var _defineProperty = require("/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/node_modules/@babel/runtime/helpers/objectSpread");

var _toConsumableArray = require("/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  visibility: ", ";\n  height: ", ";\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: ", ";\n  flex-wrap: wrap;\n  margin: 5px 0px;\n\n  &.radioTermWrapper {\n    justify-content: flex-start;\n    margin: 5px 0px 5px 30px;\n  }\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  &.inline-fields {\n    @media (min-width: ", "em) {\n      width: 50%;\n      display: inline-block;\n      &.first {\n        padding-right: 15px;\n      }\n    }\n  }\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.6em;\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  font-size: 1.1em;\n  font-weight: 600;\n  width: 100%;\n  text-align: center;\n  margin-top: 1px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-top: 5px;\n  margin-right: 5px;\n  align-self: flex-end;\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 1px 5px rgba(35, 34, 33, 0.47);\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n\n  &.active {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 1.3em;\n  padding-left: 18px;\n  text-align: right;\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n  font-size: 3.2em;\n  padding-right: 18px;\n  font-weight: 600;\n  text-align: left;\n  color: ", ";\n"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  padding: 5px;\n  min-width: 120px;\n  max-width: 120px;\n\n  @media (min-width: ", "em) {\n    min-width: 120px;\n    max-width: 120px;\n  }\n\n  @media (max-width: ", "em) {\n    max-width: 120px;\n    min-width: 120px;\n  }\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background: ", ";\n  color: ", ";\n  font-size: 1.1em;\n  font-weight: 600;\n  width: 100%;\n  text-align: center;\n  margin-top: 1px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-top: 5px;\n  margin-right: 5px;\n  align-self: flex-end;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 1px 5px rgba(35, 34, 33, 0.47);\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n\n  &.active {\n    box-shadow: inset 0 0 0 1px ", ";\n  }\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  margin: 5px;\n  min-width: 120px;\n  max-width: 120px;\n\n  @media (min-width: ", "em) {\n    min-width: 120px;\n    max-width: 120px;\n  }\n\n  @media (max-width: ", "em) {\n    max-width: 100px;\n    min-width: 100px;\n  }\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ", ";\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  align-items: flex-start;\n\n  & > * {\n    width: 100%;\n  }\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  > a {\n    padding: 20px;\n    font-size: 85%;\n    @media (max-width: ", "em) {\n      font-size: 75%;\n      padding: 20px;\n    }\n    text-decoration: underline;\n    color: ", ";\n    :hover {\n      cursor: pointer;\n      color: ", ";\n    }\n    &.selected {\n      cursor: pointer;\n      color: ", ";\n    }\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-weight: bold;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  color: #fff;\n  border: none;\n  border-radius: ", ";\n  border-bottom-width: ", ";\n  border-bottom-style: solid;\n  border-bottom-color: ", ";\n  :hover {\n    cursor: pointer;\n    color: #fff;\n    border-bottom-color: ", ";\n  }\n  &.selected {\n    background-color: ", ";\n    color: #fff;\n    border-bottom-color: ", ";\n  }\n  font-size: 70%;\n  letter-spacing: -0.5px;\n  padding: 10px 5px;\n  @media (min-width: ", "em) {\n    font-size: 95%;\n    padding: 10px;\n  }\n\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  margin: 15px auto;\n  display: grid;\n  grid-gap: 10px;\n  grid-template-columns: repeat(4, 23%);\n  grid-template-rows: repeat(3, 33%);\n  grid-auto-flow: row;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  max-width: 500px;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  width: 40px;\n  display: inline;\n  text-align: center;\n  margin: 5px;\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  > div {\n    overflow: hidden;\n    > div {\n      float: left;\n      width: 25%;\n      box-sizing: border-box;\n      background-color: ", ";\n      color: ", ";\n      padding: 10px;\n      cursor: pointer;\n      text-align: center;\n      border: 1px solid ", ";\n      &.selected {\n        background-color: ", ";\n        color: ", ";\n      }\n\n      span {\n        margin: auto;\n        font-size: 15px;\n      }\n    }\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  span {\n    font-size: 22px;\n    color: ", ";\n    text-align: center;\n    width: 100%;\n    display: block;\n  }\n\n  .controls {\n    max-height: 50px;\n    margin-top: 15px;\n    display: flex;\n\n    .icon {\n      cursor: pointer;\n\n      &.disabled {\n        cursor: default;\n        opacity: 0.3;\n      }\n    }\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  max-width: 300px;\n  max-height: 300px;\n  float: left;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  left: 0;\n  top: ", "px;\n  flex-flow: column wrap;\n  justify-content: space-around;\n  z-index: 1000;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #ccc;\n  cursor: default;\n  :hover,\n  focus {\n    pointer: cursor;\n    outline: none;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-size: 1em;\n  :hover,\n  :focus {\n    background: #eee;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  z-index: 100;\n  max-height: ", ";\n  overflow: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  line-height: 1.75;\n  text-align: left;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  align-items: flex-start;\n  margin-right: 20px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-size: 1em;\n  :hover,\n  :focus {\n    background: #eee;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  z-index: 100;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  font-size: 1em;\n\n  :hover,\n  :focus {\n    background: #eee;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  top: ", ";\n  z-index: 100;\n  max-height: ", ";\n  overflow: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 8px 5px;\n  font-family: Museo;\n  color: ", ";\n  font-size: 16px;\n  border: none;\n  border-bottom: 1px solid\n    ", ";\n  display: block;\n  width: 100%;\n  ", ";\n  ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n  opacity: 0.5;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &:focus {\n    z-index: 2;\n    outline: none;\n    box-shadow: inset 0 0 2px rgba(67, 90, 111, 0.18), inset 0 0 0 1px #579ad900,\n      0 0 0 3px rgba(16, 112, 202, 0.07);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('formik'), require('styled-components'), require('@rtm-ui/layout'), require('@rtm-ui/typography'), require('@rtm-ui/button'), require('@rtm-ui/theme'), require('react-places-autocomplete'), require('@rtm-ui/icon'), require('react-text-mask'), require('text-mask-addons'), require('react-stripe-elements'), require('yup'), require('xstate'), require('@xstate/react')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'formik', 'styled-components', '@rtm-ui/layout', '@rtm-ui/typography', '@rtm-ui/button', '@rtm-ui/theme', 'react-places-autocomplete', '@rtm-ui/icon', 'react-text-mask', 'text-mask-addons', 'react-stripe-elements', 'yup', 'xstate', '@xstate/react'], factory) : (global = global || self, factory(global.form = {}, global.React, global.PropTypes, global.Formik, global.styled, global.RtmUiLayout, global.RtmUiTypography, global.RtmUiButton, global.RtmUiTheme, global.ReactPlacesAutocomplete, global.RtmUiIcon, global.ReactTextMask, global.TextMaskAddons, global.ReactStripeElements, global.Yup, global.Xstate, global.XstateReact));
})(this, function (exports, React, PropTypes, formik, styled, layout, typography, button, theme, PlacesAutocomplete, _icon, MaskedInput, textMaskAddons, reactStripeElements, Yup, xstate, react) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  var styled__default = 'default' in styled ? styled['default'] : styled;
  var PlacesAutocomplete__default = 'default' in PlacesAutocomplete ? PlacesAutocomplete['default'] : PlacesAutocomplete;
  MaskedInput = MaskedInput && Object.prototype.hasOwnProperty.call(MaskedInput, 'default') ? MaskedInput['default'] : MaskedInput;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var focusStyle = styled.css(_templateObject());
  var disabledStyle = styled.css(_templateObject2());
  var inputStyle = styled.css(_templateObject3(), function (props) {
    return "".concat(theme.getColor('text', props.theme));
  }, function (props) {
    return "".concat(theme.getColor(props.showErrorColor ? 'error' : 'normal', props.theme));
  }, function (props) {
    return props.disabled && disabledStyle;
  }, focusStyle, function (props) {
    return "".concat(theme.getColor('normal', props.theme));
  });
  var Input = styled__default(function (_ref) {
    var showErrorColor = _ref.showErrorColor,
        error = _ref.error,
        rest = _objectWithoutProperties(_ref, ["showErrorColor", "error"]);

    return (
      /*#__PURE__*/
      React__default.createElement("input", rest)
    );
  })(_templateObject4(), inputStyle);

  var TextField = function TextField(_ref2) {
    var _config = _ref2.config,
        _fieldUtils = _ref2.fieldUtils,
        props = _objectWithoutProperties(_ref2, ["config", "fieldUtils"]);

    return (
      /*#__PURE__*/
      React__default.createElement(Input, props)
    );
  };

  TextField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };

  function useDebounce(value, delay) {
    var _React$useState = React.useState(value),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        debouncedValue = _React$useState2[0],
        setDebouncedValue = _React$useState2[1];

    React.useEffect(function () {
      var handler = setTimeout(function () {
        setDebouncedValue(value);
      }, delay);
      return function () {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return debouncedValue;
  }

  function useOnClickOutside(ref, handler) {
    React.useEffect(function () {
      var listener = function listener(event) {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        handler(event);
      };

      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      return function () {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    }, []); // Empty array ensures that effect is only run on mount and unmount
  }

  var ResultsContainer = styled__default(layout.Card)(_templateObject5(), function (_ref3) {
    var distanceFromTop = _ref3.distanceFromTop;
    return "".concat(distanceFromTop, "px");
  }, function (_ref4) {
    var scrollable = _ref4.scrollable;
    return scrollable ? '204px' : 'none';
  }, function (_ref5) {
    var scrollable = _ref5.scrollable;
    return scrollable ? 'auto' : 'none';
  });
  var ResultItem = styled__default(button.Button)(_templateObject6());

  var AutocompleteField = function AutocompleteField(_ref6) {
    var onWaiting = _ref6.onWaiting,
        _onFocus = _ref6.onFocus,
        onBlur = _ref6.onBlur,
        fieldUtils = _ref6.fieldUtils,
        config = _ref6.config,
        inputProps = _objectWithoutProperties(_ref6, ["onWaiting", "onFocus", "onBlur", "fieldUtils", "config"]);

    var resultsRef = React__default.useRef();
    var inputRef = React__default.useRef();

    var _React__default$useSt = React__default.useState([]),
        _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
        results = _React__default$useSt2[0],
        setResults = _React__default$useSt2[1];

    var _React__default$useSt3 = React__default.useState(false),
        _React__default$useSt4 = _slicedToArray(_React__default$useSt3, 2),
        hasSelected = _React__default$useSt4[0],
        setHasSelected = _React__default$useSt4[1];

    var _React__default$useSt5 = React__default.useState(false),
        _React__default$useSt6 = _slicedToArray(_React__default$useSt5, 2),
        isModalOpen = _React__default$useSt6[0],
        setModalOpen = _React__default$useSt6[1];

    var _React__default$useSt7 = React__default.useState(),
        _React__default$useSt8 = _slicedToArray(_React__default$useSt7, 2),
        resultsPosition = _React__default$useSt8[0],
        setResultsPosition = _React__default$useSt8[1];

    useOnClickOutside(resultsRef, function () {
      return setModalOpen(false);
    });
    var debouncedSearchTerm = useDebounce(inputProps.value, 500);

    var _React__default$useSt9 = React__default.useState(false),
        _React__default$useSt10 = _slicedToArray(_React__default$useSt9, 2),
        hasInteracted = _React__default$useSt10[0],
        setHasInteracted = _React__default$useSt10[1];

    React__default.useEffect(function () {
      if (debouncedSearchTerm) {
        !hasSelected && onWaiting('Searching pending...');
        config.searchFunction(debouncedSearchTerm).then(function (results) {
          results.length > 0 ? isModalOpen ? onWaiting("".concat(results.length, " results")) : onWaiting("") : (onWaiting(""), config.onEmptyResult());
          setResults(results);
        });
      } else {
        onWaiting('');
        setResults([]);
      }
    }, [debouncedSearchTerm]);
    React__default.useEffect(function () {
      if (inputProps.value && !hasSelected && hasInteracted) {
        // onWaiting('Search pending');
        setModalOpen(true);
      } else {
        setModalOpen(false);
      }
    }, [inputProps.value]);
    React__default.useEffect(function () {
      if (inputRef.current) {
        var position = inputRef.current.getBoundingClientRect();

        if (position) {
          setResultsPosition(position.height + 20);
        }
      }
    }, [inputRef]);
    return (
      /*#__PURE__*/
      React__default.createElement("div", {
        style: {
          position: 'relative'
        }
      },
      /*#__PURE__*/
      React__default.createElement("div", {
        ref: inputRef
      },
      /*#__PURE__*/
      React__default.createElement(TextField, _extends({}, inputProps, {
        "aria-haspopup": "listbox",
        onFocus: function onFocus(e) {
          setModalOpen(true);
          setHasInteracted(true);
          typeof _onFocus === 'function' && _onFocus(e);
        },
        onBlur: onBlur,
        onChange: function onChange(e) {
          setHasSelected(false);
          setHasInteracted(true);
          inputProps.onChange(e);
        }
      }))), isModalOpen &&
      /*#__PURE__*/
      React__default.createElement("div", {
        ref: resultsRef
      },
      /*#__PURE__*/
      React__default.createElement(ResultsContainer, {
        distanceFromTop: resultsPosition,
        scrollable: config.scrollable
      }, results.map(function (result, index) {
        return (
          /*#__PURE__*/
          React__default.createElement(typography.Label, {
            htmlFor: "result-".concat(inputProps.name, "-").concat(index),
            key: result.label
          },
          /*#__PURE__*/
          React__default.createElement(ResultItem, {
            "aria-selected": result.label === inputProps.value,
            asWrapper: true,
            id: "result-".concat(inputProps.name, "-").concat(index),
            type: "button",
            block: true,
            style: {
              width: '100%'
            },
            onClick: function onClick() {
              setHasSelected(true);
              setModalOpen(false);
              onWaiting('');
              config.onDidSelect && config.onDidSelect(inputProps.name, result.label, result);
              fieldUtils.setFieldValue(inputProps.name, result.label);
              onBlur(); // FIXME
            }
          },
          /*#__PURE__*/
          React__default.createElement(typography.Header, {
            tag: "h6",
            align: "left",
            weight: "thin",
            p: 15
          }, result.label)))
        );
      }))))
    );
  };

  AutocompleteField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  var ResultsContainer$1 = styled__default(layout.Card)(_templateObject7());
  var ResultItem$1 = styled__default(button.Button)(_templateObject8());
  /**
   * break down into address component
   * These much info is enough for now
   */

  var componentForm = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
  };

  var parseAddress = function parseAddress(formatted_address, _ref7) {
    var address_components = _ref7.address_components;

    /**
     * Keep this log, which is used for spying on test
     */
    console.log("parsing ".concat(formatted_address));
    var returnObj = {
      formatted_address: formatted_address
    };
    address_components.map(function (component) {
      var addressTypes = component.types[0];

      if (componentForm[addressTypes]) {
        returnObj[addressTypes] = component[componentForm[addressTypes]];
      }
    });
    return returnObj;
  };

  var GoogleAddressAutocompleteField = function GoogleAddressAutocompleteField(_ref8) {
    var onWaiting = _ref8.onWaiting,
        _onFocus2 = _ref8.onFocus,
        onBlur = _ref8.onBlur,
        fieldUtils = _ref8.fieldUtils,
        config = _ref8.config,
        onChange = _ref8.onChange,
        inputProps = _objectWithoutProperties(_ref8, ["onWaiting", "onFocus", "onBlur", "fieldUtils", "config", "onChange"]);

    // destructured onChange as the PlacesAutocomplete has it's own onChange implementation and would override
    var resultsRef = React__default.useRef();
    var inputRef = React__default.useRef();

    var _React__default$useSt11 = React__default.useState(false),
        _React__default$useSt12 = _slicedToArray(_React__default$useSt11, 2),
        hasSelected = _React__default$useSt12[0],
        setHasSelected = _React__default$useSt12[1];

    var _React__default$useSt13 = React__default.useState(false),
        _React__default$useSt14 = _slicedToArray(_React__default$useSt13, 2),
        isModalOpen = _React__default$useSt14[0],
        setModalOpen = _React__default$useSt14[1]; // const [resultsPosition, setResultsPosition] = React.useState();


    useOnClickOutside(resultsRef, function () {
      return setModalOpen(false);
    });

    var _React__default$useSt15 = React__default.useState(false),
        _React__default$useSt16 = _slicedToArray(_React__default$useSt15, 2),
        hasInteracted = _React__default$useSt16[0],
        setHasInteracted = _React__default$useSt16[1];

    var _React__default$useSt17 = React__default.useState(inputProps.value || ''),
        _React__default$useSt18 = _slicedToArray(_React__default$useSt17, 2),
        address = _React__default$useSt18[0],
        setAddress = _React__default$useSt18[1];

    var _React__default$useSt19 = React__default.useState('Start typing address'),
        _React__default$useSt20 = _slicedToArray(_React__default$useSt19, 2),
        suggestionHint = _React__default$useSt20[0],
        setSuggestionHint = _React__default$useSt20[1];

    React__default.useEffect(function () {
      if (address && !hasSelected && hasInteracted) {
        setModalOpen(true);
      } else {
        setModalOpen(false);
      }
    }, [address]); // input element onchange handler

    var handleChange = function handleChange(addr) {
      if (addr) {
        if (addr.length < 6) {
          setSuggestionHint('Need more characters');
        }
      } else {
        setSuggestionHint('Start typing address');
      }

      setHasInteracted(true);
      setHasSelected(false);
      setAddress(addr);
    };

    var handleSelect = function handleSelect(address, placeId) {
      setHasSelected(true);
      setModalOpen(false);
      onWaiting('');
      setSuggestionHint('');
      setAddress(address);
      fieldUtils.setFieldValue(inputProps.name, address);
      placeId && config.onDidSelect && PlacesAutocomplete.geocodeByPlaceId(placeId).then(function (result) {
        var _result = _slicedToArray(result, 1),
            address_components = _result[0];

        config.onDidSelect(parseAddress(address, address_components));
      }).catch(function (error) {
        return console.error('Error', error);
      });
    };

    var onError = function onError(status, clearSuggestions) {
      setSuggestionHint('No matches');
      clearSuggestions();
      config.onEmptyResult && config.onEmptyResult(status);
    };

    return (
      /*#__PURE__*/
      React__default.createElement(PlacesAutocomplete__default, {
        value: address,
        onChange: handleChange,
        onSelect: handleSelect,
        searchOptions: config.searchOptions,
        onError: onError,
        highlightFirstSuggestion: true,
        debounce: 500,
        shouldFetchSuggestions: config.minInputLength ? address.length > config.minInputLength : true
      }, function (_ref9) {
        var getInputProps = _ref9.getInputProps,
            suggestions = _ref9.suggestions,
            getSuggestionItemProps = _ref9.getSuggestionItemProps,
            loading = _ref9.loading;
        loading && setSuggestionHint('Searching');
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            style: {
              position: 'relative'
            }
          },
          /*#__PURE__*/
          React__default.createElement("div", {
            ref: inputRef
          },
          /*#__PURE__*/
          React__default.createElement(TextField, _extends({}, inputProps, getInputProps(), {
            "aria-haspopup": "listbox",
            onFocus: function onFocus(e) {
              setModalOpen(true);
              setHasInteracted(true);
              typeof _onFocus2 === 'function' && _onFocus2(e);
            },
            onBlur: onBlur
          }))), isModalOpen &&
          /*#__PURE__*/
          React__default.createElement("div", {
            ref: resultsRef
          },
          /*#__PURE__*/
          React__default.createElement(ResultsContainer$1, null, suggestions.length > 0 ? suggestions.map(function (result, index) {
            return (
              /*#__PURE__*/
              React__default.createElement(typography.Label, _extends({}, getSuggestionItemProps(result), {
                htmlFor: "result-".concat(inputProps.name, "-").concat(index),
                key: result.description
              }),
              /*#__PURE__*/
              React__default.createElement(ResultItem$1, {
                "aria-selected": result.description === inputProps.value,
                asWrapper: true,
                id: "result-".concat(inputProps.name, "-").concat(index),
                type: "button",
                block: true,
                style: result.active ? {
                  width: '100%',
                  background: '#eee'
                } : {
                  width: '100%'
                }
              },
              /*#__PURE__*/
              React__default.createElement(typography.Header, {
                tag: "h6",
                align: "left",
                weight: "thin",
                p: 15
              }, result.description)))
            );
          }) : suggestionHint &&
          /*#__PURE__*/
          React__default.createElement(typography.Label, {
            htmlFor: "no-result",
            key: "no-result"
          },
          /*#__PURE__*/
          React__default.createElement(typography.Header, {
            "data-testid": "no-result",
            tag: "h6",
            align: "left",
            weight: "thin",
            p: 15
          }, suggestionHint)))))
        );
      })
    );
  };

  GoogleAddressAutocompleteField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    config: PropTypes.shape({
      searchOptions: PropTypes.shape({
        componentRestrictions: PropTypes.shape({}),
        types: PropTypes.array
      }),
      onDidSelect: PropTypes.func,
      onEmptyResult: PropTypes.func,
      minInputLength: PropTypes.number
    })
  };
  var StyledButton = styled__default(button.Button)(_templateObject9(), focusStyle);
  var StyledLabel = styled__default(typography.Label)(_templateObject10());

  var BaseRadioCheckboxField = function BaseRadioCheckboxField(_ref10) {
    var options = _ref10.options,
        name = _ref10.name,
        rest = _objectWithoutProperties(_ref10, ["options", "name"]);

    var _React__default$useSt21 = React__default.useState(false),
        _React__default$useSt22 = _slicedToArray(_React__default$useSt21, 2),
        checkboxValue = _React__default$useSt22[0],
        setCheckboxValue = _React__default$useSt22[1];

    var isSingle = options.length === 1;
    return (
      /*#__PURE__*/
      React__default.createElement(React__default.Fragment, null,
      /*#__PURE__*/
      React__default.createElement(button.ButtonGroup, {
        py: 2
      }, options.map(function (option) {
        return (
          /*#__PURE__*/
          React__default.createElement(StyledButton, _extends({}, rest, {
            key: option.value,
            name: name,
            value: option.value,
            "aria-labelledby": "".concat(name, "_").concat(option.value, "-label"),
            role: "radio",
            id: "".concat(name, "_").concat(option.value),
            "data-testid": "".concat(rest.type, "-").concat(name, "_").concat(option.value),
            asWrapper: true,
            type: "button",
            onClick: function onClick() {
              if (isSingle) {
                setCheckboxValue(!checkboxValue);
                document.getElementById("input-".concat(name)).value = !checkboxValue;
              }

              rest.onClick(name, option.value, rest.value);
            }
          }), rest.icon({
            itemValue: option.value,
            fieldValue: rest.value
          }),
          /*#__PURE__*/
          React__default.createElement(StyledLabel, {
            id: "".concat(name, "_").concat(option.value, "-label"),
            htmlFor: "".concat(name, "_").concat(option.value),
            pl: 10,
            pr: 20,
            ml: '5px'
          }, option.label))
        );
      })), isSingle &&
      /*#__PURE__*/
      React__default.createElement("input", {
        type: "hidden",
        name: name,
        id: "input-".concat(name),
        value: checkboxValue
      }))
    );
  };

  BaseRadioCheckboxField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  var IconContainer = styled__default(layout.Box)(_templateObject11());
  var AbsoluteIcon = styled__default(layout.Box)(_templateObject12());

  var CheckboxField = function CheckboxField(_ref11) {
    var _config = _ref11.config,
        setFieldValue = _ref11.fieldUtils.setFieldValue,
        props = _objectWithoutProperties(_ref11, ["config", "fieldUtils"]);

    var fillColorName = function fillColorName(itemValue, fieldValue) {
      return fieldValue.includes(itemValue) ? 'primary' : 'slightlyDarker';
    };

    var isSingle = props.options.length === 1;
    return (
      /*#__PURE__*/
      React__default.createElement(BaseRadioCheckboxField, _extends({}, props, {
        onClick: function onClick(name, value, fieldValues) {
          isSingle ? setFieldValue(name, fieldValues === '' ? value : '') : setFieldValue(name, fieldValues.includes(value) ? fieldValues.filter(function (fieldValue) {
            return fieldValue !== value;
          }) : [].concat(_toConsumableArray(fieldValues), [value]));
        },
        icon: function icon(_ref12) {
          var itemValue = _ref12.itemValue,
              fieldValue = _ref12.fieldValue;
          return (
            /*#__PURE__*/
            React__default.createElement(IconContainer, null,
            /*#__PURE__*/
            React__default.createElement(AbsoluteIcon, null,
            /*#__PURE__*/
            React__default.createElement(_icon.Icon, {
              fill: fillColorName(itemValue, fieldValue),
              size: 22,
              glyph: "box"
            })),
            /*#__PURE__*/
            React__default.createElement(_icon.Icon, {
              fill: fillColorName(itemValue, fieldValue),
              size: 22,
              glyph: fieldValue.includes(itemValue) ? 'check' : 'void'
            }))
          );
        }
      }))
    );
  };

  CheckboxField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  var ResultsContainer$2 = styled__default(layout.Card)(_templateObject13(), function (_ref13) {
    var scrollable = _ref13.scrollable;
    return scrollable ? '204px' : 'none';
  }, function (_ref14) {
    var scrollable = _ref14.scrollable;
    return scrollable ? 'auto' : 'none';
  });
  var ResultItem$2 = styled__default(button.Button)(_templateObject14());
  var DropdownTextBox = styled__default(TextField)(_templateObject15());

  var DropdownField = function DropdownField(_ref15) {
    var onWaiting = _ref15.onWaiting,
        fieldUtils = _ref15.fieldUtils,
        config = _ref15.config,
        inputProps = _objectWithoutProperties(_ref15, ["onWaiting", "fieldUtils", "config"]);

    var dropdownRef = React__default.useRef();
    useOnClickOutside(dropdownRef, function () {
      return setModalOpen(false);
    });

    var _React__default$useSt23 = React__default.useState(false),
        _React__default$useSt24 = _slicedToArray(_React__default$useSt23, 2),
        isModalOpen = _React__default$useSt24[0],
        setModalOpen = _React__default$useSt24[1];

    var _React__default$useSt25 = React__default.useState({
      label: null,
      value: null
    }),
        _React__default$useSt26 = _slicedToArray(_React__default$useSt25, 2),
        currentElement = _React__default$useSt26[0],
        setCurrentElement = _React__default$useSt26[1]; // Pass these values straight through with no submission


    React__default.useEffect(function () {
      if (typeof inputProps.onDropdownChange == 'function') {
        inputProps.onDropdownChange(currentElement.value);
      }
    }, [currentElement]);
    return (
      /*#__PURE__*/
      React__default.createElement("div", {
        ref: dropdownRef,
        style: {
          position: 'relative'
        }
      },
      /*#__PURE__*/
      React__default.createElement("div", null,
      /*#__PURE__*/
      React__default.createElement(DropdownTextBox, _extends({}, inputProps, {
        autoComplete: "off",
        "aria-haspopup": "listbox",
        onFocus: function onFocus() {
          setModalOpen(true);
        },
        onClick: function onClick() {
          if (inputProps.value == '') {
            if (isModalOpen == false) {
              setModalOpen(true);
            }
          }
        },
        value: currentElement.label || inputProps.options.map(function (option) {
          return option.value === inputProps.value ? option.label : null;
        }).filter(function (e) {
          return !!e;
        })
      })),
      /*#__PURE__*/
      React__default.createElement(layout.Box, {
        "data-testid": "arrow-box",
        onClick: function onClick() {
          return setModalOpen(!isModalOpen);
        },
        style: {
          position: 'relative',
          width: 'auto',
          float: 'right',
          top: '-35px'
        }
      },
      /*#__PURE__*/
      React__default.createElement(_icon.Icon, {
        rotate: isModalOpen ? 90 : 270,
        glyph: "view-back"
      }))), isModalOpen &&
      /*#__PURE__*/
      React__default.createElement("div", null,
      /*#__PURE__*/
      React__default.createElement(ResultsContainer$2, {
        "data-testid": "results-container",
        scrollable: config.scrollable
      }, inputProps.options.map(function (element, index) {
        return (
          /*#__PURE__*/
          React__default.createElement(typography.Label, {
            htmlFor: "element-".concat(inputProps.name, "-").concat(index),
            key: element.label
          },
          /*#__PURE__*/
          React__default.createElement(ResultItem$2, {
            "aria-selected": element.label === inputProps.value,
            asWrapper: true,
            id: "element-".concat(inputProps.name, "-").concat(index),
            type: "button",
            block: true,
            style: {
              width: '100%'
            },
            onClick: function onClick() {
              setModalOpen(false);
              onWaiting('');
              fieldUtils.setFieldValue(inputProps.name, element.value);
              setCurrentElement(_objectSpread({}, element));
            }
          },
          /*#__PURE__*/
          React__default.createElement(typography.Header, {
            tag: "h6",
            align: "left",
            weight: "thin",
            p: 15
          }, element.label)))
        );
      }))))
    );
  };

  DropdownField.propTypes = {
    config: PropTypes.shape({
      component: PropTypes.string,
      scrollable: PropTypes.bool
    }),
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    }))
  };

  var HiddenField = function HiddenField(_ref16) {
    var _fieldUtils = _ref16.fieldUtils,
        error = _ref16.error,
        inputProps = _objectWithoutProperties(_ref16, ["fieldUtils", "error"]);

    return (
      /*#__PURE__*/
      React__default.createElement("input", _extends({}, inputProps, {
        type: "hidden"
      }))
    );
  };

  var BoxWrapper = styled__default(layout.Box)(_templateObject16(), function (props) {
    return props.offsetHeight;
  });
  var Wrapper = styled__default(layout.Card)(_templateObject17(), function (props) {
    return theme.getColor('secondary', props.theme);
  });
  var WrapperContent = styled__default.div(_templateObject18(), function (props) {
    return theme.getColor('primary', props.theme);
  });
  var MonthDropdownBox = styled__default.div(_templateObject19(), function (props) {
    return theme.getColor('primary', props.theme);
  }, function (props) {
    return theme.getColor('light', props.theme);
  }, function (props) {
    return theme.getColor('light', props.theme);
  }, function (props) {
    return theme.getColor('accent', props.theme);
  }, function (props) {
    return theme.getColor('light', props.theme);
  });

  var MonthSelector = function MonthSelector(_ref17) {
    var minYear = _ref17.minYear,
        maxYear = _ref17.maxYear,
        selectedYear = _ref17.selectedYear,
        selectedMonth = _ref17.selectedMonth,
        onChangeMonth = _ref17.onChangeMonth,
        onChangeYear = _ref17.onChangeYear,
        onChange = _ref17.onChange,
        showYear = _ref17.showYear,
        offsetHeight = _ref17.offsetHeight;

    function handleOnClickLeftArrow() {
      if (selectedYear <= minYear) {
        return;
      }

      return onChangeYear(selectedYear - 1);
    }

    function handleOnClickRightArrow() {
      if (selectedYear >= maxYear) {
        return;
      }

      return onChangeYear(selectedYear + 1);
    }

    function renderMonth() {
      var monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return monthArr.map(function (type, i) {
        return (
          /*#__PURE__*/
          React__default.createElement("div", {
            key: i,
            className: selectedMonth === type ? 'selected' : '',
            role: "button",
            tabIndex: "0",
            onClick: function onClick() {
              onChangeMonth(type);
              onChange(type + ', ' + selectedYear);
            }
          },
          /*#__PURE__*/
          React__default.createElement("span", null, " ", type))
        );
      });
    }

    function renderLeftArrowButton() {
      if (selectedYear === minYear) {
        return (
          /*#__PURE__*/
          React__default.createElement(_icon.Icon, {
            glyph: "view-back",
            disabled: true
          })
        );
      }

      return (
        /*#__PURE__*/
        React__default.createElement("div", {
          onClick: handleOnClickLeftArrow,
          className: "icon"
        },
        /*#__PURE__*/
        React__default.createElement(_icon.Icon, {
          size: 35,
          fill: "primary",
          glyph: "view-back"
        }))
      );
    }

    function renderRightArrowButton() {
      if (selectedYear === maxYear) {
        return (
          /*#__PURE__*/
          React__default.createElement(_icon.Icon, {
            glyph: "view-forward",
            disabled: true
          })
        );
      }

      return (
        /*#__PURE__*/
        React__default.createElement("div", {
          onClick: handleOnClickRightArrow,
          className: "icon"
        },
        /*#__PURE__*/
        React__default.createElement(_icon.Icon, {
          size: 35,
          fill: "primary",
          glyph: "view-forward"
        }))
      );
    }

    return (
      /*#__PURE__*/
      React__default.createElement(BoxWrapper, {
        offsetHeight: offsetHeight
      },
      /*#__PURE__*/
      React__default.createElement(Wrapper, null, showYear &&
      /*#__PURE__*/
      React__default.createElement(WrapperContent, null,
      /*#__PURE__*/
      React__default.createElement("div", {
        className: "controls"
      },
      /*#__PURE__*/
      React__default.createElement("span", null, renderLeftArrowButton()),
      /*#__PURE__*/
      React__default.createElement("span", null, selectedYear),
      /*#__PURE__*/
      React__default.createElement("span", null, " ", renderRightArrowButton()))),
      /*#__PURE__*/
      React__default.createElement(MonthDropdownBox, null,
      /*#__PURE__*/
      React__default.createElement("div", null, renderMonth()))))
    );
  };

  MonthSelector.propTypes = {
    selectedYear: PropTypes.number,
    selectedMonth: PropTypes.string,
    minYear: PropTypes.number,
    maxYear: PropTypes.number,
    showYear: PropTypes.bool,
    onChangeYear: PropTypes.func,
    onChangeMonth: PropTypes.func
  };
  var monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var shortMonthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  var getCurrentMonth = function getCurrentMonth(showYear) {
    var d = new Date();

    if (showYear) {
      return shortMonthArray[d.getMonth()];
    } else {
      return monthArray[d.getMonth()];
    }
  };

  var Wrapper$1 = styled__default.div(_templateObject20());

  var MonthField = function MonthField(_ref18) {
    var _onFocus3 = _ref18.onFocus,
        onBlur = _ref18.onBlur,
        onKeyDown = _ref18.onKeyDown,
        fieldUtils = _ref18.fieldUtils,
        defaultValue = _ref18.defaultValue,
        inputProps = _objectWithoutProperties(_ref18, ["onFocus", "onBlur", "onKeyDown", "fieldUtils", "defaultValue"]);

    var config = inputProps.config || {};
    var resultsRef = React__default.useRef();
    var anchorRef = React__default.useRef();

    var _React__default$useSt27 = React__default.useState(getCurrentMonth(config.showYear)),
        _React__default$useSt28 = _slicedToArray(_React__default$useSt27, 2),
        month = _React__default$useSt28[0],
        setMonth = _React__default$useSt28[1];

    var currentYear = new Date().getFullYear();

    var _React__default$useSt29 = React__default.useState(currentYear),
        _React__default$useSt30 = _slicedToArray(_React__default$useSt29, 2),
        year = _React__default$useSt30[0],
        setYear = _React__default$useSt30[1];

    var _React__default$useSt31 = React__default.useState(false),
        _React__default$useSt32 = _slicedToArray(_React__default$useSt31, 2),
        monthPickerVisible = _React__default$useSt32[0],
        setMonthPickerVisible = _React__default$useSt32[1];

    var inputRef = React__default.useRef();
    useOnClickOutside(resultsRef, function () {
      return setMonthPickerVisible(false);
    });

    var _React__default$useSt33 = React__default.useState(false),
        _React__default$useSt34 = _slicedToArray(_React__default$useSt33, 2),
        hasSelected = _React__default$useSt34[0],
        setHasSelected = _React__default$useSt34[1];

    var _React__default$useSt35 = React__default.useState(0),
        _React__default$useSt36 = _slicedToArray(_React__default$useSt35, 2),
        height = _React__default$useSt36[0],
        setHeight = _React__default$useSt36[1];

    React__default.useEffect(function () {
      if (anchorRef.current) {
        var position = anchorRef.current.getBoundingClientRect();
        setHeight(position.height);
      }
    }, [anchorRef.current]);
    React__default.useEffect(function () {
      if (defaultValue) {
        fieldUtils.setFieldValue(inputProps.name, defaultValue);
        var defaultMonth = defaultValue.split(', ')[0];
        setMonth(defaultMonth);
        var defaultYear = defaultValue.split(', ')[1] || currentYear;
        setYear(parseInt(defaultYear));
      }
    }, [defaultValue]);
    React__default.useEffect(function () {
      if (inputProps.value && !hasSelected & !defaultValue) {
        setMonthPickerVisible(true);
      } else {
        setMonthPickerVisible(false);
      }
    }, [inputProps.value, 500]);
    React__default.useEffect(function () {
      if (inputRef.current) {
        return inputRef.current.value;
      }
    }, [inputRef]);
    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper$1, {
        ref: inputRef
      },
      /*#__PURE__*/
      React__default.createElement("div", {
        ref: anchorRef
      },
      /*#__PURE__*/
      React__default.createElement(TextField, _extends({}, inputProps, {
        onFocus: function onFocus() {
          setMonthPickerVisible(true);
          setHasSelected(true);

          _onFocus3();
        },
        onKeyDown: function onKeyDown(e) {
          if (inputProps.value += e.key) {
            setMonthPickerVisible(false);
            setHasSelected(true);
          }

          if (e.which === 8) {
            // Shows month picker if Backspace is pressed.
            setMonthPickerVisible(true);
            setHasSelected(false);
          }
        },
        value: inputProps.value,
        onBlur: onBlur,
        autoComplete: "off",
        onChange: function onChange(e) {
          inputProps.onChange(e);
        }
      }))), monthPickerVisible &&
      /*#__PURE__*/
      React__default.createElement("div", {
        ref: resultsRef
      },
      /*#__PURE__*/
      React__default.createElement(MonthSelector, {
        offsetHeight: height,
        selectedMonth: month,
        selectedYear: year,
        minYear: 2000,
        maxYear: 2030,
        showYear: config.showYear,
        onChangeYear: setYear,
        onChangeMonth: setMonth,
        onChange: function onChange(val) {
          if (config.showYear) {
            fieldUtils.setFieldValue(inputProps.name, val);
          } else {
            var onlyMonth = val.split(', ')[0];
            var monthIndex = shortMonthArray.indexOf(onlyMonth);
            var fullMonth = monthArray[monthIndex];
            fieldUtils.setFieldValue(inputProps.name, fullMonth);
          }
        }
      })))
    );
  };

  MonthField.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  var StyledField = styled__default(TextField)(_templateObject21());

  var YearField = function YearField(_ref19) {
    var fieldUtils = _ref19.fieldUtils,
        defaultValue = _ref19.defaultValue,
        placeholder = _ref19.placeholder,
        props = _objectWithoutProperties(_ref19, ["fieldUtils", "defaultValue", "placeholder"]);

    var _React$useState3 = React.useState([]),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        year = _React$useState4[0],
        setYear = _React$useState4[1];

    var yearPlaceholder = placeholder ? placeholder.split('') : [];
    React.useEffect(function () {
      fieldUtils.setFieldValue(props.name, defaultValue);

      if (defaultValue) {
        setYear(defaultValue.split(''));
      }
    }, []);

    var handleKeyPress = function handleKeyPress(_index, e) {
      // istanbul ignore next
      var value = e.target.value; // istanbul ignore if

      if (e.key && e.key == value) {
        e.preventDefault();
        var nextSibling = e.target.nextSibling;

        if (nextSibling) {
          nextSibling.focus();
          nextSibling.select();
        }
      }
    };

    var handleChange = function handleChange(index, _ref20) {
      var target = _ref20.target;
      var value = target.value;

      if (value.length < 2 && (!isNaN(Number(value)) || value == '')) {
        var oldYear = year;
        var updatedYear = year;
        updatedYear[index] = value;
        setYear(updatedYear);
        fieldUtils.setFieldValue(props.name, "".concat(year[0]).concat(year[1]).concat(year[2]).concat(year[3]));
        var element = target;
        var nextSibling = element.nextElementSibling;

        if (value != '' && (nextSibling || oldYear[index] == value)) {
          nextSibling.focus();
          nextSibling.select();
        } else if (value == '') {
          element.focus();
          element.select();
        } else {
          nextSibling.focus();
          nextSibling.select();
        }
      } else {
        setYear(year);
        fieldUtils.setFieldValue(props.name, "".concat(year[0]).concat(year[1]).concat(year[2]).concat(year[3]));
      }
    };

    return (
      /*#__PURE__*/
      React__default.createElement(React__default.Fragment, null,
      /*#__PURE__*/
      React__default.createElement("div", null,
      /*#__PURE__*/
      React__default.createElement(StyledField, {
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        value: year[0],
        "data-testid": "y0",
        inputmode: "numeric",
        placeholder: yearPlaceholder[0],
        onChange: function onChange(e) {
          return handleChange(0, e);
        },
        onKeyPress: function onKeyPress(e) {
          return handleKeyPress(0, e);
        },
        "data-year": "".concat(year.join(''))
      }),
      /*#__PURE__*/
      React__default.createElement(StyledField, {
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        value: year[1],
        "data-testid": "y1",
        inputmode: "numeric",
        placeholder: yearPlaceholder[1],
        onChange: function onChange(e) {
          return handleChange(1, e);
        },
        onKeyPress: function onKeyPress(e) {
          return handleKeyPress(1, e);
        },
        "data-year": "".concat(year.join(''))
      }),
      /*#__PURE__*/
      React__default.createElement(StyledField, {
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        value: year[2],
        "data-testid": "y2",
        inputmode: "numeric",
        placeholder: yearPlaceholder[2],
        onChange: function onChange(e) {
          return handleChange(2, e);
        },
        onKeyPress: function onKeyPress(e) {
          return handleKeyPress(2, e);
        },
        "data-year": "".concat(year.join(''))
      }),
      /*#__PURE__*/
      React__default.createElement(StyledField, {
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        value: year[3],
        "data-testid": "y3",
        inputmode: "numeric",
        placeholder: yearPlaceholder[3],
        onChange: function onChange(e) {
          return handleChange(3, e);
        },
        onKeyPress: function onKeyPress(e) {
          return handleKeyPress(3, e);
        },
        "data-year": "".concat(year.join(''))
      }),
      /*#__PURE__*/
      React__default.createElement(TextField, _extends({}, props, {
        type: "hidden",
        name: props.name,
        value: "".concat(year.join(''))
      }))))
    );
  };

  YearField.PropTypes = {
    id: PropTypes.string,
    defaultValue: PropTypes.string
  };
  var monthArray$1 = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var shortMonthArray$1 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var Wrapper$2 = styled__default(layout.Box)(_templateObject22());
  var MonthBox = styled__default(layout.Box)(_templateObject23());
  var MonthButton = styled__default(layout.Box)(_templateObject24(), function (props) {
    return theme.getColor('primary', props.theme);
  }, function (props) {
    return props.theme.button.borderRadius;
  }, function (props) {
    return props.theme.button.bottomBorderWidth;
  }, function (props) {
    return theme.tintColor(theme.getColor('primary', props.theme), -10);
  }, function (props) {
    return theme.getColor('accent', props.theme);
  }, function (props) {
    return theme.getColor('accent', props.theme);
  }, function (props) {
    return theme.tintColor(theme.getColor('accent', props.theme), -10);
  }, function (props) {
    return props.theme.grid.sm;
  });
  var DontKnow = styled__default(layout.Box)(_templateObject25(), function (props) {
    return props.theme.grid.sm;
  }, function (props) {
    return theme.getColor('primary', props.theme);
  }, function (props) {
    return theme.getColor('accent', props.theme);
  }, function (props) {
    return theme.getColor('accent', props.theme);
  });

  var MonthButtonGroupField = function MonthButtonGroupField(_ref21) {
    var defaultValue = _ref21.defaultValue,
        onFocus = _ref21.onFocus,
        onBlur = _ref21.onBlur,
        onKeyDown = _ref21.onKeyDown,
        fieldUtils = _ref21.fieldUtils,
        inputProps = _objectWithoutProperties(_ref21, ["defaultValue", "onFocus", "onBlur", "onKeyDown", "fieldUtils"]);

    var _React__default$useSt37 = React__default.useState(null),
        _React__default$useSt38 = _slicedToArray(_React__default$useSt37, 2),
        month = _React__default$useSt38[0],
        setMonth = _React__default$useSt38[1];

    React__default.useEffect(function () {
      if (defaultValue) {
        fieldUtils.setFieldValue(inputProps.name, defaultValue);
        setMonth(defaultValue);
      }
    }, [defaultValue]);

    function onMonthSelect(value) {
      inputProps.onChange(value);
      fieldUtils.setFieldValue(inputProps.name, value);
      setMonth(value);
    }

    function renderMonth() {
      var monthArr = inputProps.useShortMonthName ? shortMonthArray$1 : monthArray$1;
      return monthArr.map(function (type, i) {
        return (
          /*#__PURE__*/
          React__default.createElement(MonthButton, {
            key: i,
            className: month === type ? 'selected' : '',
            role: "button",
            tabIndex: "0",
            onClick: function onClick() {
              onMonthSelect(type);
            }
          }, type)
        );
      });
    }

    function renderDontKnowDontHave(additionalChoices, month) {
      if (additionalChoices && additionalChoices.length > 0) {
        return (
          /*#__PURE__*/
          React__default.createElement(DontKnow, null, additionalChoices.map(function (item) {
            return (
              /*#__PURE__*/
              React__default.createElement("a", {
                key: item.value,
                className: month === item.value ? 'selected' : '',
                onClick: function onClick() {
                  onMonthSelect(item.value);
                }
              }, item.label)
            );
          }))
        );
      } else {
        return;
      }
    }

    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper$2, null,
      /*#__PURE__*/
      React__default.createElement(MonthBox, null, renderMonth()), renderDontKnowDontHave(inputProps.additionalChoices, month))
    );
  };

  MonthButtonGroupField.propTypes = {
    onChange: PropTypes.func,
    defaultValue: PropTypes.string
  };
  var maskPatterns = {
    // TODO: probably should show a nicer looking output
    phoneUS: ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    phoneAU: ['0', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    phoneIE: ['0', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    dateUS: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    dateAU: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    ssn: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    eir: [/[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/, /[a-zA-Z0-9]/]
  }; // https://github.com/text-mask/text-mask/tree/master/addons#pipes
  // Pipes allow us to add additional constraints to a pattern

  var pipes = {
    dateUS: textMaskAddons.createAutoCorrectedDatePipe('mm/dd/yyyy'),
    dateAU: textMaskAddons.createAutoCorrectedDatePipe('dd/mm/yyyy')
  };
  var StyledInput = styled__default(function (_ref22) {
    var showErrorColor = _ref22.showErrorColor,
        error = _ref22.error,
        rest = _objectWithoutProperties(_ref22, ["showErrorColor", "error"]);

    return (
      /*#__PURE__*/
      React__default.createElement(MaskedInput, rest)
    );
  })(_templateObject26(), inputStyle);

  var NumberField = function NumberField(_ref23) {
    var mask = _ref23.config.mask,
        _fieldUtils = _ref23.fieldUtils,
        _onWaiting = _ref23.onWaiting,
        inputProps = _objectWithoutProperties(_ref23, ["config", "fieldUtils", "onWaiting"]);

    return (
      /*#__PURE__*/
      React__default.createElement(StyledInput, _extends({
        mask: maskPatterns[mask],
        pipe: pipes[mask],
        guide: false
      }, inputProps))
    );
  };

  NumberField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  var StyledButton$1 = styled__default(button.Button)(_templateObject27(), focusStyle);
  var Wrapper$3 = styled__default(layout.Box)(_templateObject28(), function (props) {
    return props.justifyContent;
  });

  var BasePanelRadioCheckboxField = function BasePanelRadioCheckboxField(_ref24) {
    var options = _ref24.options,
        name = _ref24.name,
        _ref24$columns = _ref24.columns,
        columns = _ref24$columns === void 0 ? 3 : _ref24$columns,
        _ref24$justifyContent = _ref24.justifyContent,
        justifyContent = _ref24$justifyContent === void 0 ? 'flex-start' : _ref24$justifyContent,
        rest = _objectWithoutProperties(_ref24, ["options", "name", "columns", "justifyContent"]);

    var optionWidth = 100 / columns;
    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper$3, {
        py: 10,
        justifyContent: justifyContent
      }, options.map(function (option) {
        return (
          /*#__PURE__*/
          React__default.createElement(StyledButton$1, {
            optionWidth: optionWidth,
            key: option.value,
            name: name,
            value: option.value,
            "aria-labelledby": "".concat(name, "_").concat(option.value, "-label"),
            role: "radio",
            id: "".concat(name, "_").concat(option.value),
            "data-testid": "".concat(rest.type, "-").concat(name, "_").concat(option.value),
            asWrapper: true,
            type: "button",
            onClick: function onClick() {
              return rest.onClick(name, option.value, rest.value);
            }
          }, rest.children({
            option: option,
            name: name,
            fieldValue: rest.value
          }))
        );
      }))
    );
  };

  BasePanelRadioCheckboxField.propTypes = {
    autoComplete: PropTypes.string,
    icon: PropTypes.func,
    name: PropTypes.string,
    onChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  var Wrapper$4 = styled__default.div(_templateObject29(), function (props) {
    return props.theme.grid.sm;
  }, function (props) {
    return props.theme.grid.sm;
  });
  var StyledBox = styled__default(layout.Card)(_templateObject30(), function (props) {
    return theme.getColor('accent', props.theme);
  });
  var IconContainer$1 = styled__default(layout.Box)(_templateObject31());
  var StyledLabel$1 = styled__default(typography.Label)(_templateObject32(), function (props) {
    return theme.getColor(props.fillColor, props.theme);
  }, function (props) {
    return theme.getColor(props.color || 'inverseText', props.theme);
  });

  var PanelCheckField = function PanelCheckField(_ref25) {
    var config = _ref25.config,
        setFieldValue = _ref25.fieldUtils.setFieldValue,
        props = _objectWithoutProperties(_ref25, ["config", "fieldUtils"]);

    var isSingle = props.options.length === 1;
    return (
      /*#__PURE__*/
      React__default.createElement(BasePanelRadioCheckboxField, _extends({}, config, props, {
        onClick: function onClick(name, value, fieldValues) {
          isSingle ? setFieldValue(name, fieldValues === '' ? value : '') : setFieldValue(name, fieldValues.includes(value) ? fieldValues.filter(function (fieldValue) {
            return fieldValue !== value;
          }) : [].concat(_toConsumableArray(fieldValues), [value]));
        }
      }), function (_ref26) {
        var option = _ref26.option,
            name = _ref26.name,
            fieldValue = _ref26.fieldValue;
        return (
          /*#__PURE__*/
          React__default.createElement(Wrapper$4, null,
          /*#__PURE__*/
          React__default.createElement(StyledBox, {
            className: fieldValue.includes(option.value) ? 'active' : ''
          },
          /*#__PURE__*/
          React__default.createElement(IconContainer$1, null,
          /*#__PURE__*/
          React__default.createElement(_icon.Icon, {
            size: 18,
            glyph: fieldValue.includes(option.value) ? 'check' : 'void'
          })), option.icon &&
          /*#__PURE__*/
          React__default.createElement(_icon.Icon, {
            glyph: option.icon,
            size: 46,
            fill: fieldValue.includes(option.value) ? 'accent' : 'primary'
          }),
          /*#__PURE__*/
          React__default.createElement(StyledLabel$1, {
            htmlFor: "".concat(name, "_").concat(option.value),
            px: 10,
            py: 10,
            fillColor: fieldValue.includes(option.value) ? 'accent' : 'primary'
          }, option.label)))
        );
      })
    );
  };

  PanelCheckField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  var Wrapper$5 = styled__default.div(_templateObject33(), function (props) {
    return props.theme.grid.sm;
  }, function (props) {
    return props.theme.grid.sm;
  });
  var DynamicHeader = styled__default(typography.Header)(_templateObject34(), function (props) {
    return theme.getColor('accent', props.theme);
  });
  var DynamicSubHeader = styled__default(typography.Header)(_templateObject35(), function (props) {
    return theme.getColor('accent', props.theme);
  });
  var StyledBox$1 = styled__default(layout.Card)(_templateObject36(), function (props) {
    return theme.getColor('accent', props.theme);
  });
  var IconContainer$2 = styled__default(layout.Box)(_templateObject37());
  var StyledLabel$2 = styled__default(typography.Label)(_templateObject38(), function (props) {
    return theme.getColor(props.fillColor, props.theme);
  }, function (props) {
    return theme.getColor(props.color || 'inverseText', props.theme);
  });

  var PanelRadioField = function PanelRadioField(_ref27) {
    var config = _ref27.config,
        setFieldValue = _ref27.fieldUtils.setFieldValue,
        props = _objectWithoutProperties(_ref27, ["config", "fieldUtils"]);

    var fillColorName = function fillColorName(itemValue, fieldValue) {
      return fieldValue === itemValue ? 'accent' : 'primary';
    };

    return (
      /*#__PURE__*/
      React__default.createElement(BasePanelRadioCheckboxField, _extends({}, config, props, {
        onClick: function onClick(name, value) {
          return setFieldValue(name, value);
        }
      }), function (_ref28) {
        var option = _ref28.option,
            name = _ref28.name,
            fieldValue = _ref28.fieldValue;
        return (
          /*#__PURE__*/
          React__default.createElement(Wrapper$5, null,
          /*#__PURE__*/
          React__default.createElement(StyledBox$1, {
            className: fieldValue === option.value ? 'active' : ''
          },
          /*#__PURE__*/
          React__default.createElement(IconContainer$2, null,
          /*#__PURE__*/
          React__default.createElement(_icon.Icon, {
            fill: fillColorName(option.value, fieldValue),
            size: 18,
            glyph: fieldValue === option.value ? 'radio-active' : 'radio'
          })), !('icon' in option) || !option.icon ?
          /*#__PURE__*/
          // Returns text only If the icon is null
          React__default.createElement(layout.Box, null,
          /*#__PURE__*/
          React__default.createElement(DynamicHeader, null, option.header),
          /*#__PURE__*/
          React__default.createElement(DynamicSubHeader, null, option.subHeader)) : option.icon && !(option.header && option.subHeader) ?
          /*#__PURE__*/
          // Returns icon only when headers and subheaders are not present.
          React__default.createElement(_icon.Icon, {
            glyph: option.icon,
            size: 46,
            fill: fillColorName(option.value, fieldValue)
          }) : // Returns null if icons, headers and subheaders are present.
          '',
          /*#__PURE__*/
          React__default.createElement(StyledLabel$2, {
            fillColor: fillColorName(option.value, fieldValue),
            px: 10,
            py: 10,
            "data-testid": "".concat(name, "-").concat(option.value, "-label"),
            htmlFor: "".concat(name, "_").concat(option.value)
          }, option.label)))
        );
      })
    );
  };

  PanelRadioField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.string,
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };

  var RadioField = function RadioField(_ref29) {
    var _config = _ref29.config,
        setFieldValue = _ref29.fieldUtils.setFieldValue,
        props = _objectWithoutProperties(_ref29, ["config", "fieldUtils"]);

    var fillColorName = function fillColorName(itemValue, fieldValue) {
      return fieldValue === itemValue ? 'primary' : 'slightlyDarker';
    };

    return (
      /*#__PURE__*/
      React__default.createElement(BaseRadioCheckboxField, _extends({}, props, {
        onClick: function onClick(name, value) {
          return setFieldValue(name, value);
        },
        icon: function icon(_ref30) {
          var itemValue = _ref30.itemValue,
              fieldValue = _ref30.fieldValue;
          return (
            /*#__PURE__*/
            React__default.createElement(_icon.Icon, {
              fill: fillColorName(itemValue, fieldValue),
              size: 22,
              glyph: fieldValue === itemValue ? 'radio-active' : 'radio'
            })
          );
        }
      }))
    );
  };

  RadioField.propTypes = {
    autoComplete: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.string,
    id: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };
  /* istanbul ignore file */

  var cachedScripts = [];

  function useScript(src) {
    var _React$useState5 = React.useState({
      loaded: false,
      error: false
    }),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        state = _React$useState6[0],
        setState = _React$useState6[1];

    React.useEffect(function () {
      if (cachedScripts.includes(src)) {
        setState({
          loaded: true,
          error: false
        });
      } else {
        cachedScripts.push(src);
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.id = 'stripe';

        var onScriptLoad = function onScriptLoad() {
          setState({
            loaded: true,
            error: false
          });
        };

        var onScriptError = function onScriptError() {
          var index = cachedScripts.indexOf(src);
          if (index >= 0) cachedScripts.splice(index, 1);
          script.remove();
          setState({
            loaded: true,
            error: true
          });
        };

        script.addEventListener('load', onScriptLoad);
        script.addEventListener('error', onScriptError);
        document.body.appendChild(script);
        return function () {
          script.removeEventListener('load', onScriptLoad);
          script.removeEventListener('error', onScriptError);
        };
      }
    }, [src]);
    return [state.loaded, state.error];
  }
  /* istanbul ignore file */


  var Stripe = function Stripe(_ref31) {
    var apiKey = _ref31.apiKey,
        children = _ref31.children;

    var _useScript = useScript('https://js.stripe.com/v3/'),
        _useScript2 = _slicedToArray(_useScript, 2),
        loaded = _useScript2[0],
        error = _useScript2[1];

    var stripe = null;

    if (loaded && window.Stripe) {
      stripe = window.Stripe(apiKey);
    }

    if (error) {
      return (
        /*#__PURE__*/
        React__default.createElement("div", {
          "data-testid": "stripe-load-error"
        }, "Unable to load payment gateway")
      );
    }

    return (
      /*#__PURE__*/
      React__default.createElement(reactStripeElements.StripeProvider, {
        stripe: stripe
      },
      /*#__PURE__*/
      React__default.createElement(reactStripeElements.Elements, {
        fonts: [{
          family: 'MuseoSans',
          src: "url(https://fonts.resources.revtech.media/museosans_500-webfont.woff)"
        }, {
          family: 'Museo',
          src: "url(https://fonts.resources.revtech.media/museo_500-webfont.woff)"
        }]
      }, children))
    );
  };

  var stripeStyle = {
    base: {
      color: '#565656',
      letterSpacing: '0.025em',
      fontFamily: 'MuseoSans',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#9e2146'
    }
  };
  /* istanbul ignore file */

  var Wrapper$6 = styled__default(layout.Box)(_templateObject39(), inputStyle);

  var Card = function Card(props) {
    var _React__default$useSt39 = React__default.useState(false),
        _React__default$useSt40 = _slicedToArray(_React__default$useSt39, 2),
        completed = _React__default$useSt40[0],
        setCompleted = _React__default$useSt40[1];

    var getStripeToken =
    /*#__PURE__*/
    function () {
      var _ref32 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                props.onWaiting('Establishing secure payment token');
                props.fieldUtils.setFieldError(props.name, null);
                _context.next = 4;
                return props.stripe.createToken({
                  name: 'Some User'
                }).then(function (_ref33) {
                  var token = _ref33.token;
                  props.onWaiting(false);
                  props.fieldUtils.setFieldValue(props.name, token.id);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getStripeToken() {
        return _ref32.apply(this, arguments);
      };
    }();

    var setEntryStatus =
    /*#__PURE__*/
    function () {
      var _ref34 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(stripeEvent) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return setCompleted(stripeEvent.complete);

              case 2:
                if (!stripeEvent.complete) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return getStripeToken();

              case 5:
                if (!stripeEvent.error) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 8;
                return props.fieldUtils.setFieldError(props.name, 'Incomplete payment details');

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function setEntryStatus(_x) {
        return _ref34.apply(this, arguments);
      };
    }();

    var checkStatus = function checkStatus() {
      if (!completed) {
        props.fieldUtils.setFieldError(props.name, 'Incomplete payment details');
      }

      props.onBlur();
    };

    return (
      /*#__PURE__*/
      React__default.createElement(reactStripeElements.CardElement, {
        hidePostalCode: true,
        style: stripeStyle,
        onBlur: checkStatus,
        onChange: function onChange(stripeEvent) {
          return setEntryStatus(stripeEvent);
        },
        onFocus: function onFocus() {
          props.fieldUtils.setFieldTouched(props.name, true);
          props.onFocus();
        }
      })
    );
  };

  var InjectedCard = reactStripeElements.injectStripe(Card);

  var StripeField = function StripeField(props) {
    var apiKey = props.config.apiKey;
    return (
      /*#__PURE__*/
      React__default.createElement(Stripe, {
        apiKey: apiKey
      },
      /*#__PURE__*/
      React__default.createElement(Wrapper$6, {
        showErrorColor: props.showErrorColor
      },
      /*#__PURE__*/
      React__default.createElement(InjectedCard, props)))
    );
  };

  Card.propTypes = {
    name: PropTypes.string,
    onFocus: PropTypes.func,
    onWaiting: PropTypes.func,
    setFieldTouched: PropTypes.func,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
    onBlur: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    stripe: PropTypes.object
  };

  var getFieldComponent = function getFieldComponent(type, _ref35) {
    var _ref35$component = _ref35.component,
        component = _ref35$component === void 0 ? null : _ref35$component,
        _ref35$validator = _ref35.validator,
        validator = _ref35$validator === void 0 ? null : _ref35$validator;
    return type === 'radio' ? component === 'panelRadio' ? PanelRadioField : RadioField : type === 'checkbox' ? component === 'panelCheck' ? PanelCheckField : CheckboxField : component === 'month' ? MonthField : component === 'monthButtonGroup' ? MonthButtonGroupField : type === 'hidden' ? HiddenField : component === 'stripePayment' ? StripeField : component === 'autocomplete' ? AutocompleteField : component === 'addressautocomplete' ? GoogleAddressAutocompleteField : component === 'dropdownfield' ? DropdownField : validator === 'mask' ? NumberField : component === 'inlineYear' ? YearField : TextField;
  };
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
    Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  /* global Reflect, Promise */


  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  function __extends(d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }

  var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return _assign.apply(this, arguments);
  };

  function __rest(s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  }

  function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
      s += arguments[i].length;
    }

    for (var r = Array(s), k = 0, i = 0; i < il; i++) {
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
        r[k] = a[j];
      }
    }

    return r;
  }

  var warning = function warning() {};

  var invariant = function invariant() {};

  if (process.env.NODE_ENV !== 'production') {
    warning = function warning(check, message) {
      if (!check && typeof console !== 'undefined') {
        console.warn(message);
      }
    };

    invariant = function invariant(check, message) {
      if (!check) {
        throw new Error(message);
      }
    };
  }

  var prevTime = 0;
  var onNextFrame = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined ? function (callback) {
    return window.requestAnimationFrame(callback);
  } : function (callback) {
    var timestamp = Date.now();
    var timeToCall = Math.max(0, 16.7 - (timestamp - prevTime));
    prevTime = timestamp + timeToCall;
    setTimeout(function () {
      return callback(prevTime);
    }, timeToCall);
  };

  var createStep = function createStep(setRunNextFrame) {
    var processToRun = [];
    var processToRunNextFrame = [];
    var numThisFrame = 0;
    var isProcessing = false;
    var i = 0;
    var cancelled = new WeakSet();
    var toKeepAlive = new WeakSet();
    var renderStep = {
      cancel: function cancel(process) {
        var indexOfCallback = processToRunNextFrame.indexOf(process);
        cancelled.add(process);

        if (indexOfCallback !== -1) {
          processToRunNextFrame.splice(indexOfCallback, 1);
        }
      },
      process: function process(frame) {
        var _a;

        isProcessing = true;
        _a = [processToRunNextFrame, processToRun], processToRun = _a[0], processToRunNextFrame = _a[1];
        processToRunNextFrame.length = 0;
        numThisFrame = processToRun.length;

        if (numThisFrame) {
          var process_1;

          for (i = 0; i < numThisFrame; i++) {
            process_1 = processToRun[i];
            process_1(frame);

            if (toKeepAlive.has(process_1) === true && !cancelled.has(process_1)) {
              renderStep.schedule(process_1);
              setRunNextFrame(true);
            }
          }
        }

        isProcessing = false;
      },
      schedule: function schedule(process, keepAlive, immediate) {
        if (keepAlive === void 0) {
          keepAlive = false;
        }

        if (immediate === void 0) {
          immediate = false;
        }

        invariant(typeof process === "function", "Argument must be a function");
        var addToCurrentBuffer = immediate && isProcessing;
        var buffer = addToCurrentBuffer ? processToRun : processToRunNextFrame;
        cancelled.delete(process);
        if (keepAlive) toKeepAlive.add(process);

        if (buffer.indexOf(process) === -1) {
          buffer.push(process);
          if (addToCurrentBuffer) numThisFrame = processToRun.length;
        }
      }
    };
    return renderStep;
  };

  var maxElapsed = 40;
  var defaultElapsed = 1 / 60 * 1000;
  var useDefaultElapsed = true;
  var willRunNextFrame = false;
  var isProcessing = false;
  var frame = {
    delta: 0,
    timestamp: 0
  };
  var stepsOrder = ["read", "update", "preRender", "render", "postRender"];

  var setWillRunNextFrame = function setWillRunNextFrame(willRun) {
    return willRunNextFrame = willRun;
  };

  var steps =
  /*#__PURE__*/
  stepsOrder.reduce(function (acc, key) {
    acc[key] = createStep(setWillRunNextFrame);
    return acc;
  }, {});
  var sync =
  /*#__PURE__*/
  stepsOrder.reduce(function (acc, key) {
    var step = steps[key];

    acc[key] = function (process, keepAlive, immediate) {
      if (keepAlive === void 0) {
        keepAlive = false;
      }

      if (immediate === void 0) {
        immediate = false;
      }

      if (!willRunNextFrame) startLoop();
      step.schedule(process, keepAlive, immediate);
      return process;
    };

    return acc;
  }, {});
  var cancelSync =
  /*#__PURE__*/
  stepsOrder.reduce(function (acc, key) {
    acc[key] = steps[key].cancel;
    return acc;
  }, {});

  var processStep = function processStep(stepId) {
    return steps[stepId].process(frame);
  };

  var processFrame = function processFrame(timestamp) {
    willRunNextFrame = false;
    frame.delta = useDefaultElapsed ? defaultElapsed : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    if (!useDefaultElapsed) defaultElapsed = frame.delta;
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;

    if (willRunNextFrame) {
      useDefaultElapsed = false;
      onNextFrame(processFrame);
    }
  };

  var startLoop = function startLoop() {
    willRunNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing) onNextFrame(processFrame);
  };

  var getFrameData = function getFrameData() {
    return frame;
  };

  var clamp = function clamp(min, max) {
    return function (v) {
      return Math.max(Math.min(v, max), min);
    };
  };

  var sanitize = function sanitize(v) {
    return v % 1 ? Number(v.toFixed(5)) : v;
  };

  var floatRegex = /(-)?(\d[\d\.]*)/g;
  var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
  var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
  var number = {
    test: function test(v) {
      return typeof v === 'number';
    },
    parse: parseFloat,
    transform: function transform(v) {
      return v;
    }
  };

  var alpha = _assign(_assign({}, number), {
    transform: clamp(0, 1)
  });

  var scale = _assign(_assign({}, number), {
    default: 1
  });

  var createUnitType = function createUnitType(unit) {
    return {
      test: function test(v) {
        return typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1;
      },
      parse: parseFloat,
      transform: function transform(v) {
        return "" + v + unit;
      }
    };
  };

  var degrees = createUnitType('deg');
  var percent = createUnitType('%');
  var px = createUnitType('px');
  var vh = createUnitType('vh');
  var vw = createUnitType('vw');

  var progressPercentage = _assign(_assign({}, percent), {
    parse: function parse(v) {
      return percent.parse(v) / 100;
    },
    transform: function transform(v) {
      return percent.transform(v * 100);
    }
  });

  var getValueFromFunctionString = function getValueFromFunctionString(value) {
    return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
  };

  var clampRgbUnit = clamp(0, 255);

  var isRgba = function isRgba(v) {
    return v.red !== undefined;
  };

  var isHsla = function isHsla(v) {
    return v.hue !== undefined;
  };

  function getValuesAsArray(value) {
    return getValueFromFunctionString(value).replace(/(,|\/)/g, ' ').split(/ \s*/);
  }

  var splitColorValues = function splitColorValues(terms) {
    return function (v) {
      if (typeof v !== 'string') return v;
      var values = {};
      var valuesArray = getValuesAsArray(v);

      for (var i = 0; i < 4; i++) {
        values[terms[i]] = valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
      }

      return values;
    };
  };

  var rgbaTemplate = function rgbaTemplate(_a) {
    var red = _a.red,
        green = _a.green,
        blue = _a.blue,
        _b = _a.alpha,
        alpha = _b === void 0 ? 1 : _b;
    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
  };

  var hslaTemplate = function hslaTemplate(_a) {
    var hue = _a.hue,
        saturation = _a.saturation,
        lightness = _a.lightness,
        _b = _a.alpha,
        alpha = _b === void 0 ? 1 : _b;
    return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha + ")";
  };

  var rgbUnit = _assign(_assign({}, number), {
    transform: function transform(v) {
      return Math.round(clampRgbUnit(v));
    }
  });

  function isColorString(color, colorType) {
    return color.startsWith(colorType) && singleColorRegex.test(color);
  }

  var rgba = {
    test: function test(v) {
      return typeof v === 'string' ? isColorString(v, 'rgb') : isRgba(v);
    },
    parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
    transform: function transform(_a) {
      var red = _a.red,
          green = _a.green,
          blue = _a.blue,
          _b = _a.alpha,
          alpha$1 = _b === void 0 ? 1 : _b;
      return rgbaTemplate({
        red: rgbUnit.transform(red),
        green: rgbUnit.transform(green),
        blue: rgbUnit.transform(blue),
        alpha: sanitize(alpha.transform(alpha$1))
      });
    }
  };
  var hsla = {
    test: function test(v) {
      return typeof v === 'string' ? isColorString(v, 'hsl') : isHsla(v);
    },
    parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
    transform: function transform(_a) {
      var hue = _a.hue,
          saturation = _a.saturation,
          lightness = _a.lightness,
          _b = _a.alpha,
          alpha$1 = _b === void 0 ? 1 : _b;
      return hslaTemplate({
        hue: Math.round(hue),
        saturation: percent.transform(sanitize(saturation)),
        lightness: percent.transform(sanitize(lightness)),
        alpha: sanitize(alpha.transform(alpha$1))
      });
    }
  };

  var hex = _assign(_assign({}, rgba), {
    test: function test(v) {
      return typeof v === 'string' && isColorString(v, '#');
    },
    parse: function parse(v) {
      var r = '';
      var g = '';
      var b = '';

      if (v.length > 4) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
      } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        r += r;
        g += g;
        b += b;
      }

      return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: 1
      };
    }
  });

  var color = {
    test: function test(v) {
      return typeof v === 'string' && singleColorRegex.test(v) || isRgba(v) || isHsla(v);
    },
    parse: function parse(v) {
      if (rgba.test(v)) {
        return rgba.parse(v);
      } else if (hsla.test(v)) {
        return hsla.parse(v);
      } else if (hex.test(v)) {
        return hex.parse(v);
      }

      return v;
    },
    transform: function transform(v) {
      if (isRgba(v)) {
        return rgba.transform(v);
      } else if (isHsla(v)) {
        return hsla.transform(v);
      }

      return v;
    }
  };
  var COLOR_TOKEN = '${c}';
  var NUMBER_TOKEN = '${n}';

  var convertNumbersToZero = function convertNumbersToZero(v) {
    return typeof v === 'number' ? 0 : v;
  };

  var complex = {
    test: function test(v) {
      if (typeof v !== 'string' || !isNaN(v)) return false;
      var numValues = 0;
      var foundNumbers = v.match(floatRegex);
      var foundColors = v.match(colorRegex);
      if (foundNumbers) numValues += foundNumbers.length;
      if (foundColors) numValues += foundColors.length;
      return numValues > 0;
    },
    parse: function parse(v) {
      var input = v;
      var parsed = [];
      var foundColors = input.match(colorRegex);

      if (foundColors) {
        input = input.replace(colorRegex, COLOR_TOKEN);
        parsed.push.apply(parsed, foundColors.map(color.parse));
      }

      var foundNumbers = input.match(floatRegex);

      if (foundNumbers) {
        parsed.push.apply(parsed, foundNumbers.map(number.parse));
      }

      return parsed;
    },
    createTransformer: function createTransformer(prop) {
      var template = prop;
      var token = 0;
      var foundColors = prop.match(colorRegex);
      var numColors = foundColors ? foundColors.length : 0;

      if (foundColors) {
        for (var i = 0; i < numColors; i++) {
          template = template.replace(foundColors[i], COLOR_TOKEN);
          token++;
        }
      }

      var foundNumbers = template.match(floatRegex);
      var numNumbers = foundNumbers ? foundNumbers.length : 0;

      if (foundNumbers) {
        for (var i = 0; i < numNumbers; i++) {
          template = template.replace(foundNumbers[i], NUMBER_TOKEN);
          token++;
        }
      }

      return function (v) {
        var output = template;

        for (var i = 0; i < token; i++) {
          output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
        }

        return output;
      };
    },
    getAnimatableNone: function getAnimatableNone(target) {
      var parsedTarget = complex.parse(target);
      var targetTransformer = complex.createTransformer(target);
      return targetTransformer(parsedTarget.map(convertNumbersToZero));
    }
  };
  var DEFAULT_OVERSHOOT_STRENGTH = 1.525;

  var reversed = function reversed(easing) {
    return function (p) {
      return 1 - easing(1 - p);
    };
  };

  var mirrored = function mirrored(easing) {
    return function (p) {
      return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
  };

  var createReversedEasing = reversed;
  var createMirroredEasing = mirrored;

  var createExpoIn = function createExpoIn(power) {
    return function (p) {
      return Math.pow(p, power);
    };
  };

  var createBackIn = function createBackIn(power) {
    return function (p) {
      return p * p * ((power + 1) * p - power);
    };
  };

  var createAnticipateEasing = function createAnticipateEasing(power) {
    var backEasing = createBackIn(power);
    return function (p) {
      return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
  };

  var linear = function linear(p) {
    return p;
  };

  var easeIn =
  /*#__PURE__*/
  createExpoIn(2);
  var easeOut =
  /*#__PURE__*/
  reversed(easeIn);
  var easeInOut =
  /*#__PURE__*/
  mirrored(easeIn);

  var circIn = function circIn(p) {
    return 1 - Math.sin(Math.acos(p));
  };

  var circOut =
  /*#__PURE__*/
  reversed(circIn);
  var circInOut =
  /*#__PURE__*/
  mirrored(circOut);
  var backIn =
  /*#__PURE__*/
  createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
  var backOut =
  /*#__PURE__*/
  reversed(backIn);
  var backInOut =
  /*#__PURE__*/
  mirrored(backIn);
  var anticipate =
  /*#__PURE__*/
  createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
  var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
  var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
  var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
  var ca = 4356.0 / 361.0;
  var cb = 35442.0 / 1805.0;
  var cc = 16061.0 / 1805.0;

  var bounceOut = function bounceOut(p) {
    var p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < BOUNCE_THIRD_THRESHOLD ? ca * p2 - cb * p + cc : 10.8 * p * p - 20.52 * p + 10.72;
  };

  var bounceIn = function bounceIn(p) {
    return 1.0 - bounceOut(1.0 - p);
  };

  var bounceInOut = function bounceInOut(p) {
    return p < 0.5 ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0)) : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
  };

  var NEWTON_ITERATIONS = 8;
  var NEWTON_MIN_SLOPE = 0.001;
  var SUBDIVISION_PRECISION = 0.0000001;
  var SUBDIVISION_MAX_ITERATIONS = 10;
  var K_SPLINE_TABLE_SIZE = 11;
  var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
  var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';

  var a = function a(a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
  };

  var b = function b(a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
  };

  var c = function c(a1) {
    return 3.0 * a1;
  };

  var getSlope = function getSlope(t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
  };

  var calcBezier = function calcBezier(t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
  };

  function cubicBezier(mX1, mY1, mX2, mY2) {
    var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);

    var binarySubdivide = function binarySubdivide(aX, aA, aB) {
      var i = 0;
      var currentX;
      var currentT;

      do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;

        if (currentX > 0.0) {
          aB = currentT;
        } else {
          aA = currentT;
        }
      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

      return currentT;
    };

    var newtonRaphsonIterate = function newtonRaphsonIterate(aX, aGuessT) {
      var i = 0;
      var currentSlope = 0;
      var currentX;

      for (; i < NEWTON_ITERATIONS; ++i) {
        currentSlope = getSlope(aGuessT, mX1, mX2);

        if (currentSlope === 0.0) {
          return aGuessT;
        }

        currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
      }

      return aGuessT;
    };

    var calcSampleValues = function calcSampleValues() {
      for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
        sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
      }
    };

    var getTForX = function getTForX(aX) {
      var intervalStart = 0.0;
      var currentSample = 1;
      var lastSample = K_SPLINE_TABLE_SIZE - 1;
      var dist = 0.0;
      var guessForT = 0.0;
      var initialSlope = 0.0;

      for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
        intervalStart += K_SAMPLE_STEP_SIZE;
      }

      --currentSample;
      dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
      guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
      initialSlope = getSlope(guessForT, mX1, mX2);

      if (initialSlope >= NEWTON_MIN_SLOPE) {
        return newtonRaphsonIterate(aX, guessForT);
      } else if (initialSlope === 0.0) {
        return guessForT;
      } else {
        return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
      }
    };

    calcSampleValues();

    var resolver = function resolver(aX) {
      var returnValue;

      if (mX1 === mY1 && mX2 === mY2) {
        returnValue = aX;
      } else if (aX === 0) {
        returnValue = 0;
      } else if (aX === 1) {
        returnValue = 1;
      } else {
        returnValue = calcBezier(getTForX(aX), mY1, mY2);
      }

      return returnValue;
    };

    return resolver;
  }

  var easingLookup =
  /*#__PURE__*/
  Object.freeze({
    __proto__: null,
    reversed: reversed,
    mirrored: mirrored,
    createReversedEasing: createReversedEasing,
    createMirroredEasing: createMirroredEasing,
    createExpoIn: createExpoIn,
    createBackIn: createBackIn,
    createAnticipateEasing: createAnticipateEasing,
    linear: linear,
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut,
    circIn: circIn,
    circOut: circOut,
    circInOut: circInOut,
    backIn: backIn,
    backOut: backOut,
    backInOut: backInOut,
    anticipate: anticipate,
    bounceOut: bounceOut,
    bounceIn: bounceIn,
    bounceInOut: bounceInOut,
    cubicBezier: cubicBezier
  });
  var zeroPoint = {
    x: 0,
    y: 0,
    z: 0
  };

  var isNum = function isNum(v) {
    return typeof v === 'number';
  };

  var curryRange = function curryRange(func) {
    return function (min, max, v) {
      return v !== undefined ? func(min, max, v) : function (cv) {
        return func(min, max, cv);
      };
    };
  };

  var clamp$1 = function clamp$1(min, max, v) {
    return Math.min(Math.max(v, min), max);
  };

  var clamp$1$1 = curryRange(clamp$1);

  var isPoint = function isPoint(point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
  };

  var isPoint3D = function isPoint3D(point) {
    return isPoint(point) && point.hasOwnProperty('z');
  };

  var distance1D = function distance1D(a, b) {
    return Math.abs(a - b);
  };

  var distance = function distance(a, b) {
    if (b === void 0) {
      b = zeroPoint;
    }

    if (isNum(a) && isNum(b)) {
      return distance1D(a, b);
    } else if (isPoint(a) && isPoint(b)) {
      var xDelta = distance1D(a.x, b.x);
      var yDelta = distance1D(a.y, b.y);
      var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
      return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }

    return 0;
  };

  var progress = function progress(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
  };

  var mix = function mix(from, to, progress) {
    return -progress * from + progress * to + from;
  };
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */


  var _assign$ = function __assign$1() {
    _assign$ = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];

        for (var p in s) {
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
      }

      return t;
    };

    return _assign$.apply(this, arguments);
  };

  var mixLinearColor = function mixLinearColor(from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
  };

  var colorTypes = [hex, rgba, hsla];

  var getColorType = function getColorType(v) {
    return colorTypes.find(function (type) {
      return type.test(v);
    });
  };

  var notAnimatable = function notAnimatable(color$$1) {
    return "'" + color$$1 + "' is not an animatable color. Use the equivalent color code instead.";
  };

  var mixColor = function mixColor(from, to) {
    var fromColorType = getColorType(from);
    var toColorType = getColorType(to);
    invariant(!!fromColorType, notAnimatable(from));
    invariant(!!toColorType, notAnimatable(to));
    invariant(fromColorType.transform === toColorType.transform, 'Both colors must be hex/RGBA, OR both must be HSLA.');
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);

    var blended = _assign$({}, fromColor);

    var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
    return function (v) {
      for (var key in blended) {
        if (key !== 'alpha') {
          blended[key] = mixFunc(fromColor[key], toColor[key], v);
        }
      }

      blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
      return fromColorType.transform(blended);
    };
  };

  var combineFunctions = function combineFunctions(a, b) {
    return function (v) {
      return b(a(v));
    };
  };

  var pipe = function pipe() {
    var transformers = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      transformers[_i] = arguments[_i];
    }

    return transformers.reduce(combineFunctions);
  };

  function getMixer(origin, target) {
    if (isNum(origin)) {
      return function (v) {
        return mix(origin, target, v);
      };
    } else if (color.test(origin)) {
      return mixColor(origin, target);
    } else {
      return mixComplex(origin, target);
    }
  }

  var mixArray = function mixArray(from, to) {
    var output = from.slice();
    var numValues = output.length;
    var blendValue = from.map(function (fromThis, i) {
      return getMixer(fromThis, to[i]);
    });
    return function (v) {
      for (var i = 0; i < numValues; i++) {
        output[i] = blendValue[i](v);
      }

      return output;
    };
  };

  function analyse(value) {
    var parsed = complex.parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;

    for (var i = 0; i < numValues; i++) {
      if (numNumbers || typeof parsed[i] === 'number') {
        numNumbers++;
      } else {
        if (parsed[i].hue !== undefined) {
          numHSL++;
        } else {
          numRGB++;
        }
      }
    }

    return {
      parsed: parsed,
      numNumbers: numNumbers,
      numRGB: numRGB,
      numHSL: numHSL
    };
  }

  var mixComplex = function mixComplex(origin, target) {
    var template = complex.createTransformer(target);
    var originStats = analyse(origin);
    var targetStats = analyse(target);
    invariant(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
  };

  var velocityPerSecond = function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
  };

  var clampProgress = clamp$1$1(0, 1);

  var createStyler = function createStyler(_a) {
    var onRead = _a.onRead,
        onRender = _a.onRender,
        _b = _a.uncachedValues,
        uncachedValues = _b === void 0 ? new Set() : _b,
        _c = _a.useCache,
        useCache = _c === void 0 ? true : _c;
    return function (_a) {
      if (_a === void 0) {
        _a = {};
      }

      var props = __rest(_a, []);

      var state = {};
      var changedValues = [];
      var hasChanged = false;

      function setValue(key, value) {
        if (key.startsWith('--')) {
          props.hasCSSVariable = true;
        }

        var currentValue = state[key];
        state[key] = value;
        if (state[key] === currentValue) return;

        if (changedValues.indexOf(key) === -1) {
          changedValues.push(key);
        }

        if (!hasChanged) {
          hasChanged = true;
          sync.render(styler.render);
        }
      }

      var styler = {
        get: function get(key, forceRead) {
          if (forceRead === void 0) {
            forceRead = false;
          }

          var useCached = !forceRead && useCache && !uncachedValues.has(key) && state[key] !== undefined;
          return useCached ? state[key] : onRead(key, props);
        },
        set: function set(values, value) {
          if (typeof values === 'string') {
            setValue(values, value);
          } else {
            for (var key in values) {
              setValue(key, values[key]);
            }
          }

          return this;
        },
        render: function render(forceRender) {
          if (forceRender === void 0) {
            forceRender = false;
          }

          if (hasChanged || forceRender === true) {
            onRender(state, props, changedValues);
            hasChanged = false;
            changedValues.length = 0;
          }

          return this;
        }
      };
      return styler;
    };
  };

  var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
  var REPLACE_TEMPLATE = '$1-$2';

  var camelToDash = function camelToDash(str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
  };

  var camelCache =
  /*#__PURE__*/
  new Map();
  var dashCache =
  /*#__PURE__*/
  new Map();
  var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
  var numPrefixes = prefixes.length;
  var isBrowser = typeof document !== 'undefined';
  var testElement;

  var setDashPrefix = function setDashPrefix(key, prefixed) {
    return dashCache.set(key, camelToDash(prefixed));
  };

  var testPrefix = function testPrefix(key) {
    testElement = testElement || document.createElement('div');

    for (var i = 0; i < numPrefixes; i++) {
      var prefix = prefixes[i];
      var noPrefix = prefix === '';
      var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);

      if (prefixedPropertyName in testElement.style || noPrefix) {
        if (noPrefix && key === 'clipPath' && dashCache.has(key)) {
          return;
        }

        camelCache.set(key, prefixedPropertyName);
        setDashPrefix(key, "" + (noPrefix ? '' : '-') + camelToDash(prefixedPropertyName));
      }
    }
  };

  var setServerProperty = function setServerProperty(key) {
    return setDashPrefix(key, key);
  };

  var prefixer = function prefixer(key, asDashCase) {
    if (asDashCase === void 0) {
      asDashCase = false;
    }

    var cache = asDashCase ? dashCache : camelCache;

    if (!cache.has(key)) {
      isBrowser ? testPrefix(key) : setServerProperty(key);
    }

    return cache.get(key) || key;
  };

  var axes = ['', 'X', 'Y', 'Z'];
  var order = ['translate', 'scale', 'rotate', 'skew', 'transformPerspective'];
  var transformProps =
  /*#__PURE__*/
  order.reduce(function (acc, key) {
    return axes.reduce(function (axesAcc, axesKey) {
      axesAcc.push(key + axesKey);
      return axesAcc;
    }, acc);
  }, ['x', 'y', 'z']);
  var transformPropDictionary =
  /*#__PURE__*/
  transformProps.reduce(function (dict, key) {
    dict[key] = true;
    return dict;
  }, {});

  function isTransformProp(key) {
    return transformPropDictionary[key] === true;
  }

  function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
  }

  var transformOriginProps =
  /*#__PURE__*/
  new Set(['originX', 'originY', 'originZ']);

  function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
  }

  var int =
  /*#__PURE__*/
  _assign(
  /*#__PURE__*/
  _assign({}, number), {
    transform: Math.round
  });

  var valueTypes = {
    color: color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale: scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    zIndex: int,
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int
  };

  var getValueType = function getValueType(key) {
    return valueTypes[key];
  };

  var getValueAsType = function getValueAsType(value, type) {
    return type && typeof value === 'number' ? type.transform(value) : value;
  };

  var SCROLL_LEFT = 'scrollLeft';
  var SCROLL_TOP = 'scrollTop';
  var scrollKeys =
  /*#__PURE__*/
  new Set([SCROLL_LEFT, SCROLL_TOP]);
  var blacklist =
  /*#__PURE__*/
  new Set([SCROLL_LEFT, SCROLL_TOP, 'transform']);
  var translateAlias = {
    x: 'translateX',
    y: 'translateY',
    z: 'translateZ'
  };

  function isCustomTemplate(v) {
    return typeof v === 'function';
  }

  function buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone) {
    if (allowTransformNone === void 0) {
      allowTransformNone = true;
    }

    var transformString = '';
    var transformHasZ = false;
    transformKeys.sort(sortTransformProps);
    var numTransformKeys = transformKeys.length;

    for (var i = 0; i < numTransformKeys; i++) {
      var key = transformKeys[i];
      transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
      transformHasZ = key === 'z' ? true : transformHasZ;
    }

    if (!transformHasZ && enableHardwareAcceleration) {
      transformString += 'translateZ(0)';
    } else {
      transformString = transformString.trim();
    }

    if (isCustomTemplate(state.transform)) {
      transformString = state.transform(transform, transformIsDefault ? '' : transformString);
    } else if (allowTransformNone && transformIsDefault) {
      transformString = 'none';
    }

    return transformString;
  }

  function buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone) {
    if (enableHardwareAcceleration === void 0) {
      enableHardwareAcceleration = true;
    }

    if (styles === void 0) {
      styles = {};
    }

    if (transform === void 0) {
      transform = {};
    }

    if (transformOrigin === void 0) {
      transformOrigin = {};
    }

    if (transformKeys === void 0) {
      transformKeys = [];
    }

    if (isDashCase === void 0) {
      isDashCase = false;
    }

    if (allowTransformNone === void 0) {
      allowTransformNone = true;
    }

    var transformIsDefault = true;
    var hasTransform = false;
    var hasTransformOrigin = false;

    for (var key in state) {
      var value = state[key];
      var valueType = getValueType(key);
      var valueAsType = getValueAsType(value, valueType);

      if (isTransformProp(key)) {
        hasTransform = true;
        transform[key] = valueAsType;
        transformKeys.push(key);

        if (transformIsDefault) {
          if (valueType.default && value !== valueType.default || !valueType.default && value !== 0) {
            transformIsDefault = false;
          }
        }
      } else if (isTransformOriginProp(key)) {
        transformOrigin[key] = valueAsType;
        hasTransformOrigin = true;
      } else if (!blacklist.has(key) || !isCustomTemplate(valueAsType)) {
        styles[prefixer(key, isDashCase)] = valueAsType;
      }
    }

    if (hasTransform || typeof state.transform === 'function') {
      styles.transform = buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone);
    }

    if (hasTransformOrigin) {
      styles.transformOrigin = (transformOrigin.originX || '50%') + " " + (transformOrigin.originY || '50%') + " " + (transformOrigin.originZ || 0);
    }

    return styles;
  }

  function createStyleBuilder(_a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.enableHardwareAcceleration,
        enableHardwareAcceleration = _c === void 0 ? true : _c,
        _d = _b.isDashCase,
        isDashCase = _d === void 0 ? true : _d,
        _e = _b.allowTransformNone,
        allowTransformNone = _e === void 0 ? true : _e;

    var styles = {};
    var transform = {};
    var transformOrigin = {};
    var transformKeys = [];
    return function (state) {
      transformKeys.length = 0;
      buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone);
      return styles;
    };
  }

  function onRead(key, options) {
    var element = options.element,
        preparseOutput = options.preparseOutput;
    var defaultValueType = getValueType(key);

    if (isTransformProp(key)) {
      return defaultValueType ? defaultValueType.default || 0 : 0;
    } else if (scrollKeys.has(key)) {
      return element[key];
    } else {
      var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer(key, true)) || 0;
      return preparseOutput && defaultValueType && defaultValueType.test(domValue) && defaultValueType.parse ? defaultValueType.parse(domValue) : domValue;
    }
  }

  function onRender(state, _a, changedValues) {
    var element = _a.element,
        buildStyles = _a.buildStyles,
        hasCSSVariable = _a.hasCSSVariable;
    Object.assign(element.style, buildStyles(state));

    if (hasCSSVariable) {
      var numChangedValues = changedValues.length;

      for (var i = 0; i < numChangedValues; i++) {
        var key = changedValues[i];

        if (key.startsWith('--')) {
          element.style.setProperty(key, state[key]);
        }
      }
    }

    if (changedValues.indexOf(SCROLL_LEFT) !== -1) {
      element[SCROLL_LEFT] = state[SCROLL_LEFT];
    }

    if (changedValues.indexOf(SCROLL_TOP) !== -1) {
      element[SCROLL_TOP] = state[SCROLL_TOP];
    }
  }

  var cssStyler =
  /*#__PURE__*/
  createStyler({
    onRead: onRead,
    onRender: onRender,
    uncachedValues: scrollKeys
  });

  function createCssStyler(element, _a) {
    if (_a === void 0) {
      _a = {};
    }

    var enableHardwareAcceleration = _a.enableHardwareAcceleration,
        allowTransformNone = _a.allowTransformNone,
        props = __rest(_a, ["enableHardwareAcceleration", "allowTransformNone"]);

    return cssStyler(_assign({
      element: element,
      buildStyles: createStyleBuilder({
        enableHardwareAcceleration: enableHardwareAcceleration,
        allowTransformNone: allowTransformNone
      }),
      preparseOutput: true
    }, props));
  }

  var camelCaseAttributes =
  /*#__PURE__*/
  new Set(['baseFrequency', 'diffuseConstant', 'kernelMatrix', 'kernelUnitLength', 'keySplines', 'keyTimes', 'limitingConeAngle', 'markerHeight', 'markerWidth', 'numOctaves', 'targetX', 'targetY', 'surfaceScale', 'specularConstant', 'specularExponent', 'stdDeviation', 'tableValues']);
  var defaultOrigin = 0.5;

  var svgAttrsTemplate = function svgAttrsTemplate() {
    return {
      style: {}
    };
  };

  var progressToPixels = function progressToPixels(progress, length) {
    return px.transform(progress * length);
  };

  var unmeasured = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };

  function calcOrigin(origin, offset, size) {
    return typeof origin === 'string' ? origin : px.transform(offset + size * origin);
  }

  function calculateSVGTransformOrigin(dimensions, originX, originY) {
    return calcOrigin(originX, dimensions.x, dimensions.width) + " " + calcOrigin(originY, dimensions.y, dimensions.height);
  }

  var svgStyleConfig = {
    enableHardwareAcceleration: false,
    isDashCase: false
  };

  function buildSVGAttrs(_a, dimensions, totalPathLength, cssBuilder, attrs, isDashCase) {
    if (dimensions === void 0) {
      dimensions = unmeasured;
    }

    if (cssBuilder === void 0) {
      cssBuilder = createStyleBuilder(svgStyleConfig);
    }

    if (attrs === void 0) {
      attrs = svgAttrsTemplate();
    }

    if (isDashCase === void 0) {
      isDashCase = true;
    }

    var attrX = _a.attrX,
        attrY = _a.attrY,
        originX = _a.originX,
        originY = _a.originY,
        pathLength = _a.pathLength,
        _b = _a.pathSpacing,
        pathSpacing = _b === void 0 ? 1 : _b,
        _c = _a.pathOffset,
        pathOffset = _c === void 0 ? 0 : _c,
        state = __rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);

    var style = cssBuilder(state);

    for (var key in style) {
      if (key === 'transform') {
        attrs.style.transform = style[key];
      } else {
        var attrKey = isDashCase && !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        attrs[attrKey] = style[key];
      }
    }

    if (originX !== undefined || originY !== undefined || style.transform) {
      attrs.style.transformOrigin = calculateSVGTransformOrigin(dimensions, originX !== undefined ? originX : defaultOrigin, originY !== undefined ? originY : defaultOrigin);
    }

    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;

    if (totalPathLength !== undefined && pathLength !== undefined) {
      attrs[isDashCase ? 'stroke-dashoffset' : 'strokeDashoffset'] = progressToPixels(-pathOffset, totalPathLength);
      attrs[isDashCase ? 'stroke-dasharray' : 'strokeDasharray'] = progressToPixels(pathLength, totalPathLength) + " " + progressToPixels(pathSpacing, totalPathLength);
    }

    return attrs;
  }

  function createAttrBuilder(dimensions, totalPathLength, isDashCase) {
    if (isDashCase === void 0) {
      isDashCase = true;
    }

    var attrs = svgAttrsTemplate();
    var cssBuilder = createStyleBuilder(svgStyleConfig);
    return function (state) {
      return buildSVGAttrs(state, dimensions, totalPathLength, cssBuilder, attrs, isDashCase);
    };
  }

  var getDimensions = function getDimensions(element) {
    return typeof element.getBBox === 'function' ? element.getBBox() : element.getBoundingClientRect();
  };

  var getSVGElementDimensions = function getSVGElementDimensions(element) {
    try {
      return getDimensions(element);
    } catch (e) {
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }
  };

  var isPath = function isPath(element) {
    return element.tagName === 'path';
  };

  var svgStyler =
  /*#__PURE__*/
  createStyler({
    onRead: function onRead(key, _a) {
      var element = _a.element;
      key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;

      if (!isTransformProp(key)) {
        return element.getAttribute(key);
      } else {
        var valueType = getValueType(key);
        return valueType ? valueType.default || 0 : 0;
      }
    },
    onRender: function onRender(state, _a) {
      var element = _a.element,
          buildAttrs = _a.buildAttrs;
      var attrs = buildAttrs(state);

      for (var key in attrs) {
        if (key === 'style') {
          Object.assign(element.style, attrs.style);
        } else {
          element.setAttribute(key, attrs[key]);
        }
      }
    }
  });

  var svg = function svg(element) {
    var dimensions = getSVGElementDimensions(element);
    var pathLength = isPath(element) && element.getTotalLength ? element.getTotalLength() : undefined;
    return svgStyler({
      element: element,
      buildAttrs: createAttrBuilder(dimensions, pathLength)
    });
  };

  var viewport =
  /*#__PURE__*/
  createStyler({
    useCache: false,
    onRead: function onRead(key) {
      return key === 'scrollTop' ? window.pageYOffset : window.pageXOffset;
    },
    onRender: function onRender(_a) {
      var _b = _a.scrollTop,
          scrollTop = _b === void 0 ? 0 : _b,
          _c = _a.scrollLeft,
          scrollLeft = _c === void 0 ? 0 : _c;
      return window.scrollTo(scrollLeft, scrollTop);
    }
  });
  var cache =
  /*#__PURE__*/
  new WeakMap();

  var isHTMLElement = function isHTMLElement(node) {
    return node instanceof HTMLElement || typeof node.click === 'function';
  };

  var isSVGElement = function isSVGElement(node) {
    return node instanceof SVGElement || 'ownerSVGElement' in node;
  };

  var createDOMStyler = function createDOMStyler(node, props) {
    var styler;

    if (node === window) {
      styler = viewport(node);
    } else if (isHTMLElement(node)) {
      styler = createCssStyler(node, props);
    } else if (isSVGElement(node)) {
      styler = svg(node);
    }

    invariant(styler !== undefined, 'No valid node provided. Node must be HTMLElement, SVGElement or window.');
    cache.set(node, styler);
    return styler;
  };

  var getStyler = function getStyler(node, props) {
    return cache.has(node) ? cache.get(node) : createDOMStyler(node, props);
  };

  function index(nodeOrSelector, props) {
    var node = typeof nodeOrSelector === 'string' ? document.querySelector(nodeOrSelector) : nodeOrSelector;
    return getStyler(node, props);
  }

  var Observer =
  /*#__PURE__*/
  function () {
    function Observer(_a, observer) {
      var _this = this;

      var middleware = _a.middleware,
          onComplete = _a.onComplete;
      this.isActive = true;

      this.update = function (v) {
        if (_this.observer.update) _this.updateObserver(v);
      };

      this.complete = function () {
        if (_this.observer.complete && _this.isActive) _this.observer.complete();
        if (_this.onComplete) _this.onComplete();
        _this.isActive = false;
      };

      this.error = function (err) {
        if (_this.observer.error && _this.isActive) _this.observer.error(err);
        _this.isActive = false;
      };

      this.observer = observer;

      this.updateObserver = function (v) {
        return observer.update(v);
      };

      this.onComplete = onComplete;

      if (observer.update && middleware && middleware.length) {
        middleware.forEach(function (m) {
          return _this.updateObserver = m(_this.updateObserver, _this.complete);
        });
      }
    }

    return Observer;
  }();

  var createObserver = function createObserver(observerCandidate, _a, onComplete) {
    var middleware = _a.middleware;

    if (typeof observerCandidate === 'function') {
      return new Observer({
        middleware: middleware,
        onComplete: onComplete
      }, {
        update: observerCandidate
      });
    } else {
      return new Observer({
        middleware: middleware,
        onComplete: onComplete
      }, observerCandidate);
    }
  };

  var Action =
  /*#__PURE__*/
  function () {
    function Action(props) {
      if (props === void 0) {
        props = {};
      }

      this.props = props;
    }

    Action.prototype.create = function (props) {
      return new Action(props);
    };

    Action.prototype.start = function (observerCandidate) {
      if (observerCandidate === void 0) {
        observerCandidate = {};
      }

      var isComplete = false;
      var subscription = {
        stop: function stop() {
          return undefined;
        }
      };

      var _a = this.props,
          init = _a.init,
          observerProps = __rest(_a, ["init"]);

      var observer = createObserver(observerCandidate, observerProps, function () {
        isComplete = true;
        subscription.stop();
      });
      var api = init(observer);
      subscription = api ? _assign({}, subscription, api) : subscription;
      if (isComplete) subscription.stop();
      return subscription;
    };

    Action.prototype.applyMiddleware = function (middleware) {
      return this.create(_assign({}, this.props, {
        middleware: this.props.middleware ? [middleware].concat(this.props.middleware) : [middleware]
      }));
    };

    Action.prototype.pipe = function () {
      var funcs = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
      }

      var pipedUpdate = funcs.length === 1 ? funcs[0] : pipe.apply(void 0, funcs);
      return this.applyMiddleware(function (update) {
        return function (v) {
          return update(pipedUpdate(v));
        };
      });
    };

    return Action;
  }();

  var action = function action(init) {
    return new Action({
      init: init
    });
  };

  var createVectorTests = function createVectorTests(typeTests) {
    var testNames = Object.keys(typeTests);

    var isVectorProp = function isVectorProp(prop, key) {
      return prop !== undefined && !typeTests[key](prop);
    };

    var getVectorKeys = function getVectorKeys(props) {
      return testNames.reduce(function (vectorKeys, key) {
        if (isVectorProp(props[key], key)) vectorKeys.push(key);
        return vectorKeys;
      }, []);
    };

    var testVectorProps = function testVectorProps(props) {
      return props && testNames.some(function (key) {
        return isVectorProp(props[key], key);
      });
    };

    return {
      getVectorKeys: getVectorKeys,
      testVectorProps: testVectorProps
    };
  };

  var unitTypes = [px, percent, degrees, vh, vw];

  var findUnitType = function findUnitType(prop) {
    return unitTypes.find(function (type) {
      return type.test(prop);
    });
  };

  var isUnitProp = function isUnitProp(prop) {
    return Boolean(findUnitType(prop));
  };

  var createAction = function createAction(action, props) {
    return action(props);
  };

  var createUnitAction = function createUnitAction(action, _a) {
    var from = _a.from,
        to = _a.to,
        props = __rest(_a, ["from", "to"]);

    var unitType = findUnitType(from) || findUnitType(to);
    var transform = unitType.transform,
        parse = unitType.parse;
    return action(_assign({}, props, {
      from: typeof from === 'string' ? parse(from) : from,
      to: typeof to === 'string' ? parse(to) : to
    })).pipe(transform);
  };

  var createMixerAction = function createMixerAction(mixer) {
    return function (action, _a) {
      var from = _a.from,
          to = _a.to,
          props = __rest(_a, ["from", "to"]);

      return action(_assign({}, props, {
        from: 0,
        to: 1
      })).pipe(mixer(from, to));
    };
  };

  var createColorAction =
  /*#__PURE__*/
  createMixerAction(mixColor);
  var createComplexAction =
  /*#__PURE__*/
  createMixerAction(mixComplex);

  var createVectorAction = function createVectorAction(action, typeTests) {
    var _a = createVectorTests(typeTests),
        testVectorProps = _a.testVectorProps,
        getVectorKeys = _a.getVectorKeys;

    var vectorAction = function vectorAction(props) {
      var isVector = testVectorProps(props);
      if (!isVector) return action(props);
      var vectorKeys = getVectorKeys(props);
      var testKey = vectorKeys[0];
      var testProp = props[testKey];
      return getActionCreator(testProp)(action, props, vectorKeys);
    };

    return vectorAction;
  };

  var getActionCreator = function getActionCreator(prop) {
    if (typeof prop === 'number') {
      return createAction;
    } else if (isUnitProp(prop)) {
      return createUnitAction;
    } else if (color.test(prop)) {
      return createColorAction;
    } else if (complex.test(prop)) {
      return createComplexAction;
    } else {
      return createAction;
    }
  };

  var decay = function decay(props) {
    if (props === void 0) {
      props = {};
    }

    return action(function (_a) {
      var complete = _a.complete,
          update = _a.update;
      var _b = props.velocity,
          velocity = _b === void 0 ? 0 : _b,
          _c = props.from,
          from = _c === void 0 ? 0 : _c,
          _d = props.power,
          power = _d === void 0 ? 0.8 : _d,
          _e = props.timeConstant,
          timeConstant = _e === void 0 ? 350 : _e,
          _f = props.restDelta,
          restDelta = _f === void 0 ? 0.5 : _f,
          modifyTarget = props.modifyTarget;
      var elapsed = 0;
      var amplitude = power * velocity;
      var idealTarget = Math.round(from + amplitude);
      var target = typeof modifyTarget === 'undefined' ? idealTarget : modifyTarget(idealTarget);
      var process = sync.update(function (_a) {
        var frameDelta = _a.delta;
        elapsed += frameDelta;
        var delta = -amplitude * Math.exp(-elapsed / timeConstant);
        var isMoving = delta > restDelta || delta < -restDelta;
        var current = isMoving ? target + delta : target;
        update(current);

        if (!isMoving) {
          cancelSync.update(process);
          complete();
        }
      }, true);
      return {
        stop: function stop() {
          return cancelSync.update(process);
        }
      };
    });
  };

  var vectorDecay =
  /*#__PURE__*/
  createVectorAction(decay, {
    from: number.test,
    modifyTarget: function modifyTarget(func) {
      return typeof func === 'function';
    },
    velocity: number.test
  });

  var spring = function spring(props) {
    if (props === void 0) {
      props = {};
    }

    return action(function (_a) {
      var update = _a.update,
          complete = _a.complete;
      var _b = props.velocity,
          velocity = _b === void 0 ? 0.0 : _b;
      var _c = props.from,
          from = _c === void 0 ? 0.0 : _c,
          _d = props.to,
          to = _d === void 0 ? 0.0 : _d,
          _e = props.stiffness,
          stiffness = _e === void 0 ? 100 : _e,
          _f = props.damping,
          damping = _f === void 0 ? 10 : _f,
          _g = props.mass,
          mass = _g === void 0 ? 1.0 : _g,
          _h = props.restSpeed,
          restSpeed = _h === void 0 ? 0.01 : _h,
          _j = props.restDelta,
          restDelta = _j === void 0 ? 0.01 : _j;
      var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
      var t = 0;
      var delta = to - from;
      var position = from;
      var prevPosition = position;
      var process = sync.update(function (_a) {
        var timeDelta = _a.delta;
        t += timeDelta;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var angularFreq = Math.sqrt(stiffness / mass) / 1000;
        prevPosition = position;

        if (dampingRatio < 1) {
          var envelope = Math.exp(-dampingRatio * angularFreq * t);
          var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
          position = to - envelope * ((initialVelocity + dampingRatio * angularFreq * delta) / expoDecay * Math.sin(expoDecay * t) + delta * Math.cos(expoDecay * t));
        } else {
          var envelope = Math.exp(-angularFreq * t);
          position = to - envelope * (delta + (initialVelocity + angularFreq * delta) * t);
        }

        velocity = velocityPerSecond(position - prevPosition, timeDelta);
        var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
        var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;

        if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
          position = to;
          update(position);
          cancelSync.update(process);
          complete();
        } else {
          update(position);
        }
      }, true);
      return {
        stop: function stop() {
          return cancelSync.update(process);
        }
      };
    });
  };

  var vectorSpring =
  /*#__PURE__*/
  createVectorAction(spring, {
    from: number.test,
    to: number.test,
    stiffness: number.test,
    damping: number.test,
    mass: number.test,
    velocity: number.test
  });

  var inertia = function inertia(_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.velocity,
        velocity = _c === void 0 ? 0 : _c,
        min = _a.min,
        max = _a.max,
        _d = _a.power,
        power = _d === void 0 ? 0.8 : _d,
        _e = _a.timeConstant,
        timeConstant = _e === void 0 ? 700 : _e,
        _f = _a.bounceStiffness,
        bounceStiffness = _f === void 0 ? 500 : _f,
        _g = _a.bounceDamping,
        bounceDamping = _g === void 0 ? 10 : _g,
        _h = _a.restDelta,
        restDelta = _h === void 0 ? 1 : _h,
        modifyTarget = _a.modifyTarget;
    return action(function (_a) {
      var update = _a.update,
          _complete = _a.complete;
      var prev = from;
      var current = from;
      var activeAnimation;
      var isSpring = false;

      var isLessThanMin = function isLessThanMin(v) {
        return min !== undefined && v <= min;
      };

      var isMoreThanMax = function isMoreThanMax(v) {
        return max !== undefined && v >= max;
      };

      var isOutOfBounds = function isOutOfBounds(v) {
        return isLessThanMin(v) || isMoreThanMax(v);
      };

      var isTravellingAwayFromBounds = function isTravellingAwayFromBounds(v, currentVelocity) {
        return isLessThanMin(v) && currentVelocity < 0 || isMoreThanMax(v) && currentVelocity > 0;
      };

      var onUpdate = function onUpdate(v) {
        update(v);
        prev = current;
        current = v;
        velocity = velocityPerSecond(current - prev, getFrameData().delta);

        if (activeAnimation && !isSpring && isTravellingAwayFromBounds(v, velocity)) {
          startSpring({
            from: v,
            velocity: velocity
          });
        }
      };

      var startAnimation = function startAnimation(animation, next) {
        activeAnimation && activeAnimation.stop();
        activeAnimation = animation.start({
          update: onUpdate,
          complete: function complete() {
            if (next) {
              next();
              return;
            }

            _complete();
          }
        });
      };

      var startSpring = function startSpring(props) {
        isSpring = true;
        startAnimation(vectorSpring(_assign({}, props, {
          to: isLessThanMin(props.from) ? min : max,
          stiffness: bounceStiffness,
          damping: bounceDamping,
          restDelta: restDelta
        })));
      };

      if (isOutOfBounds(from)) {
        startSpring({
          from: from,
          velocity: velocity
        });
      } else if (velocity !== 0) {
        var animation = vectorDecay({
          from: from,
          velocity: velocity,
          timeConstant: timeConstant,
          power: power,
          restDelta: isOutOfBounds(from) ? 20 : restDelta,
          modifyTarget: modifyTarget
        });
        startAnimation(animation, function () {
          if (isOutOfBounds(current)) {
            startSpring({
              from: current,
              velocity: velocity
            });
          } else {
            _complete();
          }
        });
      } else {
        _complete();
      }

      return {
        stop: function stop() {
          return activeAnimation && activeAnimation.stop();
        }
      };
    });
  };

  var index$1 =
  /*#__PURE__*/
  createVectorAction(inertia, {
    from: number.test,
    velocity: number.test,
    min: number.test,
    max: number.test,
    damping: number.test,
    stiffness: number.test,
    modifyTarget: function modifyTarget(func) {
      return typeof func === 'function';
    }
  });

  var scrubber = function scrubber(_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.to,
        to = _c === void 0 ? 1 : _c,
        _d = _a.ease,
        ease = _d === void 0 ? linear : _d,
        _e = _a.reverseEase,
        reverseEase = _e === void 0 ? false : _e;

    if (reverseEase) {
      ease = createReversedEasing(ease);
    }

    return action(function (_a) {
      var update = _a.update;
      return {
        seek: function seek(progress) {
          return update(progress);
        }
      };
    }).pipe(ease, function (v) {
      return mix(from, to, v);
    });
  };

  var vectorScrubber =
  /*#__PURE__*/
  createVectorAction(scrubber, {
    ease: function ease(func) {
      return typeof func === 'function';
    },
    from: number.test,
    to: number.test
  });
  var clampProgress$1 =
  /*#__PURE__*/
  clamp$1$1(0, 1);

  var tween = function tween(props) {
    if (props === void 0) {
      props = {};
    }

    return action(function (_a) {
      var update = _a.update,
          complete = _a.complete;
      var _b = props.duration,
          duration = _b === void 0 ? 300 : _b,
          _c = props.ease,
          ease = _c === void 0 ? easeOut : _c,
          _d = props.flip,
          flip = _d === void 0 ? 0 : _d,
          _e = props.loop,
          loop = _e === void 0 ? 0 : _e,
          _f = props.yoyo,
          yoyo = _f === void 0 ? 0 : _f,
          _g = props.repeatDelay,
          repeatDelay = _g === void 0 ? 0 : _g;
      var _h = props.from,
          from = _h === void 0 ? 0 : _h,
          _j = props.to,
          to = _j === void 0 ? 1 : _j,
          _k = props.elapsed,
          elapsed = _k === void 0 ? 0 : _k,
          _l = props.flipCount,
          flipCount = _l === void 0 ? 0 : _l,
          _m = props.yoyoCount,
          yoyoCount = _m === void 0 ? 0 : _m,
          _o = props.loopCount,
          loopCount = _o === void 0 ? 0 : _o;
      var playhead = vectorScrubber({
        from: from,
        to: to,
        ease: ease
      }).start(update);
      var currentProgress = 0;
      var process;
      var _isActive = false;

      var reverseAnimation = function reverseAnimation(reverseEase) {
        var _a;

        if (reverseEase === void 0) {
          reverseEase = false;
        }

        _a = [to, from], from = _a[0], to = _a[1];
        playhead = vectorScrubber({
          from: from,
          to: to,
          ease: ease,
          reverseEase: reverseEase
        }).start(update);
      };

      var isTweenComplete = function isTweenComplete() {
        var isComplete = _isActive && elapsed > duration + repeatDelay;
        if (!isComplete) return false;
        if (isComplete && !loop && !flip && !yoyo) return true;
        var overtime = elapsed - duration;
        elapsed = overtime - repeatDelay;

        if (loop && loopCount < loop) {
          loopCount++;
          return false;
        } else if (flip && flipCount < flip) {
          flipCount++;
          reverseAnimation();
          return false;
        } else if (yoyo && yoyoCount < yoyo) {
          yoyoCount++;
          reverseAnimation(yoyoCount % 2 !== 0);
          return false;
        }

        return true;
      };

      var updateTween = function updateTween() {
        currentProgress = clampProgress$1(progress(0, duration, elapsed));
        playhead.seek(currentProgress);
      };

      var startTimer = function startTimer() {
        _isActive = true;
        process = sync.update(function (_a) {
          var delta = _a.delta;
          elapsed += delta;
          updateTween();

          if (isTweenComplete()) {
            cancelSync.update(process);
            complete && sync.update(complete, false, true);
          }
        }, true);
      };

      var stopTimer = function stopTimer() {
        _isActive = false;
        if (process) cancelSync.update(process);
      };

      startTimer();
      return {
        isActive: function isActive() {
          return _isActive;
        },
        getElapsed: function getElapsed() {
          return clamp$1$1(0, duration, elapsed);
        },
        getProgress: function getProgress() {
          return currentProgress;
        },
        stop: function stop() {
          stopTimer();
        },
        pause: function pause() {
          stopTimer();
          return this;
        },
        resume: function resume() {
          if (!_isActive) startTimer();
          return this;
        },
        seek: function seek(newProgress) {
          elapsed = mix(0, duration, newProgress);
          sync.update(updateTween, false, true);
          return this;
        },
        reverse: function reverse() {
          reverseAnimation();
          return this;
        }
      };
    });
  };

  var clampProgress$1$1 =
  /*#__PURE__*/
  clamp$1$1(0, 1);

  var defaultEasings = function defaultEasings(values, easing) {
    return values.map(function () {
      return easing || easeOut;
    }).splice(0, values.length - 1);
  };

  var defaultTimings = function defaultTimings(values) {
    var numValues = values.length;
    return values.map(function (value, i) {
      return i !== 0 ? i / (numValues - 1) : 0;
    });
  };

  var interpolateScrubbers = function interpolateScrubbers(input, scrubbers, update) {
    var rangeLength = input.length;
    var finalInputIndex = rangeLength - 1;
    var finalScrubberIndex = finalInputIndex - 1;
    var subs = scrubbers.map(function (scrub) {
      return scrub.start(update);
    });
    return function (v) {
      if (v <= input[0]) {
        subs[0].seek(0);
      }

      if (v >= input[finalInputIndex]) {
        subs[finalScrubberIndex].seek(1);
      }

      var i = 1;

      for (; i < rangeLength; i++) {
        if (input[i] > v || i === finalInputIndex) break;
      }

      var progressInRange = progress(input[i - 1], input[i], v);
      subs[i - 1].seek(clampProgress$1$1(progressInRange));
    };
  };

  var keyframes = function keyframes(_a) {
    var easings = _a.easings,
        _b = _a.ease,
        ease = _b === void 0 ? linear : _b,
        times = _a.times,
        values = _a.values,
        tweenProps = __rest(_a, ["easings", "ease", "times", "values"]);

    easings = Array.isArray(easings) ? easings : defaultEasings(values, easings);
    times = times || defaultTimings(values);
    var scrubbers = easings.map(function (easing, i) {
      return vectorScrubber({
        from: values[i],
        to: values[i + 1],
        ease: easing
      });
    });
    return tween(_assign({}, tweenProps, {
      ease: ease
    })).applyMiddleware(function (update) {
      return interpolateScrubbers(times, scrubbers, update);
    });
  };

  var listen = function listen(element, events, options) {
    return action(function (_a) {
      var update = _a.update;
      var eventNames = events.split(' ').map(function (eventName) {
        element.addEventListener(eventName, update, options);
        return eventName;
      });
      return {
        stop: function stop() {
          return eventNames.forEach(function (eventName) {
            return element.removeEventListener(eventName, update, options);
          });
        }
      };
    });
  };

  var defaultPointerPos = function defaultPointerPos() {
    return {
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      x: 0,
      y: 0
    };
  };

  var eventToPoint = function eventToPoint(e, point) {
    if (point === void 0) {
      point = defaultPointerPos();
    }

    point.clientX = point.x = e.clientX;
    point.clientY = point.y = e.clientY;
    point.pageX = e.pageX;
    point.pageY = e.pageY;
    return point;
  };

  var points = [
  /*#__PURE__*/
  defaultPointerPos()];

  if (typeof document !== 'undefined') {
    var updatePointsLocation = function updatePointsLocation(_a) {
      var touches = _a.touches;
      var numTouches = touches.length;
      points.length = 0;

      for (var i = 0; i < numTouches; i++) {
        var thisTouch = touches[i];
        points.push(eventToPoint(thisTouch));
      }
    };

    listen(document, 'touchstart touchmove', {
      passive: true,
      capture: true
    }).start(updatePointsLocation);
  }

  var point =
  /*#__PURE__*/
  defaultPointerPos();

  if (typeof document !== 'undefined') {
    var updatePointLocation = function updatePointLocation(e) {
      eventToPoint(e, point);
    };

    listen(document, 'mousedown mousemove', true).start(updatePointLocation);
  }

  var delay = function delay(timeToDelay) {
    return action(function (_a) {
      var complete = _a.complete;
      var timeout = setTimeout(complete, timeToDelay);
      return {
        stop: function stop() {
          return clearTimeout(timeout);
        }
      };
    });
  };

  var isFloat = function isFloat(value) {
    return !isNaN(parseFloat(value));
  };
  /**
   * `MotionValue` is used to track the state and velocity of motion values.
   *
   * @public
   */


  var MotionValue =
  /** @class */
  function () {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    function MotionValue(init, _a) {
      var _this = this;

      var _b = _a === void 0 ? {} : _a,
          transformer = _b.transformer,
          parent = _b.parent;
      /**
       * Duration, in milliseconds, since last updating frame.
       *
       * @internal
       */


      this.timeDelta = 0;
      /**
       * Timestamp of the last time this `MotionValue` was updated.
       *
       * @internal
       */

      this.lastUpdated = 0;
      /**
       * Tracks whether this value can output a velocity. Currently this is only true
       * if the value is numerical, but we might be able to widen the scope here and support
       * other value types.
       *
       * @internal
       */

      this.canTrackVelocity = false;

      this.updateAndNotify = function (v, render) {
        if (render === void 0) {
          render = true;
        }

        _this.prev = _this.current;
        _this.current = _this.transformer ? _this.transformer(v) : v;

        if (_this.updateSubscribers && _this.prev !== _this.current) {
          _this.updateSubscribers.forEach(_this.notifySubscriber);
        }

        if (_this.children) {
          _this.children.forEach(_this.setChild);
        }

        if (render && _this.renderSubscribers) {
          _this.renderSubscribers.forEach(_this.notifySubscriber);
        } // Update timestamp


        var _a = getFrameData(),
            delta = _a.delta,
            timestamp = _a.timestamp;

        if (_this.lastUpdated !== timestamp) {
          _this.timeDelta = delta;
          _this.lastUpdated = timestamp;
          sync.postRender(_this.scheduleVelocityCheck);
        }
      };
      /**
       * Notify a subscriber with the latest value.
       *
       * This is an instanced and bound function to prevent generating a new
       * function once per frame.
       *
       * @param subscriber - The subscriber to notify.
       *
       * @internal
       */


      this.notifySubscriber = function (subscriber) {
        subscriber(_this.current);
      };
      /**
       * Schedule a velocity check for the next frame.
       *
       * This is an instanced and bound function to prevent generating a new
       * function once per frame.
       *
       * @internal
       */


      this.scheduleVelocityCheck = function () {
        return sync.postRender(_this.velocityCheck);
      };
      /**
       * Updates `prev` with `current` if the value hasn't been updated this frame.
       * This ensures velocity calculations return `0`.
       *
       * This is an instanced and bound function to prevent generating a new
       * function once per frame.
       *
       * @internal
       */


      this.velocityCheck = function (_a) {
        var timestamp = _a.timestamp;

        if (timestamp !== _this.lastUpdated) {
          _this.prev = _this.current;
        }
      };
      /**
       * Updates child `MotionValue`.
       *
       * @param child - Child `MotionValue`.
       *
       * @internal
       */


      this.setChild = function (child) {
        return child.set(_this.current);
      };

      this.parent = parent;
      this.transformer = transformer;
      this.set(init, false);
      this.canTrackVelocity = isFloat(this.current);
    }
    /**
     * Creates a new `MotionValue` that's subscribed to the output of this one.
     *
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */


    MotionValue.prototype.addChild = function (config) {
      if (config === void 0) {
        config = {};
      }

      var child = new MotionValue(this.current, _assign({
        parent: this
      }, config));
      if (!this.children) this.children = new Set();
      this.children.add(child);
      return child;
    };
    /**
     * Stops a `MotionValue` from being subscribed to this one.
     *
     * @param child - The subscribed `MotionValue`
     *
     * @internal
     */


    MotionValue.prototype.removeChild = function (child) {
      if (!this.children) {
        return;
      }

      this.children.delete(child);
    };
    /**
     * Subscribes a subscriber function to a subscription list.
     *
     * @param subscriptions - A `Set` of subscribers.
     * @param subscription - A subscriber function.
     */


    MotionValue.prototype.subscribeTo = function (subscriptions, subscription) {
      var _this = this;

      var updateSubscriber = function updateSubscriber() {
        return subscription(_this.current);
      };

      subscriptions.add(updateSubscriber);
      return function () {
        return subscriptions.delete(updateSubscriber);
      };
    };
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */


    MotionValue.prototype.onChange = function (subscription) {
      if (!this.updateSubscribers) this.updateSubscribers = new Set();
      return this.subscribeTo(this.updateSubscribers, subscription);
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */


    MotionValue.prototype.onRenderRequest = function (subscription) {
      if (!this.renderSubscribers) this.renderSubscribers = new Set(); // Render immediately

      this.notifySubscriber(subscription);
      return this.subscribeTo(this.renderSubscribers, subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */


    MotionValue.prototype.attach = function (passiveEffect) {
      this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */


    MotionValue.prototype.set = function (v, render) {
      if (render === void 0) {
        render = true;
      }

      if (!render || !this.passiveEffect) {
        this.updateAndNotify(v, render);
      } else {
        this.passiveEffect(v, this.updateAndNotify);
      }
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */


    MotionValue.prototype.get = function () {
      return this.current;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */


    MotionValue.prototype.getVelocity = function () {
      // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
      return this.canTrackVelocity ? // These casts could be avoided if parseFloat would be typed better
      velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */


    MotionValue.prototype.start = function (animation) {
      var _this = this;

      this.stop();
      return new Promise(function (resolve) {
        _this.stopAnimation = animation(resolve);
      }).then(function () {
        return _this.clearAnimation();
      });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */


    MotionValue.prototype.stop = function () {
      if (this.stopAnimation) this.stopAnimation();
      this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */


    MotionValue.prototype.isAnimating = function () {
      return !!this.stopAnimation;
    };

    MotionValue.prototype.clearAnimation = function () {
      this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */


    MotionValue.prototype.destroy = function () {
      this.updateSubscribers && this.updateSubscribers.clear();
      this.renderSubscribers && this.renderSubscribers.clear();
      this.parent && this.parent.removeChild(this);
      this.stop();
    };

    return MotionValue;
  }();
  /**
   * @internal
   */


  function motionValue(init, opts) {
    return new MotionValue(init, opts);
  }
  /**
   * Creates a constant value over the lifecycle of a component.
   *
   * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
   * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
   * you can ensure that initialisers don't execute twice or more.
   */


  function useConstant(init) {
    var ref = React.useRef(null);

    if (ref.current === null) {
      ref.current = init();
    }

    return ref.current;
  }

  var isMotionValue = function isMotionValue(value) {
    return value instanceof MotionValue;
  }; // Creating a styler factory for the `onUpdate` prop allows all values
  // to fire and the `onUpdate` prop will only fire once per frame


  var updateStyler = createStyler({
    onRead: function onRead() {
      return null;
    },
    onRender: function onRender(state, _a) {
      var onUpdate = _a.onUpdate;
      return onUpdate(state);
    }
  });

  var MotionValuesMap =
  /** @class */
  function () {
    function MotionValuesMap() {
      this.hasMounted = false;
      this.values = new Map();
      this.unsubscribers = new Map();
    }

    MotionValuesMap.prototype.has = function (key) {
      return this.values.has(key);
    };

    MotionValuesMap.prototype.set = function (key, value) {
      this.values.set(key, value);

      if (this.hasMounted) {
        this.bindValueToOutput(key, value);
      }
    };

    MotionValuesMap.prototype.get = function (key, defaultValue) {
      var value = this.values.get(key);

      if (value === undefined && defaultValue !== undefined) {
        value = new MotionValue(defaultValue);
        this.set(key, value);
      }

      return value;
    };

    MotionValuesMap.prototype.forEach = function (callback) {
      return this.values.forEach(callback);
    };

    MotionValuesMap.prototype.bindValueToOutput = function (key, value) {
      var _this = this;

      var onRender = function onRender(v) {
        return _this.output && _this.output(key, v);
      };

      var unsubscribeOnRender = value.onRenderRequest(onRender);

      var onChange = function onChange(v) {
        _this.onUpdate && _this.onUpdate.set(key, v);
      };

      var unsubscribeOnChange = value.onChange(onChange);

      if (this.unsubscribers.has(key)) {
        this.unsubscribers.get(key)();
      }

      this.unsubscribers.set(key, function () {
        unsubscribeOnRender();
        unsubscribeOnChange();
      });
    };

    MotionValuesMap.prototype.setOnUpdate = function (onUpdate) {
      this.onUpdate = undefined;

      if (onUpdate) {
        this.onUpdate = updateStyler({
          onUpdate: onUpdate
        });
      }
    };

    MotionValuesMap.prototype.setTransformTemplate = function (transformTemplate) {
      if (this.transformTemplate !== transformTemplate) {
        this.transformTemplate = transformTemplate;
        this.updateTransformTemplate();
      }
    };

    MotionValuesMap.prototype.getTransformTemplate = function () {
      return this.transformTemplate;
    };

    MotionValuesMap.prototype.updateTransformTemplate = function () {
      if (this.output) {
        this.output("transform", this.transformTemplate);
      }
    };

    MotionValuesMap.prototype.mount = function (output) {
      var _this = this;

      this.hasMounted = true;
      if (output) this.output = output;
      this.values.forEach(function (value, key) {
        return _this.bindValueToOutput(key, value);
      });
      this.updateTransformTemplate();
    };

    MotionValuesMap.prototype.unmount = function () {
      var _this = this;

      this.values.forEach(function (_value, key) {
        var unsubscribe = _this.unsubscribers.get(key);

        unsubscribe && unsubscribe();
      });
    };

    return MotionValuesMap;
  }();

  var specialMotionValueProps = new Set(["dragOriginX", "dragOriginY"]);

  var useMotionValues = function useMotionValues(props) {
    var motionValues = useConstant(function () {
      var map = new MotionValuesMap();
      /**
       * Loop through every prop and add any detected `MotionValue`s. This is SVG-specific
       * code that should be extracted, perhaps considered hollistically with `useMotionStyles`.
       *
       * <motion.circle cx={motionValue(0)} />
       */

      for (var key in props) {
        if (isMotionValue(props[key]) && !specialMotionValueProps.has(key)) {
          map.set(key, props[key]);
        }
      }

      return map;
    });
    motionValues.setOnUpdate(props.onUpdate);
    motionValues.setTransformTemplate(props.transformTemplate);
    return motionValues;
  };

  var session = null;
  var syncRenderSession = {
    isOpen: function isOpen() {
      return session !== null;
    },
    open: function open() {
      invariant(!session, "Sync render session already open");
      session = [];
    },
    flush: function flush() {
      invariant(session !== null, "No sync render session found");
      session && session.forEach(function (styler) {
        return styler.render();
      });
      session = null;
    },
    push: function push(styler) {
      invariant(session !== null, "No sync render session found");
      session && session.push(styler);
    }
  };
  /**
   * `useEffect` gets resolved bottom-up. We defer some optional functionality to child
   * components, so to ensure everything runs correctly we export the ref-binding logic
   * to a new component rather than in `useMotionValues`.
   */

  var MountComponent = function MountComponent(_a) {
    var ref = _a.innerRef,
        values = _a.values,
        isStatic = _a.isStatic;
    React.useEffect(function () {
      invariant(ref.current instanceof Element, "No `ref` found. Ensure components created with `motion.custom` forward refs using `React.forwardRef`");
      var domStyler = index(ref.current, {
        preparseOutput: false,
        enableHardwareAcceleration: !isStatic
      });
      values.mount(function (key, value) {
        domStyler.set(key, value);

        if (syncRenderSession.isOpen()) {
          syncRenderSession.push(domStyler);
        }
      });
      return function () {
        return values.unmount();
      };
    }, []);
    return null;
  };

  var Mount =
  /*#__PURE__*/
  React.memo(MountComponent);

  var createValueResolver = function createValueResolver(resolver) {
    return function (values) {
      var resolvedValues = {};
      values.forEach(function (value, key) {
        return resolvedValues[key] = resolver(value);
      });
      return resolvedValues;
    };
  };

  var resolveCurrent = createValueResolver(function (value) {
    return value.get();
  });
  var transformOriginProps$1 = new Set(["originX", "originY", "originZ"]);

  var isTransformOriginProp$1 = function isTransformOriginProp$1(key) {
    return transformOriginProps$1.has(key);
  };

  var buildStyleAttr = function buildStyleAttr(values, styleProp, isStatic) {
    var motionValueStyles = resolveCurrent(values);
    var transformTemplate = values.getTransformTemplate();

    if (transformTemplate) {
      // If `transform` has been manually set as a string, pass that through the template
      // otherwise pass it forward to Stylefire's style property builder
      motionValueStyles.transform = styleProp.transform ? transformTemplate({}, styleProp.transform) : transformTemplate;
    }

    return buildStyleProperty(_assign(_assign({}, styleProp), motionValueStyles), !isStatic);
  };

  var useMotionStyles = function useMotionStyles(values, styleProp, isStatic, transformValues) {
    if (styleProp === void 0) {
      styleProp = {};
    }

    var style = {};
    var prevMotionStyles = React.useRef({}).current;

    for (var key in styleProp) {
      var thisStyle = styleProp[key];

      if (isMotionValue(thisStyle)) {
        // If this is a motion value, add it to our MotionValuesMap
        values.set(key, thisStyle);
      } else if (!isStatic && (isTransformProp(key) || isTransformOriginProp$1(key))) {
        // Or if it's a transform prop, create a motion value (or update an existing one)
        // to ensure Stylefire can reconcile all the transform values together.
        // A further iteration on this would be to create a single styler per component that gets
        // used in the DOM renderer's buildStyleAttr *and* animations, then we would only
        // have to convert animating values to `MotionValues` (we could probably remove this entire function).
        // The only architectural consideration is to allow Stylefire to have elements mounted after
        // a styler is created.
        if (!values.has(key)) {
          // If it doesn't exist as a motion value, create it
          values.set(key, motionValue(thisStyle));
        } else {
          // Otherwise only update it if it's changed from a previous render
          if (thisStyle !== prevMotionStyles[key]) {
            var value = values.get(key);
            value.set(thisStyle);
          }
        }

        prevMotionStyles[key] = thisStyle;
      } else {
        style[key] = thisStyle;
      }
    }

    return transformValues ? transformValues(style) : style;
  };

  var isKeyframesTarget = function isKeyframesTarget(v) {
    return Array.isArray(v);
  };

  var resolveFinalValueInKeyframes = function resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
  };

  var auto = {
    test: function test(v) {
      return v === "auto";
    },
    parse: function parse(v) {
      return v;
    }
  };
  var dimensionTypes = [number, px, percent, degrees, vw, vh, auto];

  var valueTypes$1 = __spreadArrays(dimensionTypes, [color, complex]);

  var testValueType = function testValueType(v) {
    return function (type) {
      return type.test(v);
    };
  };

  var getDimensionValueType = function getDimensionValueType(v) {
    return dimensionTypes.find(testValueType(v));
  };

  var getValueType$1 = function getValueType$1(v) {
    return valueTypes$1.find(testValueType(v));
  };

  var underDampedSpring = function underDampedSpring() {
    return {
      type: "spring",
      stiffness: 500,
      damping: 25,
      restDelta: 0.5,
      restSpeed: 10
    };
  };

  var overDampedSpring = function overDampedSpring(to) {
    return {
      type: "spring",
      stiffness: 700,
      damping: to === 0 ? 100 : 35
    };
  };

  var linearTween = function linearTween() {
    return {
      ease: "linear",
      duration: 0.3
    };
  };

  var keyframes$1 = function keyframes$1(values) {
    return {
      type: "keyframes",
      duration: 0.8,
      values: values
    };
  };

  var defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: overDampedSpring,
    scaleY: overDampedSpring,
    scale: overDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: overDampedSpring
  };

  var getDefaultTransition = function getDefaultTransition(valueKey, to) {
    var transitionFactory;

    if (isKeyframesTarget(to)) {
      transitionFactory = keyframes$1;
    } else {
      transitionFactory = defaultTransitions[valueKey] || defaultTransitions.default;
    }

    return _assign({
      to: to
    }, transitionFactory(to));
  };
  /**
   * A Popmotion action that accepts a single `to` prop. When it starts, it immediately
   * updates with `to` and then completes. By using this we can compose instant transitions
   * in with the same logic that applies `delay` or returns a `Promise` etc.
   *
   * Accepting `duration` is a little bit of a hack that simply defers the completetion of
   * the animation until after the duration finishes. This is for situations when you're **only**
   * animating non-animatable values and then setting something on `transitionEnd`. Really
   * you want this to fire after the "animation" finishes, rather than instantly.
   *
   * ```
   * animate={{
   *   display: 'block',
   *   transitionEnd: { display: 'none' }
   * }}
   * ```
   */


  var just = function just(_a) {
    var to = _a.to,
        duration = _a.duration;
    return action(function (_a) {
      var update = _a.update,
          complete = _a.complete;
      update(to);
      duration ? delay(duration).start({
        complete: complete
      }) : complete();
    });
  };

  var easingDefinitionToFunction = function easingDefinitionToFunction(definition) {
    if (Array.isArray(definition)) {
      // If cubic bezier definition, create bezier curve
      invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
      var x1 = definition[0],
          y1 = definition[1],
          x2 = definition[2],
          y2 = definition[3];
      return cubicBezier(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
      // Else lookup from table
      invariant(easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
      return easingLookup[definition];
    }

    return definition;
  };

  var isEasingArray = function isEasingArray(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
  };

  var isDurationAnimation = function isDurationAnimation(v) {
    return v.hasOwnProperty("duration") || v.hasOwnProperty("repeatDelay");
  };
  /**
   * Check if a value is animatable. Examples:
   *
   * ✅: 100, "100px", "#fff"
   * ❌: "block", "url(2.jpg)"
   * @param value
   *
   * @internal
   */


  var isAnimatable = function isAnimatable(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false; // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons

    if (typeof value === "number" || Array.isArray(value)) return true;

    if (typeof value === "string" && // It's animatable if we have a string
    complex.test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
      }

    return false;
  };
  /**
   * Converts seconds to milliseconds
   *
   * @param seconds - Time in seconds.
   * @return milliseconds - Converted time in milliseconds.
   */


  var secondsToMilliseconds = function secondsToMilliseconds(seconds) {
    return seconds * 1000;
  };

  var transitions = {
    tween: tween,
    spring: vectorSpring,
    keyframes: keyframes,
    inertia: index$1,
    just: just
  };
  var transitionOptionParser = {
    tween: function tween(opts) {
      if (opts.ease) {
        var ease = isEasingArray(opts.ease) ? opts.ease[0] : opts.ease;
        opts.ease = easingDefinitionToFunction(ease);
      }

      return opts;
    },
    keyframes: function keyframes(_a) {
      var from = _a.from,
          to = _a.to,
          velocity = _a.velocity,
          opts = __rest(_a, ["from", "to", "velocity"]);

      if (opts.values && opts.values[0] === null) {
        var values = __spreadArrays(opts.values);

        values[0] = from;
        opts.values = values;
      }

      if (opts.ease) {
        opts.easings = isEasingArray(opts.ease) ? opts.ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(opts.ease);
      }

      opts.ease = linear;
      return opts;
    }
  };

  var isTransitionDefined = function isTransitionDefined(_a) {
    var when = _a.when,
        delay = _a.delay,
        delayChildren = _a.delayChildren,
        staggerChildren = _a.staggerChildren,
        staggerDirection = _a.staggerDirection,
        transition = __rest(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection"]);

    return Object.keys(transition).length;
  };

  var getTransitionDefinition = function getTransitionDefinition(key, to, transitionDefinition) {
    var delay = transitionDefinition ? transitionDefinition.delay : 0; // If no object, return default transition
    // A better way to handle this would be to deconstruct out all the shared Orchestration props
    // and see if there's any props remaining

    if (transitionDefinition === undefined || !isTransitionDefined(transitionDefinition)) {
      return _assign({
        delay: delay
      }, getDefaultTransition(key, to));
    }

    var valueTransitionDefinition = transitionDefinition[key] || transitionDefinition.default || transitionDefinition;

    if (valueTransitionDefinition.type === false) {
      return {
        delay: valueTransitionDefinition.hasOwnProperty("delay") ? valueTransitionDefinition.delay : delay,
        to: isKeyframesTarget(to) ? to[to.length - 1] : to,
        type: "just"
      };
    } else if (isKeyframesTarget(to)) {
      return _assign(_assign({
        values: to,
        duration: 0.8,
        delay: delay,
        ease: "linear"
      }, valueTransitionDefinition), {
        // This animation must be keyframes if we're animating through an array
        type: "keyframes"
      });
    } else {
      return _assign({
        type: "tween",
        to: to,
        delay: delay
      }, valueTransitionDefinition);
    }
  };

  var preprocessOptions = function preprocessOptions(type, opts) {
    return transitionOptionParser[type] ? transitionOptionParser[type](opts) : opts;
  };

  var getAnimation = function getAnimation(key, value, target, transition) {
    var origin = value.get();
    var isOriginAnimatable = isAnimatable(key, origin);
    var isTargetAnimatable = isAnimatable(key, target); // TODO we could probably improve this check to ensure both values are of the same type -
    // for instance 100 to #fff. This might live better in Popmotion.

    warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to " + target + ". \"" + origin + "\" is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property."); // Parse the `transition` prop and return options for the Popmotion animation

    var _a = getTransitionDefinition(key, target, transition),
        _b = _a.type,
        type = _b === void 0 ? "tween" : _b,
        transitionDefinition = __rest(_a, ["type"]); // If this is an animatable pair of values, return an animation, otherwise use `just`


    var actionFactory = isOriginAnimatable && isTargetAnimatable ? transitions[type] : just;
    var opts = preprocessOptions(type, _assign({
      from: origin,
      velocity: value.getVelocity()
    }, transitionDefinition)); // Convert duration from Framer Motion's seconds into Popmotion's milliseconds

    if (isDurationAnimation(opts)) {
      if (opts.duration) {
        opts.duration = secondsToMilliseconds(opts.duration);
      }

      if (opts.repeatDelay) {
        opts.repeatDelay = secondsToMilliseconds(opts.repeatDelay);
      }
    }

    return [actionFactory, opts];
  };
  /**
   * Start animation on a value. This function completely encapsulates Popmotion-specific logic.
   *
   * @internal
   */


  function startAnimation(key, value, target, _a) {
    var _b = _a.delay,
        delay$1 = _b === void 0 ? 0 : _b,
        transition = __rest(_a, ["delay"]);

    return value.start(function (complete) {
      var activeAnimation;

      var _a = getAnimation(key, value, target, transition),
          animationFactory = _a[0],
          _b = _a[1],
          valueDelay = _b.delay,
          options = __rest(_b, ["delay"]);

      if (valueDelay !== undefined) {
        delay$1 = valueDelay;
      }

      var animate = function animate() {
        var animation = animationFactory(options); // Bind animation opts to animation

        activeAnimation = animation.start({
          update: function update(v) {
            return value.set(v);
          },
          complete: complete
        });
      }; // If we're delaying this animation, only resolve it **after** the delay to
      // ensure the value's resolve velocity is up-to-date.


      if (delay$1) {
        activeAnimation = delay(secondsToMilliseconds(delay$1)).start({
          complete: animate
        });
      } else {
        animate();
      }

      return function () {
        if (activeAnimation) activeAnimation.stop();
      };
    });
  }
  /**
   * Get the current value of every `MotionValue`
   * @param values -
   */


  var getCurrent = function getCurrent(values) {
    var current = {};
    values.forEach(function (value, key) {
      return current[key] = value.get();
    });
    return current;
  };
  /**
   * Get the current velocity of every `MotionValue`
   * @param values -
   */


  var getVelocity = function getVelocity(values) {
    var velocity = {};
    values.forEach(function (value, key) {
      return velocity[key] = value.getVelocity();
    });
    return velocity;
  };
  /**
   * Check if value is a function that returns a `Target`. A generic typeof === 'function'
   * check, just helps with typing.
   * @param p -
   */


  var isTargetResolver = function isTargetResolver(p) {
    return typeof p === "function";
  };
  /**
   * Check if value is a list of variant labels
   * @param v -
   */


  var isVariantLabels = function isVariantLabels(v) {
    return Array.isArray(v);
  };
  /**
   * Check if value is a numerical string, ie "100" or "100px"
   */


  var isNumericalString = function isNumericalString(v) {
    return /^\d*\.?\d+$/.test(v);
  };
  /**
   * Control animations for a single component
   *
   * @internal
   */


  var ValueAnimationControls =
  /** @class */
  function () {
    function ValueAnimationControls(_a) {
      var _this = this;

      var values = _a.values,
          readValueFromSource = _a.readValueFromSource,
          makeTargetAnimatable = _a.makeTargetAnimatable;
      /**
       * A reference to the component's latest props. We could probably ditch this in
       * favour to a reference to the `custom` prop now we don't send all props through
       * to target resolvers.
       */

      this.props = {};
      /**
       * The component's variants, as provided by `variants`
       */

      this.variants = {};
      /**
       * A set of values that we animate back to when a value is cleared of all overrides.
       */

      this.baseTarget = {};
      /**
       * A series of target overrides that we can animate to/from when overrides are set/cleared.
       */

      this.overrides = [];
      /**
       * A series of target overrides as they were originally resolved.
       */

      this.resolvedOverrides = [];
      /**
       * A Set of currently active override indexes
       */

      this.activeOverrides = new Set();
      /**
       * A Set of value keys that are currently animating.
       */

      this.isAnimating = new Set();
      /**
       * Check if the associated `MotionValueMap` has a key with the provided string.
       * Pre-bound to the class so we can provide directly to the `filter` in `checkForNewValues`.
       */

      this.hasValue = function (key) {
        return !_this.values.has(key);
      };

      this.values = values;
      this.readValueFromSource = readValueFromSource;
      this.makeTargetAnimatable = makeTargetAnimatable;
      this.values.forEach(function (value, key) {
        return _this.baseTarget[key] = value.get();
      });
    }
    /**
     * Set the reference to the component's props.
     * @param props -
     */


    ValueAnimationControls.prototype.setProps = function (props) {
      this.props = props;
    };
    /**
     * Set the reference to the component's variants
     * @param variants -
     */


    ValueAnimationControls.prototype.setVariants = function (variants) {
      if (variants) this.variants = variants;
    };
    /**
     * Set the component's default transition
     * @param transition -
     */


    ValueAnimationControls.prototype.setDefaultTransition = function (transition) {
      if (transition) this.defaultTransition = transition;
    };
    /**
     * Set motion values without animation.
     *
     * @param definition -
     * @param isActive -
     */


    ValueAnimationControls.prototype.setValues = function (definition, _a) {
      var _this = this;

      var _b = _a === void 0 ? {} : _a,
          _c = _b.isActive,
          isActive = _c === void 0 ? new Set() : _c,
          priority = _b.priority;

      var _d = this.resolveVariant(definition),
          target = _d.target,
          transitionEnd = _d.transitionEnd;

      target = this.transformValues(_assign(_assign({}, target), transitionEnd));
      return Object.keys(target).forEach(function (key) {
        if (isActive.has(key)) return;
        isActive.add(key);

        if (target) {
          var targetValue = resolveFinalValueInKeyframes(target[key]);

          if (_this.values.has(key)) {
            var value = _this.values.get(key);

            value && value.set(targetValue);
          } else {
            _this.values.set(key, motionValue(targetValue));
          }

          if (!priority) _this.baseTarget[key] = targetValue;
        }
      });
    };
    /**
     * Allows `transformValues` to be set by a component that allows us to
     * transform the values in a given `Target`. This allows Framer Library
     * to extend Framer Motion to animate `Color` variables etc. Currently we have
     * to manually support these extended types here in Framer Motion.
     *
     * @param values -
     */


    ValueAnimationControls.prototype.transformValues = function (values) {
      var transformValues = this.props.transformValues;
      return transformValues ? transformValues(values) : values;
    };
    /**
     * Check a `Target` for new values we haven't animated yet, and add them
     * to the `MotionValueMap`.
     *
     * Currently there's functionality here that is DOM-specific, we should allow
     * this functionality to be injected by the factory that creates DOM-specific
     * components.
     *
     * @param target -
     */


    ValueAnimationControls.prototype.checkForNewValues = function (target) {
      var newValueKeys = Object.keys(target).filter(this.hasValue);
      var numNewValues = newValueKeys.length;
      if (!numNewValues) return;

      for (var i = 0; i < numNewValues; i++) {
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null; // If this is a keyframes value, we can attempt to use the first value in the
        // array as that's going to be the first value of the animation anyway

        if (Array.isArray(targetValue)) {
          value = targetValue[0];
        } // If it isn't a keyframes or the first keyframes value was set as `null`, read the
        // value from the DOM. It might be worth investigating whether to check props (for SVG)
        // or props.style (for HTML) if the value exists there before attempting to read.


        if (value === null) {
          value = this.readValueFromSource(key);
          invariant(value !== null, "No initial value for \"" + key + "\" can be inferred. Ensure an initial value for \"" + key + "\" is defined on the component.");
        }

        if (typeof value === "string" && isNumericalString(value)) {
          // If this is a number read as a string, ie "0" or "200", convert it to a number
          value = parseFloat(value);
        } else if (!getValueType$1(value) && complex.test(targetValue)) {
          // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
          value = complex.getAnimatableNone(targetValue);
        }

        this.values.set(key, motionValue(value));
        this.baseTarget[key] = value;
      }
    };
    /**
     * Resolve a variant from its label or resolver into an actual `Target` we can animate to.
     * @param variant -
     */


    ValueAnimationControls.prototype.resolveVariant = function (variant) {
      if (!variant) {
        return {
          target: undefined,
          transition: undefined,
          transitionEnd: undefined
        };
      }

      if (isTargetResolver(variant)) {
        // resolve current and velocity
        variant = variant(this.props.custom, getCurrent(this.values), getVelocity(this.values));
      }

      var _a = variant.transition,
          transition = _a === void 0 ? this.defaultTransition : _a,
          transitionEnd = variant.transitionEnd,
          target = __rest(variant, ["transition", "transitionEnd"]);

      return {
        transition: transition,
        transitionEnd: transitionEnd,
        target: target
      };
    };
    /**
     * Get the highest active override priority index
     */


    ValueAnimationControls.prototype.getHighestPriority = function () {
      if (!this.activeOverrides.size) return 0;
      return Math.max.apply(Math, Array.from(this.activeOverrides));
    };
    /**
     * Set an override. We add this layer of indirection so if, for instance, a tap gesture
     * starts and overrides a hover gesture, when we clear the tap gesture and fallback to the
     * hover gesture, if that hover gesture has changed in the meantime we can go to that rather
     * than the one that was resolved when the hover gesture animation started.
     *
     * @param definition -
     * @param overrideIndex -
     */


    ValueAnimationControls.prototype.setOverride = function (definition, overrideIndex) {
      this.overrides[overrideIndex] = definition;

      if (this.children) {
        this.children.forEach(function (child) {
          return child.setOverride(definition, overrideIndex);
        });
      }
    };
    /**
     * Start an override animation.
     * @param overrideIndex -
     */


    ValueAnimationControls.prototype.startOverride = function (overrideIndex) {
      var override = this.overrides[overrideIndex];

      if (override) {
        return this.start(override, {
          priority: overrideIndex
        });
      }
    };
    /**
     * Clear an override. We check every value we animated to in this override to see if
     * its present on any lower-priority overrides. If not, we animate it back to its base target.
     * @param overrideIndex -
     */


    ValueAnimationControls.prototype.clearOverride = function (overrideIndex) {
      var _this = this;

      if (this.children) {
        this.children.forEach(function (child) {
          return child.clearOverride(overrideIndex);
        });
      }

      var override = this.overrides[overrideIndex];
      if (!override) return;
      this.activeOverrides.delete(overrideIndex);
      var highest = this.getHighestPriority();
      this.resetIsAnimating();

      if (highest) {
        var highestOverride = this.overrides[highest];
        highestOverride && this.startOverride(highest);
      } // Figure out which remaining values were affected by the override and animate those


      var overrideTarget = this.resolvedOverrides[overrideIndex];
      if (!overrideTarget) return;
      var remainingValues = {};

      for (var key in this.baseTarget) {
        if (overrideTarget[key] !== undefined) {
          remainingValues[key] = this.baseTarget[key];
        }
      }

      this.onStart();
      this.animate(remainingValues).then(function () {
        return _this.onComplete();
      });
    };
    /**
     * Apply a target/variant without any animation
     */


    ValueAnimationControls.prototype.apply = function (definition) {
      if (Array.isArray(definition)) {
        return this.applyVariantLabels(definition);
      } else if (typeof definition === "string") {
        return this.applyVariantLabels([definition]);
      } else {
        this.setValues(definition);
      }
    };
    /**
     * Apply variant labels without animation
     */


    ValueAnimationControls.prototype.applyVariantLabels = function (variantLabelList) {
      var _this = this;

      var isActive = new Set();

      var reversedList = __spreadArrays(variantLabelList).reverse();

      reversedList.forEach(function (key) {
        var _a = _this.resolveVariant(_this.variants[key]),
            target = _a.target,
            transitionEnd = _a.transitionEnd;

        if (transitionEnd) {
          _this.setValues(transitionEnd, {
            isActive: isActive
          });
        }

        if (target) {
          _this.setValues(target, {
            isActive: isActive
          });
        }

        if (_this.children && _this.children.size) {
          _this.children.forEach(function (child) {
            return child.applyVariantLabels(variantLabelList);
          });
        }
      });
    };

    ValueAnimationControls.prototype.start = function (definition, opts) {
      var _this = this;

      if (opts === void 0) {
        opts = {};
      }

      if (opts.priority) {
        this.activeOverrides.add(opts.priority);
      }

      this.resetIsAnimating(opts.priority);
      var animation;

      if (isVariantLabels(definition)) {
        animation = this.animateVariantLabels(definition, opts);
      } else if (typeof definition === "string") {
        animation = this.animateVariant(definition, opts);
      } else {
        animation = this.animate(definition, opts);
      }

      this.onStart();
      return animation.then(function () {
        return _this.onComplete();
      });
    };

    ValueAnimationControls.prototype.animate = function (animationDefinition, _a) {
      var _this = this;

      var _b = _a === void 0 ? {} : _a,
          _c = _b.delay,
          delay = _c === void 0 ? 0 : _c,
          _d = _b.priority,
          priority = _d === void 0 ? 0 : _d,
          transitionOverride = _b.transitionOverride;

      var _e = this.resolveVariant(animationDefinition),
          target = _e.target,
          transition = _e.transition,
          transitionEnd = _e.transitionEnd;

      if (transitionOverride) {
        transition = transitionOverride;
      }

      if (!target) return Promise.resolve();
      target = this.transformValues(target);

      if (transitionEnd) {
        transitionEnd = this.transformValues(transitionEnd);
      }

      this.checkForNewValues(target);

      if (this.makeTargetAnimatable) {
        var animatable = this.makeTargetAnimatable(target, transitionEnd);
        target = animatable.target;
        transitionEnd = animatable.transitionEnd;
      }

      if (priority) {
        this.resolvedOverrides[priority] = target;
      }

      this.checkForNewValues(target);
      var animations = [];

      for (var key in target) {
        var value = this.values.get(key);
        if (!value || !target || target[key] === undefined) continue;
        var valueTarget = target[key];

        if (!priority) {
          this.baseTarget[key] = resolveFinalValueInKeyframes(valueTarget);
        }

        if (this.isAnimating.has(key)) continue;
        this.isAnimating.add(key);
        animations.push(startAnimation(key, value, valueTarget, _assign({
          delay: delay
        }, transition)));
      }

      var allAnimations = Promise.all(animations);
      return transitionEnd ? allAnimations.then(function () {
        _this.setValues(transitionEnd, {
          priority: priority
        });
      }) : allAnimations;
    };

    ValueAnimationControls.prototype.animateVariantLabels = function (variantLabels, opts) {
      var _this = this;

      var animations = __spreadArrays(variantLabels).reverse().map(function (label) {
        return _this.animateVariant(label, opts);
      });

      return Promise.all(animations);
    };

    ValueAnimationControls.prototype.animateVariant = function (variantLabel, opts) {
      var _this = this;

      var when = false;
      var delayChildren = 0;
      var staggerChildren = 0;
      var staggerDirection = 1;
      var priority = opts && opts.priority || 0;
      var variant = this.variants[variantLabel];
      var getAnimations = variant ? function () {
        return _this.animate(variant, opts);
      } : function () {
        return Promise.resolve();
      };
      var getChildrenAnimations = this.children ? function () {
        return _this.animateChildren(variantLabel, delayChildren, staggerChildren, staggerDirection, priority);
      } : function () {
        return Promise.resolve();
      };

      if (variant && this.children) {
        var transition = this.resolveVariant(variant).transition;

        if (transition) {
          when = transition.when || when;
          delayChildren = transition.delayChildren || delayChildren;
          staggerChildren = transition.staggerChildren || staggerChildren;
          staggerDirection = transition.staggerDirection || staggerDirection;
        }
      }

      if (when) {
        var _a = when === "beforeChildren" ? [getAnimations, getChildrenAnimations] : [getChildrenAnimations, getAnimations],
            first = _a[0],
            last = _a[1];

        return first().then(last);
      } else {
        return Promise.all([getAnimations(), getChildrenAnimations()]);
      }
    };

    ValueAnimationControls.prototype.animateChildren = function (variantLabel, delayChildren, staggerChildren, staggerDirection, priority) {
      if (delayChildren === void 0) {
        delayChildren = 0;
      }

      if (staggerChildren === void 0) {
        staggerChildren = 0;
      }

      if (staggerDirection === void 0) {
        staggerDirection = 1;
      }

      if (priority === void 0) {
        priority = 0;
      }

      if (!this.children) {
        return Promise.resolve();
      }

      var animations = [];
      var maxStaggerDuration = (this.children.size - 1) * staggerChildren;
      var generateStaggerDuration = staggerDirection === 1 ? function (i) {
        return i * staggerChildren;
      } : function (i) {
        return maxStaggerDuration - i * staggerChildren;
      };
      Array.from(this.children).forEach(function (childControls, i) {
        var animation = childControls.animateVariant(variantLabel, {
          priority: priority,
          delay: delayChildren + generateStaggerDuration(i)
        });
        animations.push(animation);
      });
      return Promise.all(animations);
    };

    ValueAnimationControls.prototype.onStart = function () {
      var onAnimationStart = this.props.onAnimationStart;
      onAnimationStart && onAnimationStart();
    };

    ValueAnimationControls.prototype.onComplete = function () {
      var onAnimationComplete = this.props.onAnimationComplete;
      onAnimationComplete && onAnimationComplete();
    };

    ValueAnimationControls.prototype.checkOverrideIsAnimating = function (priority) {
      var numOverrides = this.overrides.length;

      for (var i = priority + 1; i < numOverrides; i++) {
        var resolvedOverride = this.resolvedOverrides[i];

        if (resolvedOverride) {
          for (var key in resolvedOverride) {
            this.isAnimating.add(key);
          }
        }
      }
    };

    ValueAnimationControls.prototype.resetIsAnimating = function (priority) {
      if (priority === void 0) {
        priority = 0;
      }

      this.isAnimating.clear(); // If this isn't the highest priority gesture, block the animation
      // of anything that's currently being animated

      if (priority < this.getHighestPriority()) {
        this.checkOverrideIsAnimating(priority);
      }

      if (this.children) {
        this.children.forEach(function (child) {
          return child.resetIsAnimating(priority);
        });
      }
    };

    ValueAnimationControls.prototype.stop = function () {
      this.values.forEach(function (value) {
        return value.stop();
      });
    };
    /**
     * Add the controls of a child component.
     * @param controls -
     */


    ValueAnimationControls.prototype.addChild = function (controls) {
      if (!this.children) {
        this.children = new Set();
      }

      this.children.add(controls); // We set child overrides when `setOverride` is called, but also have to do it here
      // as the first time `setOverride` is called all the children might not have been added yet.

      this.overrides.forEach(function (override, i) {
        override && controls.setOverride(override, i);
      });
    };

    ValueAnimationControls.prototype.removeChild = function (controls) {
      if (!this.children) {
        return;
      }

      this.children.delete(controls);
    };

    ValueAnimationControls.prototype.resetChildren = function () {
      if (this.children) this.children.clear();
    };

    return ValueAnimationControls;
  }();
  /**
   * Use callback either only on the initial render or on all renders. In concurrent mode
   * the "initial" render might run multiple times
   *
   * @param callback - Callback to run
   * @param isInitialOnly - Set to `true` to only run on initial render, or `false` for all renders. Defaults to `false`.
   *
   * @public
   */


  function useInitialOrEveryRender(callback, isInitialOnly) {
    if (isInitialOnly === void 0) {
      isInitialOnly = false;
    }

    var isInitialRender = React.useRef(true);

    if (!isInitialOnly || isInitialOnly && isInitialRender.current) {
      callback();
    }

    isInitialRender.current = false;
  }
  /**
   * Control animations on one or more components.
   *
   * @public
   */


  var AnimationControls =
  /** @class */
  function () {
    function AnimationControls() {
      /**
       * Track whether the host component has mounted.
       *
       * @internal
       */
      this.hasMounted = false;
      /**
       * Pending animations that are started before a component is mounted.
       *
       * @internal
       */

      this.pendingAnimations = [];
      /**
       * A collection of linked component animation controls.
       *
       * @internal
       */

      this.componentControls = new Set();
    }
    /**
     * Set variants on this and all child components.
     *
     * @param variants - The variants to set
     *
     * @internal
     */


    AnimationControls.prototype.setVariants = function (variants) {
      this.variants = variants;
      this.componentControls.forEach(function (controls) {
        return controls.setVariants(variants);
      });
    };
    /**
     * Set a default transition on this and all child components
     *
     * @param transition - The default transition to set
     *
     * @internal
     */


    AnimationControls.prototype.setDefaultTransition = function (transition) {
      this.defaultTransition = transition;
      this.componentControls.forEach(function (controls) {
        return controls.setDefaultTransition(transition);
      });
    };
    /**
     * Subscribes a component's animation controls to this.
     *
     * @param controls - The controls to subscribe
     * @returns An unsubscribe function.
     *
     * @internal
     */


    AnimationControls.prototype.subscribe = function (controls) {
      var _this = this;

      this.componentControls.add(controls);
      if (this.variants) controls.setVariants(this.variants);
      if (this.defaultTransition) controls.setDefaultTransition(this.defaultTransition);
      return function () {
        return _this.componentControls.delete(controls);
      };
    };
    /**
     * Starts an animation on all linked components.
     *
     * @remarks
     *
     * ```jsx
     * controls.start("variantLabel")
     * controls.start({
     *   x: 0,
     *   transition: { duration: 1 }
     * })
     * ```
     *
     * @param definition - Properties or variant label to animate to
     * @param transition - Optional `transtion` to apply to a variant
     * @returns - A `Promise` that resolves when all animations have completed.
     *
     * @public
     */


    AnimationControls.prototype.start = function (definition, transitionOverride) {
      var _this = this;

      if (this.hasMounted) {
        var animations_1 = [];
        this.componentControls.forEach(function (controls) {
          var animation = controls.start(definition, {
            transitionOverride: transitionOverride
          });
          animations_1.push(animation);
        });
        return Promise.all(animations_1);
      } else {
        return new Promise(function (resolve) {
          _this.pendingAnimations.push({
            animation: [definition, transitionOverride],
            resolve: resolve
          });
        });
      }
    };
    /**
     * Instantly set to a set of properties or a variant.
     *
     * ```jsx
     * // With properties
     * controls.set({ opacity: 0 })
     *
     * // With variants
     * controls.set("hidden")
     * ```
     *
     * @internalremarks
     * We could perform a similar trick to `.start` where this can be called before mount
     * and we maintain a list of of pending actions that get applied on mount. But the
     * expectation of `set` is that it happens synchronously and this would be difficult
     * to do before any children have even attached themselves. It's also poor practise
     * and we should discourage render-synchronous `.start` calls rather than lean into this.
     *
     * @public
     */


    AnimationControls.prototype.set = function (definition) {
      invariant(this.hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
      return this.componentControls.forEach(function (controls) {
        return controls.apply(definition);
      });
    };
    /**
     * Stops animations on all linked components.
     *
     * ```jsx
     * controls.stop()
     * ```
     *
     * @public
     */


    AnimationControls.prototype.stop = function () {
      this.componentControls.forEach(function (controls) {
        return controls.stop();
      });
    };
    /**
     * Initialises the animation controls.
     *
     * @internal
     */


    AnimationControls.prototype.mount = function () {
      var _this = this;

      this.hasMounted = true;
      this.pendingAnimations.forEach(function (_a) {
        var animation = _a.animation,
            resolve = _a.resolve;
        return _this.start.apply(_this, animation).then(resolve);
      });
    };
    /**
     * Stops all child animations when the host component unmounts.
     *
     * @internal
     */


    AnimationControls.prototype.unmount = function () {
      this.hasMounted = false;
      this.stop();
    };

    return AnimationControls;
  }();

  var PresenceContext =
  /*#__PURE__*/
  React.createContext(null);
  /**
   * @internal
   */

  var MotionContext =
  /*#__PURE__*/
  React.createContext({
    static: false
  });

  var isVariantLabel = function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
  };

  var isAnimationControls = function isAnimationControls(v) {
    return v instanceof AnimationControls;
  };
  /**
   * Set up the context for children motion components.
   *
   * We also use this opportunity to apply `initial` values
   */


  var useMotionContext = function useMotionContext(parentContext, controls, values, isStatic, _a) {
    if (isStatic === void 0) {
      isStatic = false;
    }

    var initial = _a.initial,
        animate = _a.animate,
        variants = _a.variants,
        whileTap = _a.whileTap,
        whileHover = _a.whileHover;

    var _b;

    var presenceContext = React.useContext(PresenceContext); // Override initial with that from a parent context, if defined

    if (((_b = presenceContext) === null || _b === void 0 ? void 0 : _b.initial) !== undefined) {
      initial = presenceContext.initial;
    }

    var initialState;

    if (initial === false && !isAnimationControls(animate)) {
      initialState = animate;
    } else if (typeof initial !== "boolean") {
      initialState = initial;
    } // Track mounted status so children can detect whether they were present during their
    // parent's first render


    var hasMounted = React.useRef(false); // We propagate this component's ValueAnimationControls *if* we're being provided variants,
    // if we're being used to control variants, or if we're being passed animation controls.
    // Otherwise this component should be "invisible" to variant propagation. This is a slight concession
    // to Framer X where every `Frame` is a `motion` component and it might be if we change that in the future
    // that this restriction is removed.

    var shouldPropagateControls = variants || isVariantLabel(animate) || isVariantLabel(whileTap) || isVariantLabel(whileHover) || isAnimationControls(animate); // If this component's `initial` prop is a variant label, propagate it. Otherwise pass the parent's.

    var targetInitial = isVariantLabel(initialState) ? initialState : parentContext.initial; // If this is a variant tree we need to propagate the `animate` prop in case new children are added after
    // the tree initially animates.

    var targetAnimate = isVariantLabel(animate) ? animate : parentContext.animate; // Only allow `initial` to trigger context re-renders if this is a `static` component (ie we're on the Framer canvas)
    // or in another non-animation/interaction environment.

    var initialDependency = isStatic ? targetInitial : null; // Only allow `animate` to trigger context re-renders if it's a variant label. If this is an array of
    // variant labels there's probably an optimisation to deep-compare but it might be an over-optimisation.
    // We want to do this as we rely on React's component rendering order each render cycle to determine
    // the new order of any child components for the `staggerChildren` functionality.

    var animateDependency = shouldPropagateControls && isVariantLabel(targetAnimate) ? targetAnimate : null; // The context to provide to the child. We `useMemo` because although `controls` and `initial` are
    // unlikely to change, by making the context an object it'll be considered a new value every render.
    // So all child motion components will re-render as a result.

    var context = React.useMemo(function () {
      return {
        controls: shouldPropagateControls ? controls : parentContext.controls,
        initial: targetInitial,
        animate: targetAnimate,
        values: values,
        hasMounted: hasMounted,
        isReducedMotion: parentContext.isReducedMotion
      };
    }, [initialDependency, animateDependency, parentContext.isReducedMotion]); // Update the `static` property every render. This is unlikely to change but also essentially free.

    context.static = isStatic; // Set initial state. If this is a static component (ie in Framer canvas), respond to updates
    // in `initial`.

    useInitialOrEveryRender(function () {
      var initialToApply = initialState || parentContext.initial;
      initialToApply && controls.apply(initialToApply);
    }, !isStatic);
    React.useEffect(function () {
      hasMounted.current = true;
    }, []);
    return context;
  };
  /**
   * Creates an imperative set of controls to trigger animations.
   *
   * This allows a consolidated, uniform API for animations, to be triggered by other APIs like the `animate` prop, or the gesture handlers.
   *
   * @param values
   * @param props
   * @param ref
   * @param subscribeToParentControls
   *
   * @internal
   */


  function useValueAnimationControls(config, props, subscribeToParentControls) {
    var variants = props.variants,
        transition = props.transition;
    var parentControls = React.useContext(MotionContext).controls;
    var presenceContext = React.useContext(PresenceContext);
    var controls = useConstant(function () {
      return new ValueAnimationControls(config);
    }); // Reset and resubscribe children every render to ensure stagger order is correct

    if (!presenceContext || presenceContext.isPresent) {
      controls.resetChildren();
      controls.setProps(props);
      controls.setVariants(variants);
      controls.setDefaultTransition(transition);
    } // We have to subscribe to the parent controls within a useEffect rather than during render,
    // as


    React.useEffect(function () {
      if (subscribeToParentControls && parentControls) {
        parentControls.addChild(controls);
      }
    });
    React.useEffect(function () {
      return function () {
        // Remove reference to onAnimationComplete from controls. All the MotionValues
        // are unsubscribed from this component separately. We let animations run out
        // as they might be animating other components.
        var onAnimationComplete = props.onAnimationComplete,
            unmountProps = __rest(props, ["onAnimationComplete"]);

        controls.setProps(unmountProps);
        parentControls && parentControls.removeChild(controls);
      };
    }, []);
    return controls;
  }

  var checkShouldInheritVariant = function checkShouldInheritVariant(_a) {
    var animate = _a.animate,
        variants = _a.variants,
        _b = _a.inherit,
        inherit = _b === void 0 ? true : _b;
    return inherit && !!variants && (!animate || animate instanceof AnimationControls);
  };
  /**
   * Uses the ref that is passed in, or creates a new one
   * @param external - External ref
   * @internal
   */


  function useExternalRef(externalRef) {
    // We're conditionally calling `useRef` here which is sort of naughty as hooks
    // shouldn't be called conditionally. However, Framer Motion will break if this
    // condition changes anyway. It might be possible to use an invariant here to
    // make it explicit, but I expect changing `ref` is not normal behaviour.
    var ref = !externalRef || typeof externalRef === "function" ? React.useRef(null) : externalRef; // Handle `ref` functions. Again, calling the hook conditionally is kind of naughty
    // but `ref` types changing between renders would break Motion anyway. If we receive
    // bug reports about this, we should track the provided ref and throw an invariant
    // rather than move the conditional to inside the useEffect as this will be fired
    // for every Frame component within Framer.

    if (externalRef && typeof externalRef === "function") {
      React.useEffect(function () {
        externalRef(ref.current);
        return function () {
          return externalRef(null);
        };
      }, []);
    }

    return ref;
  }
  /**
   * @internal
   */


  var createMotionComponent = function createMotionComponent(_a) {
    var getValueControlsConfig = _a.getValueControlsConfig,
        loadFunctionalityComponents = _a.loadFunctionalityComponents,
        renderComponent = _a.renderComponent;

    function MotionComponent(props, externalRef) {
      var ref = useExternalRef(externalRef);
      var parentContext = React.useContext(MotionContext);
      var isStatic = parentContext.static || props.static || false;
      var values = useMotionValues(props);
      var style = useMotionStyles(values, props.style, isStatic, props.transformValues);
      var shouldInheritVariant = checkShouldInheritVariant(props);
      var controlsConfig = useConstant(function () {
        return getValueControlsConfig(ref, values);
      });
      var controls = useValueAnimationControls(controlsConfig, props, shouldInheritVariant);
      var context = useMotionContext(parentContext, controls, values, isStatic, props);
      var functionality = isStatic ? null : loadFunctionalityComponents(ref, values, props, parentContext, controls, shouldInheritVariant);
      var renderedComponent = renderComponent(ref, style, values, props, isStatic);
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement(MotionContext.Provider, {
          value: context
        }, renderedComponent),
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement(Mount, {
          innerRef: ref,
          values: values,
          isStatic: isStatic
        }), functionality))
      );
    }

    return (
      /*#__PURE__*/
      React.forwardRef(MotionComponent)
    );
  };
  /**
   * @internal
   */


  var htmlElements = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "webview"];
  /**
   * @internal
   */

  var svgElements = ["animate", "circle", "clipPath", "defs", "desc", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use", "view"];
  /**
   * @internal
   */

  var MotionPluginContext =
  /*#__PURE__*/
  React.createContext({
    transformPagePoint: function transformPagePoint(p) {
      return p;
    }
  });

  function useUnmountEffect(callback) {
    return React.useEffect(function () {
      return function () {
        return callback();
      };
    }, []);
  }

  function addDomEvent(target, eventName, handler, options) {
    if (!handler) return;
    target.addEventListener(eventName, handler, options);
    return function () {
      return target.removeEventListener(eventName, handler, options);
    };
  }
  /**
   * Attaches an event listener directly to the provided DOM element.
   *
   * Bypassing React's event system can be desirable, for instance when attaching non-passive
   * event handlers.
   *
   * ```jsx
   * const ref = useRef(null)
   *
   * useDomEvent(ref, 'wheel', onWheel, { passive: false })
   *
   * return <div ref={ref} />
   * ```
   *
   * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
   * @param eventName - Name of the event you want listen for.
   * @param handler - Function to fire when receiving the event.
   * @param options - Options to pass to `Event.addEventListener`.
   *
   * @public
   */


  function useDomEvent(ref, eventName, handler, options) {
    React.useEffect(function () {
      var element = ref.current;

      if (handler && element) {
        return addDomEvent(element, eventName, handler, options);
      }
    }, [ref, eventName, handler, options]);
  }

  function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
      return !!(event.pointerType === "mouse");
    }

    return event instanceof MouseEvent;
  }

  function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
  }
  /**
   * Filters out events not attached to the primary pointer (currently left mouse button)
   * @param eventHandler
   */


  function filterPrimaryPointer(eventHandler) {
    if (!eventHandler) return undefined;
    return function (event) {
      var isMouseEvent = event instanceof MouseEvent;
      var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;

      if (isPrimaryPointer) {
        eventHandler(event);
      }
    };
  }

  var defaultPagePoint = {
    pageX: 0,
    pageY: 0
  };

  function pointFromTouch(e) {
    var primaryTouch = e.touches[0] || e.changedTouches[0];

    var _a = primaryTouch || defaultPagePoint,
        pageX = _a.pageX,
        pageY = _a.pageY;

    return {
      x: pageX,
      y: pageY
    };
  }

  function pointFromMouse(_a) {
    var _b = _a.pageX,
        pageX = _b === void 0 ? 0 : _b,
        _c = _a.pageY,
        pageY = _c === void 0 ? 0 : _c;
    return {
      x: pageX,
      y: pageY
    };
  }

  function extractEventInfo(event) {
    return {
      point: isTouchEvent(event) ? pointFromTouch(event) : pointFromMouse(event)
    };
  }

  var wrapHandler = function wrapHandler(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) {
      shouldFilterPrimaryPointer = false;
    }

    if (!handler) return;

    var listener = function listener(event) {
      return handler(event, extractEventInfo(event));
    };

    return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
  };

  var isBrowser$1 = typeof window !== "undefined"; // We check for event support via functions in case they've been mocked by a testing suite.

  var supportsPointerEvents = function supportsPointerEvents() {
    return isBrowser$1 && window.onpointerdown === null;
  };

  var supportsTouchEvents = function supportsTouchEvents() {
    return isBrowser$1 && window.ontouchstart === null;
  };

  var supportsMouseEvents = function supportsMouseEvents() {
    return isBrowser$1 && window.onmousedown === null;
  };

  var mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
  };
  var touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
  };

  function getPointerEventName(name) {
    if (supportsPointerEvents()) {
      return name;
    } else if (supportsTouchEvents()) {
      return touchEventNames[name];
    } else if (supportsMouseEvents()) {
      return mouseEventNames[name];
    }

    return name;
  }

  function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
  }

  function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
  }
  /** @public */


  var Point;

  (function (Point) {
    /** @beta */
    Point.subtract = function (a, b) {
      return {
        x: a.x - b.x,
        y: a.y - b.y
      };
    };
    /** @beta */


    Point.relativeTo = function (idOrElem) {
      var elem;

      var getElem = function getElem() {
        // Caching element here could be leaky because of React lifecycle
        if (elem !== undefined) return elem;

        if (typeof idOrElem === "string") {
          elem = document.getElementById(idOrElem);
        } else {
          elem = idOrElem;
        }

        return elem;
      };

      return function (_a) {
        var x = _a.x,
            y = _a.y;
        var localElem = getElem();
        if (!localElem) return undefined;
        var rect = localElem.getBoundingClientRect();
        return {
          x: x - rect.left - window.scrollX,
          y: y - rect.top - window.scrollY
        };
      };
    };
  })(Point || (Point = {}));

  var isViewportScrollBlocked = false;
  var isBrowser$1$1 = typeof window !== "undefined";

  if (isBrowser$1$1) {
    document.addEventListener("touchmove", function (event) {
      if (isViewportScrollBlocked) {
        event.preventDefault();
      }
    }, {
      passive: false
    });
  }

  var blockViewportScroll = function blockViewportScroll() {
    return isViewportScrollBlocked = true;
  };

  var unblockViewportScroll = function unblockViewportScroll() {
    return isViewportScrollBlocked = false;
  };
  /**
   * @internal
   */


  var PanSession =
  /** @class */
  function () {
    function PanSession(event, handlers, _a) {
      var _this = this;

      var transformPagePoint = (_a === void 0 ? {} : _a).transformPagePoint;
      /**
       * @internal
       */

      this.startEvent = null;
      /**
       * @internal
       */

      this.lastMoveEvent = null;
      /**
       * @internal
       */

      this.lastMoveEventInfo = null;
      /**
       * @internal
       */

      this.handlers = {};

      this.updatePoint = function () {
        if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
        var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
        var isPanStarted = _this.startEvent !== null; // Only start panning if the offset is larger than 3 pixels. If we make it
        // any larger than this we'll want to reset the pointer history
        // on the first update to avoid visual snapping to the cursoe.

        var isDistancePastThreshold = distance(info.offset, {
          x: 0,
          y: 0
        }) >= 3;
        if (!isPanStarted && !isDistancePastThreshold) return;
        var point = info.point;
        var timestamp = getFrameData().timestamp;

        _this.history.push(_assign(_assign({}, point), {
          timestamp: timestamp
        }));

        var _a = _this.handlers,
            onStart = _a.onStart,
            onMove = _a.onMove;

        if (!isPanStarted) {
          onStart && onStart(_this.lastMoveEvent, info);
          _this.startEvent = _this.lastMoveEvent;
        }

        onMove && onMove(_this.lastMoveEvent, info);
      }; // If we have more than one touch, don't start detecting this gesture


      if (isTouchEvent(event) && event.touches.length > 1) return;
      this.handlers = handlers;
      this.transformPagePoint = transformPagePoint;
      var info = extractEventInfo(event);
      var initialInfo = transformPoint(info, this.transformPagePoint);
      var point = initialInfo.point;
      var timestamp = getFrameData().timestamp;
      this.history = [_assign(_assign({}, point), {
        timestamp: timestamp
      })];
      var onSessionStart = handlers.onSessionStart;
      onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
      var removeOnPointerMove = addPointerEvent(window, "pointermove", function (event, info) {
        return _this.handlePointerMove(event, info);
      });
      var removeOnPointerUp = addPointerEvent(window, "pointerup", function (event, info) {
        return _this.handlePointerUp(event, info);
      });

      this.removeListeners = function () {
        removeOnPointerMove && removeOnPointerMove();
        removeOnPointerUp && removeOnPointerUp();
      };
    }

    PanSession.prototype.handlePointerMove = function (event, info) {
      this.lastMoveEvent = event;
      this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint); // Because Safari doesn't trigger mouseup events when it's above a `<select>`

      if (isMouseEvent(event) && event.buttons === 0) {
        this.handlePointerUp(event, info);
        return;
      } // Throttle mouse move event to once per frame


      sync.update(this.updatePoint, true);
    };

    PanSession.prototype.handlePointerUp = function (event, info) {
      this.end();
      var onEnd = this.handlers.onEnd;
      if (!onEnd) return;
      var panInfo = getPanInfo(transformPoint(info, this.transformPagePoint), this.history);
      onEnd && onEnd(event, panInfo);
    };

    PanSession.prototype.updateHandlers = function (handlers) {
      this.handlers = handlers;
    };

    PanSession.prototype.end = function () {
      this.removeListeners && this.removeListeners();
      cancelSync.update(this.updatePoint);
      unblockViewportScroll();
    };

    return PanSession;
  }();

  function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
      point: transformPagePoint(info.point)
    } : info;
  }

  function getPanInfo(_a, history) {
    var point = _a.point;
    return {
      point: point,
      delta: Point.subtract(point, lastDevicePoint(history)),
      offset: Point.subtract(point, startDevicePoint(history)),
      velocity: getVelocity$1(history, 0.1)
    };
  }

  function startDevicePoint(history) {
    return history[0];
  }

  function lastDevicePoint(history) {
    return history[history.length - 1];
  }

  function getVelocity$1(history, timeDelta) {
    if (history.length < 2) {
      return {
        x: 0,
        y: 0
      };
    }

    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);

    while (i >= 0) {
      timestampedPoint = history[i];

      if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
        break;
      }

      i--;
    }

    if (!timestampedPoint) {
      return {
        x: 0,
        y: 0
      };
    }

    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;

    if (time === 0) {
      return {
        x: 0,
        y: 0
      };
    }

    var currentVelocity = {
      x: (lastPoint.x - timestampedPoint.x) / time,
      y: (lastPoint.y - timestampedPoint.y) / time
    };

    if (currentVelocity.x === Infinity) {
      currentVelocity.x = 0;
    }

    if (currentVelocity.y === Infinity) {
      currentVelocity.y = 0;
    }

    return currentVelocity;
  }
  /**
   *
   * @param handlers -
   * @param ref -
   *
   * @internalremarks
   * Currently this sets new pan gesture functions every render. The memo route has been explored
   * in the past but ultimately we're still creating new functions every render. An optimisation
   * to explore is creating the pan gestures and loading them into a `ref`.
   *
   * @internal
   */


  function usePanGesture(_a, ref) {
    var onPan = _a.onPan,
        onPanStart = _a.onPanStart,
        onPanEnd = _a.onPanEnd,
        onPanSessionStart = _a.onPanSessionStart;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = React.useRef(null);
    var transformPagePoint = React.useContext(MotionPluginContext).transformPagePoint;
    var handlers = {
      onSessionStart: onPanSessionStart,
      onStart: onPanStart,
      onMove: onPan,
      onEnd: function onEnd(event, info) {
        panSession.current = null;
        onPanEnd && onPanEnd(event, info);
      }
    };
    React.useEffect(function () {
      if (panSession.current !== null) {
        panSession.current.updateHandlers(handlers);
      }
    });

    function onPointerDown(event) {
      panSession.current = new PanSession(event, handlers, {
        transformPagePoint: transformPagePoint
      });
    }

    usePointerEvent(ref, "pointerdown", hasPanEvents && onPointerDown);
    useUnmountEffect(function () {
      return panSession.current && panSession.current.end();
    });
  }
  /**
   * Recursively traverse up the tree to check whether the provided child node
   * is the parent or a descendant of it.
   *
   * @param parent - Element to find
   * @param child - Element to test against parent
   */


  var isNodeOrChild = function isNodeOrChild(parent, child) {
    if (!child) {
      return false;
    } else if (parent === child) {
      return true;
    } else {
      return isNodeOrChild(parent, child.parentElement);
    }
  };

  var order$1 = ["whileHover", "whileTap", "whileDrag"];

  var getGesturePriority = function getGesturePriority(gesture) {
    return order$1.indexOf(gesture) + 1;
  };

  function createLock(name) {
    var lock = null;
    return function () {
      var openLock = function openLock() {
        lock = null;
      };

      if (lock === null) {
        lock = name;
        return openLock;
      }

      return false;
    };
  }

  var globalHorizontalLock = createLock("dragHorizontal");
  var globalVerticalLock = createLock("dragVertical");

  function getGlobalLock(drag) {
    var lock = false;

    if (drag === "y") {
      lock = globalVerticalLock();
    } else if (drag === "x") {
      lock = globalHorizontalLock();
    } else {
      var openHorizontal_1 = globalHorizontalLock();
      var openVertical_1 = globalVerticalLock();

      if (openHorizontal_1 && openVertical_1) {
        lock = function lock() {
          openHorizontal_1();
          openVertical_1();
        };
      } else {
        // Release the locks because we don't use them
        if (openHorizontal_1) openHorizontal_1();
        if (openVertical_1) openVertical_1();
      }
    }

    return lock;
  }

  var tapGesturePriority = getGesturePriority("whileTap");
  /**
   * @param handlers -
   * @internal
   */

  function useTapGesture(_a, ref) {
    var onTap = _a.onTap,
        onTapStart = _a.onTapStart,
        onTapCancel = _a.onTapCancel,
        whileTap = _a.whileTap,
        controls = _a.controls;
    var hasTapListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isTapping = React.useRef(false);
    var cancelPointerEventListener = React.useRef(null);

    function removePointerUp() {
      cancelPointerEventListener.current && cancelPointerEventListener.current();
      cancelPointerEventListener.current = null;
    }

    if (whileTap && controls) {
      controls.setOverride(whileTap, tapGesturePriority);
    } // We load this event handler into a ref so we can later refer to
    // onPointerUp.current which will always have reference to the latest props


    var onPointerUp = React.useRef(null);

    onPointerUp.current = function (event, info) {
      var element = ref.current;
      removePointerUp();
      if (!isTapping.current || !element) return;
      isTapping.current = false;

      if (controls && whileTap) {
        controls.clearOverride(tapGesturePriority);
      } // Check the gesture lock - if we get it, it means no drag gesture is active
      // and we can safely fire the tap gesture.


      var openGestureLock = getGlobalLock(true);
      if (!openGestureLock) return;
      openGestureLock();

      if (!isNodeOrChild(element, event.target)) {
        onTapCancel && onTapCancel(event, info);
      } else {
        onTap && onTap(event, info);
      }
    };

    function onPointerDown(event, info) {
      removePointerUp();
      cancelPointerEventListener.current = addPointerEvent(window, "pointerup", function (event, info) {
        return onPointerUp.current(event, info);
      });
      var element = ref.current;
      if (!element || isTapping.current) return;
      isTapping.current = true;
      onTapStart && onTapStart(event, info);

      if (controls && whileTap) {
        controls.startOverride(tapGesturePriority);
      }
    }

    usePointerEvent(ref, "pointerdown", hasTapListeners ? onPointerDown : undefined);
    useUnmountEffect(removePointerUp);
  }

  var hoverPriority = getGesturePriority("whileHover");

  var filterTouch = function filterTouch(listener) {
    return function (event, info) {
      if (isMouseEvent(event)) listener(event, info);
    };
  };
  /**
   *
   * @param props
   * @param ref
   * @internal
   */


  function useHoverGesture(_a, ref) {
    var whileHover = _a.whileHover,
        onHoverStart = _a.onHoverStart,
        onHoverEnd = _a.onHoverEnd,
        controls = _a.controls;

    if (whileHover && controls) {
      controls.setOverride(whileHover, hoverPriority);
    }

    usePointerEvent(ref, "pointerenter", filterTouch(function (event, info) {
      if (onHoverStart) onHoverStart(event, info);

      if (whileHover && controls) {
        controls.startOverride(hoverPriority);
      }
    }));
    usePointerEvent(ref, "pointerleave", filterTouch(function (event, info) {
      if (onHoverEnd) onHoverEnd(event, info);

      if (whileHover && controls) {
        controls.clearOverride(hoverPriority);
      }
    }));
  }
  /**
   * Add pan and tap gesture recognition to an element.
   *
   * @param props - Gesture event handlers
   * @param ref - React `ref` containing a DOM `Element`
   * @public
   */


  function useGestures(props, ref) {
    usePanGesture(props, ref);
    useTapGesture(props, ref);
    useHoverGesture(props, ref);
  }

  var makeRenderlessComponent = function makeRenderlessComponent(hook) {
    return function (props) {
      hook(props);
      return null;
    };
  };

  var gestureProps = ["onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileTap", "whileHover", "onHoverStart", "onHoverEnd"];
  var Gestures = {
    key: "gestures",
    shouldRender: function shouldRender(props) {
      return gestureProps.some(function (key) {
        return props.hasOwnProperty(key);
      });
    },
    Component: makeRenderlessComponent(function (_a) {
      var innerRef = _a.innerRef,
          props = __rest(_a, ["innerRef"]);

      useGestures(props, innerRef);
    })
  };

  var isRefObject = function isRefObject(ref) {
    return typeof ref === "object" && ref.hasOwnProperty("current");
  };

  var noop = function noop(v) {
    return v;
  };

  var ComponentDragControls =
  /** @class */
  function () {
    function ComponentDragControls(_a) {
      var ref = _a.ref,
          values = _a.values,
          controls = _a.controls;
      /**
       * Track whether we're currently dragging.
       *
       * @internal
       */

      this.isDragging = false;
      /**
       * The current direction of drag, or `null` if both.
       *
       * @internal
       */

      this.currentDirection = null;
      /**
       * The permitted t/r/b/l boundaries of travel, in pixels.
       *
       * @internal
       */

      this.constraints = false;
      /**
       * A reference to the host component's latest props.
       *
       * @internal
       */

      this.props = {
        transformPagePoint: noop
      };
      /**
       * References to the MotionValues used for tracking the current dragged point.
       *
       * @internal
       */

      this.point = {};
      /**
       * The origin point for the current drag gesture.
       *
       * @internal
       */

      this.origin = {
        x: motionValue(0),
        y: motionValue(0)
      }; // This is a reference to the global drag gesture lock, ensuring only one component
      // can "capture" the drag of one or both axes.
      // TODO: Look into moving this into pansession?

      this.openGlobalLock = null;
      /**
       * @internal
       */

      this.panSession = null;
      /**
       * A reference to the previous constraints bounding box
       *
       * @internal
       */

      this.prevConstraintsBox = {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      };
      this.ref = ref;
      this.values = values;
      this.controls = controls;
    }
    /**
     * Start dragging the host component.
     *
     * @param event - The originating pointer event.
     * @param options -
     *
     * @public
     */


    ComponentDragControls.prototype.start = function (originEvent, _a) {
      var _this = this;

      var _b = (_a === void 0 ? {} : _a).snapToCursor,
          snapToCursor = _b === void 0 ? false : _b;
      snapToCursor && this.snapToCursor(originEvent);

      var onSessionStart = function onSessionStart() {
        // Initiate viewport scroll blocking on touch start. This is a very aggressive approach
        // which has come out of the difficulty in us being able to do this once a scroll gesture
        // has initiated in mobile browsers. This means if there's a horizontally-scrolling carousel
        // on a page we can't let a user scroll the page itself from it. Ideally what we'd do is
        // trigger this once we've got a scroll direction determined. This approach sort-of worked
        // but if the component was dragged too far in a single frame page scrolling would initiate.
        blockViewportScroll(); // Stop any animations on both axis values immediately. This allows the user to throw and catch
        // the component.

        bothAxis(function (axis) {
          var axisPoint = _this.point[axis];
          axisPoint && axisPoint.stop();
        });
      };

      var onStart = function onStart(event, info) {
        // If constraints are an element, resolve them again in case they've updated.
        if (_this.constraintsNeedResolution) {
          var _a = _this.props,
              dragConstraints = _a.dragConstraints,
              transformPagePoint_1 = _a.transformPagePoint;
          _this.constraints = calculateConstraintsFromDom(dragConstraints, _this.ref, _this.point, transformPagePoint_1);

          _this.applyConstraintsToPoint();
        } // Set point origin and stop any existing animations.


        bothAxis(function (axis) {
          var axisPoint = _this.point[axis];
          if (!axisPoint) return;

          _this.origin[axis].set(axisPoint.get());
        }); // Attempt to grab the global drag gesture lock - maybe make this part of PanSession

        var _b = _this.props,
            drag = _b.drag,
            dragPropagation = _b.dragPropagation;

        if (drag && !dragPropagation) {
          if (_this.openGlobalLock) _this.openGlobalLock();
          _this.openGlobalLock = getGlobalLock(drag);
          if (!_this.openGlobalLock) return;
        }

        _this.isDragging = true;
        _this.currentDirection = null;
        var onDragStart = _this.props.onDragStart;
        onDragStart && onDragStart(event, convertPanToDrag(info, _this.point));
      };

      var onMove = function onMove(event, info) {
        var _a = _this.props,
            dragPropagation = _a.dragPropagation,
            dragDirectionLock = _a.dragDirectionLock; // If we didn't successfully receive the gesture lock, early return.

        if (!dragPropagation && !_this.openGlobalLock) return;
        var offset = info.offset; // Attempt to detect drag direction if directionLock is true

        if (dragDirectionLock && _this.currentDirection === null) {
          _this.currentDirection = getCurrentDirection(offset); // If we've successfully set a direction, notify listener

          if (_this.currentDirection !== null) {
            var onDirectionLock = _this.props.onDirectionLock;
            onDirectionLock && onDirectionLock(_this.currentDirection);
          }

          return;
        }

        _this.updatePoint("x", offset);

        _this.updatePoint("y", offset);

        var onDrag = _this.props.onDrag;
        onDrag && onDrag(event, convertPanToDrag(info, _this.point));
      };

      var onEnd = function onEnd(event, info) {
        _this.stop(event, info);
      };

      var transformPagePoint = this.props.transformPagePoint;
      this.panSession = new PanSession(originEvent, {
        onSessionStart: onSessionStart,
        onStart: onStart,
        onMove: onMove,
        onEnd: onEnd
      }, {
        transformPagePoint: transformPagePoint
      });
    };

    ComponentDragControls.prototype.cancelDrag = function () {
      unblockViewportScroll();
      this.isDragging = false;
      this.panSession && this.panSession.end();
      this.panSession = null;

      if (!this.props.dragPropagation && this.openGlobalLock) {
        this.openGlobalLock();
        this.openGlobalLock = null;
      }
    };

    ComponentDragControls.prototype.stop = function (event, info) {
      var _a;

      (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
      this.panSession = null;
      var isDragging = this.isDragging;
      this.cancelDrag();
      if (!isDragging) return;
      var _b = this.props,
          dragMomentum = _b.dragMomentum,
          dragElastic = _b.dragElastic,
          onDragEnd = _b.onDragEnd;

      if (dragMomentum || dragElastic) {
        var velocity = info.velocity;
        this.animateDragEnd(velocity);
      } else {
        this.recordBoxInfo(this.constraints);
      }

      onDragEnd && onDragEnd(event, convertPanToDrag(info, this.point));
    };

    ComponentDragControls.prototype.recordBoxInfo = function (constraints) {
      if (constraints) {
        var right = constraints.right,
            left = constraints.left,
            bottom = constraints.bottom,
            top_1 = constraints.top;
        this.prevConstraintsBox.width = (right || 0) - (left || 0);
        this.prevConstraintsBox.height = (bottom || 0) - (top_1 || 0);
      }

      if (this.point.x) this.prevConstraintsBox.x = this.point.x.get();
      if (this.point.y) this.prevConstraintsBox.y = this.point.y.get();
    };

    ComponentDragControls.prototype.snapToCursor = function (event) {
      var _this = this;

      var transformPagePoint = this.props.transformPagePoint;
      var point = extractEventInfo(event).point;
      var boundingBox = getBoundingBox(this.ref, transformPagePoint);
      var center = {
        x: boundingBox.width / 2 + boundingBox.left + window.scrollX,
        y: boundingBox.height / 2 + boundingBox.top + window.scrollY
      };
      var offset = {
        x: point.x - center.x,
        y: point.y - center.y
      };
      bothAxis(function (axis) {
        var point = _this.point[axis];
        if (!point) return;

        _this.origin[axis].set(point.get());
      });
      this.updatePoint("x", offset);
      this.updatePoint("y", offset);
    };

    ComponentDragControls.prototype.setPoint = function (axis, value) {
      this.point[axis] = value;
    };

    ComponentDragControls.prototype.updatePoint = function (axis, offset) {
      var _a = this.props,
          drag = _a.drag,
          dragElastic = _a.dragElastic;
      var axisPoint = this.point[axis]; // If we're not dragging this axis, do an early return.

      if (!shouldDrag(axis, drag, this.currentDirection) || !axisPoint) return;
      var current = applyConstraints(axis, this.origin[axis].get() + offset[axis], this.constraints, dragElastic);
      axisPoint.set(current);
    };

    ComponentDragControls.prototype.updateProps = function (_a) {
      var _this = this;

      var _b = _a.drag,
          drag = _b === void 0 ? false : _b,
          _c = _a.dragDirectionLock,
          dragDirectionLock = _c === void 0 ? false : _c,
          _d = _a.dragPropagation,
          dragPropagation = _d === void 0 ? false : _d,
          _e = _a.dragConstraints,
          dragConstraints = _e === void 0 ? false : _e,
          _f = _a.dragElastic,
          dragElastic = _f === void 0 ? true : _f,
          _g = _a.dragMomentum,
          dragMomentum = _g === void 0 ? true : _g,
          remainingProps = __rest(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);

      this.props = _assign({
        drag: drag,
        dragDirectionLock: dragDirectionLock,
        dragPropagation: dragPropagation,
        dragConstraints: dragConstraints,
        dragElastic: dragElastic,
        dragMomentum: dragMomentum
      }, remainingProps);
      var _dragValueX = remainingProps._dragValueX,
          _dragValueY = remainingProps._dragValueY,
          dragOriginX = remainingProps.dragOriginX,
          dragOriginY = remainingProps.dragOriginY;
      if (dragOriginX) this.origin.x = dragOriginX;
      if (dragOriginY) this.origin.y = dragOriginY; // Get the `MotionValue` for both draggable axes, or create them if they don't already
      // exist on this component.

      bothAxis(function (axis) {
        if (!shouldDrag(axis, drag, _this.currentDirection)) return;
        var defaultValue = axis === "x" ? _dragValueX : _dragValueY;

        _this.setPoint(axis, defaultValue || _this.values.get(axis, 0));
      }); // If `dragConstraints` is a React `ref`, we should resolve the constraints once the
      // component has rendered.

      this.constraintsNeedResolution = isRefObject(dragConstraints);
      this.constraints = this.constraintsNeedResolution ? this.constraints || false : dragConstraints;
    };

    ComponentDragControls.prototype.applyConstraintsToPoint = function (constraints) {
      var _this = this;

      if (constraints === void 0) {
        constraints = this.constraints;
      }

      return bothAxis(function (axis) {
        var axisPoint = _this.point[axis];
        axisPoint && !axisPoint.isAnimating() && applyConstraints(axis, axisPoint, constraints, 0);
      });
    };

    ComponentDragControls.prototype.animateDragEnd = function (velocity) {
      var _this = this;

      var _a = this.props,
          drag = _a.drag,
          dragMomentum = _a.dragMomentum,
          dragElastic = _a.dragElastic,
          dragTransition = _a.dragTransition,
          _dragValueX = _a._dragValueX,
          _dragValueY = _a._dragValueY,
          _dragTransitionControls = _a._dragTransitionControls;
      var momentumAnimations = bothAxis(function (axis) {
        var _a;

        if (!shouldDrag(axis, drag, _this.currentDirection)) {
          return;
        }

        var transition = _this.constraints ? getConstraints(axis, _this.constraints) : {};
        /**
         * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
         * of spring animations so we should look into adding a disable spring option to `inertia`.
         * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
         * using the value of `dragElastic`.
         */

        var bounceStiffness = dragElastic ? 200 : 1000000;
        var bounceDamping = dragElastic ? 40 : 10000000;
        var animationControls = _dragTransitionControls || _this.controls;

        var inertia = _assign(_assign({
          type: "inertia",
          velocity: dragMomentum ? velocity[axis] : 0,
          bounceStiffness: bounceStiffness,
          bounceDamping: bounceDamping,
          timeConstant: 750,
          restDelta: 1
        }, dragTransition), transition);

        var externalAxisMotionValue = axis === "x" ? _dragValueX : _dragValueY; // If we're not animating on an externally-provided `MotionValue` we can use the
        // component's animation controls which will handle interactions with whileHover (etc),
        // otherwise we just have to animate the `MotionValue` itself.

        return externalAxisMotionValue ? startAnimation(axis, externalAxisMotionValue, 0, inertia) : animationControls.start((_a = {}, _a[axis] = 0, _a.transition = inertia, _a));
      }); // Run all animations and then resolve the new drag constraints.

      return Promise.all(momentumAnimations).then(function () {
        _this.recordBoxInfo(_this.constraints);

        _this.scalePoint();

        var onDragTransitionEnd = _this.props.onDragTransitionEnd;
        onDragTransitionEnd && onDragTransitionEnd();
      });
    };

    ComponentDragControls.prototype.scalePoint = function () {
      var _this = this;

      var _a = this.props,
          dragConstraints = _a.dragConstraints,
          transformPagePoint = _a.transformPagePoint;
      if (!isRefObject(dragConstraints)) return;
      var constraintsBox = getBoundingBox(dragConstraints, transformPagePoint);
      var draggableBox = getBoundingBox(this.ref, transformPagePoint); // Scale a point relative to the transformation of a constraints-providing element.

      var scaleAxisPoint = function scaleAxisPoint(axis, dimension) {
        var pointToScale = _this.point[axis];
        if (!pointToScale) return; // Stop any current animations as they bug out if you resize during one

        if (pointToScale.isAnimating()) {
          pointToScale.stop();

          _this.recordBoxInfo();

          return;
        } // If the previous dimension was `0` (default), set `scale` to `1` to prevent
        // divide by zero errors.


        var scale = _this.prevConstraintsBox[dimension] ? (constraintsBox[dimension] - draggableBox[dimension]) / _this.prevConstraintsBox[dimension] : 1;
        pointToScale.set(_this.prevConstraintsBox[axis] * scale);
      };

      scaleAxisPoint("x", "width");
      scaleAxisPoint("y", "height");
    };

    ComponentDragControls.prototype.mount = function (element) {
      var _this = this;

      var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
        var _a = _this.props,
            drag = _a.drag,
            _b = _a.dragListener,
            dragListener = _b === void 0 ? true : _b;
        drag && dragListener && _this.start(event);
      });
      var stopResizeListener = addDomEvent(window, "resize", function () {
        return _this.scalePoint();
      });

      if (this.constraintsNeedResolution) {
        var _a = this.props,
            dragConstraints = _a.dragConstraints,
            transformPagePoint = _a.transformPagePoint;
        var constraints = calculateConstraintsFromDom(dragConstraints, this.ref, this.point, transformPagePoint);
        this.applyConstraintsToPoint(constraints);
        this.recordBoxInfo(constraints);
      } else if (!this.isDragging && this.constraints) {
        this.applyConstraintsToPoint();
      }

      return function () {
        stopPointerListener && stopPointerListener();
        stopResizeListener && stopResizeListener();

        _this.cancelDrag();
      };
    };

    return ComponentDragControls;
  }(); // Call a handler once for each axis


  function bothAxis(handler) {
    return [handler("x"), handler("y")];
  }

  function convertPanToDrag(info, point) {
    return _assign(_assign({}, info), {
      point: {
        x: point.x ? point.x.get() : 0,
        y: point.y ? point.y.get() : 0
      }
    });
  }

  function getConstraints(axis, _a) {
    var top = _a.top,
        right = _a.right,
        bottom = _a.bottom,
        left = _a.left;

    if (axis === "x") {
      return {
        min: left,
        max: right
      };
    } else {
      return {
        min: top,
        max: bottom
      };
    }
  }

  function shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
  }
  /**
   * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
   * than the provided threshold, return `null`.
   *
   * @param offset - The x/y offset from origin.
   * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
   */


  function getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) {
      lockThreshold = 10;
    }

    var direction = null;

    if (Math.abs(offset.y) > lockThreshold) {
      direction = "y";
    } else if (Math.abs(offset.x) > lockThreshold) {
      direction = "x";
    }

    return direction;
  }
  /**
   * Takes a parent Element and a draggable Element and returns pixel-based drag constraints.
   *
   * @param constraintsRef
   * @param draggableRef
   */


  function calculateConstraintsFromDom(constraintsRef, draggableRef, point, transformPagePoint) {
    invariant(constraintsRef.current !== null && draggableRef.current !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    var parentBoundingBox = getBoundingBox(constraintsRef, transformPagePoint);
    var draggableBoundingBox = getBoundingBox(draggableRef, transformPagePoint);
    var left = parentBoundingBox.left - draggableBoundingBox.left + getCurrentOffset(point.x);
    var top = parentBoundingBox.top - draggableBoundingBox.top + getCurrentOffset(point.y);
    var right = parentBoundingBox.width - draggableBoundingBox.width + left;
    var bottom = parentBoundingBox.height - draggableBoundingBox.height + top;
    return {
      top: top,
      left: left,
      right: right,
      bottom: bottom
    };
  }

  function getBoundingBox(ref, transformPagePoint) {
    var rect = ref.current.getBoundingClientRect();

    var _a = transformPagePoint({
      x: rect.left,
      y: rect.top
    }),
        left = _a.x,
        top = _a.y;

    var _b = transformPagePoint({
      x: rect.width,
      y: rect.height
    }),
        width = _b.x,
        height = _b.y;

    return {
      left: left,
      top: top,
      width: width,
      height: height
    };
  }

  function getCurrentOffset(point) {
    return point ? point.get() : 0;
  }

  function applyConstraints(axis, value, constraints, dragElastic) {
    var constrainedValue = value instanceof MotionValue ? value.get() : value;

    if (!constraints) {
      return constrainedValue;
    }

    var _a = getConstraints(axis, constraints),
        min = _a.min,
        max = _a.max;

    if (min !== undefined && constrainedValue < min) {
      constrainedValue = dragElastic ? applyOverdrag(min, constrainedValue, dragElastic) : Math.max(min, constrainedValue);
    } else if (max !== undefined && constrainedValue > max) {
      constrainedValue = dragElastic ? applyOverdrag(max, constrainedValue, dragElastic) : Math.min(max, constrainedValue);
    }

    if (value instanceof MotionValue) {
      value.set(constrainedValue);
    }

    return constrainedValue;
  }

  function applyOverdrag(origin, current, dragElastic) {
    var dragFactor = typeof dragElastic === "number" ? dragElastic : 0.35;
    return mix(origin, current, dragFactor);
  }
  /**
   * A hook that allows an element to be dragged.
   *
   * @param param
   * @param ref
   * @param values
   * @param controls
   *
   * @internal
   */


  function useDrag(props, ref, values, controls) {
    var groupDragControls = props.dragControls;
    var transformPagePoint = React.useContext(MotionPluginContext).transformPagePoint;
    var dragControls = useConstant(function () {
      return new ComponentDragControls({
        ref: ref,
        values: values,
        controls: controls
      });
    });
    dragControls.updateProps(_assign(_assign({}, props), {
      transformPagePoint: transformPagePoint
    }));
    React.useEffect(function () {
      return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [dragControls]);
    React.useEffect(function () {
      return dragControls.mount(ref.current);
    }, []);
  }

  var Drag = {
    key: "drag",
    shouldRender: function shouldRender(props) {
      return !!props.drag;
    },
    Component: makeRenderlessComponent(function (_a) {
      var innerRef = _a.innerRef,
          values = _a.values,
          controls = _a.controls,
          props = __rest(_a, ["innerRef", "values", "controls"]);

      return useDrag(props, innerRef, values, controls);
    })
  };

  function isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
  }
  /**
   * Parse Framer's special CSS variable format into a CSS token and a fallback.
   *
   * ```
   * `var(--foo, #fff)` => [`--foo`, '#fff']
   * ```
   *
   * @param current
   */


  var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

  function parseCSSVariable(current) {
    var match = cssVariableRegex.exec(current);
    if (!match) return [,];
    var token = match[1],
        fallback = match[2];
    return [token, fallback];
  }

  var maxDepth = 4;

  function getVariableValue(current, element, depth) {
    if (depth === void 0) {
      depth = 1;
    }

    invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");

    var _a = parseCSSVariable(current),
        token = _a[0],
        fallback = _a[1]; // No CSS variable detected


    if (!token) return; // Attempt to read this CSS variable off the element

    var resolved = window.getComputedStyle(element).getPropertyValue(token);

    if (resolved) {
      return resolved;
    } else if (isCSSVariable(fallback)) {
      // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
      return getVariableValue(fallback, element, depth + 1);
    } else {
      return fallback;
    }
  }
  /**
   * Resolve CSS variables from
   *
   * @internal
   */


  function resolveCSSVariables(values, ref, _a, transitionEnd) {
    var target = __rest(_a, []);

    var element = ref.current;
    if (!(element instanceof HTMLElement)) return {
      target: target,
      transitionEnd: transitionEnd
    }; // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.

    if (transitionEnd) {
      transitionEnd = _assign({}, transitionEnd);
    } // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved


    values.forEach(function (value) {
      var current = value.get();
      if (!isCSSVariable(current)) return;
      var resolved = getVariableValue(current, element);
      if (resolved) value.set(resolved);
    }); // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`

    for (var key in target) {
      var current = target[key];
      if (!isCSSVariable(current)) continue;
      var resolved = getVariableValue(current, element);
      if (!resolved) continue; // Clone target if it hasn't already been

      target[key] = resolved; // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
      // CSS variable. This will ensure that after the animation the component will reflect
      // changes in the value of the CSS variable.

      if (transitionEnd && transitionEnd[key] === undefined) {
        transitionEnd[key] = current;
      }
    }

    return {
      target: target,
      transitionEnd: transitionEnd
    };
  }

  var positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y"]);

  var isPositionalKey = function isPositionalKey(key) {
    return positionalKeys.has(key);
  };

  var hasPositionalKey = function hasPositionalKey(target) {
    return Object.keys(target).some(isPositionalKey);
  };

  var setAndResetVelocity = function setAndResetVelocity(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
  };

  var isNumOrPxType = function isNumOrPxType(v) {
    return v === number || v === px;
  };

  var BoundingBoxDimension;

  (function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
  })(BoundingBoxDimension || (BoundingBoxDimension = {}));

  var getPosFromMatrix = function getPosFromMatrix(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
  };

  var getTranslateFromMatrix = function getTranslateFromMatrix(pos2, pos3) {
    return function (_bbox, _a) {
      var transform = _a.transform;
      if (transform === "none" || !transform) return 0;
      var matrix3d = transform.match(/^matrix3d\((.+)\)$/);

      if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
      } else {
        var matrix = transform.match(/^matrix\((.+)\)$/);

        if (matrix) {
          return getPosFromMatrix(matrix[1], pos2);
        } else {
          return 0;
        }
      }
    };
  };

  var transformKeys = new Set(["x", "y", "z"]);
  var nonTranslationalTransformKeys = transformProps.filter(function (key) {
    return !transformKeys.has(key);
  });

  function removeNonTranslationalTransform(values, elementStyler) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function (key) {
      var value = values.get(key);

      if (value !== undefined) {
        removedTransforms.push([key, value.get()]);
        value.set(key.startsWith("scale") ? 1 : 0);
      }
    }); // Apply changes to element before measurement

    if (removedTransforms.length) elementStyler.render();
    return removedTransforms;
  }

  var positionalValues = {
    // Dimensions
    width: function width(_a) {
      var width = _a.width;
      return width;
    },
    height: function height(_a) {
      var height = _a.height;
      return height;
    },
    top: function top(_bbox, _a) {
      var top = _a.top;
      return parseFloat(top);
    },
    left: function left(_bbox, _a) {
      var left = _a.left;
      return parseFloat(left);
    },
    bottom: function bottom(_a, _b) {
      var height = _a.height;
      var top = _b.top;
      return parseFloat(top) + height;
    },
    right: function right(_a, _b) {
      var width = _a.width;
      var left = _b.left;
      return parseFloat(left) + width;
    },
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14)
  };

  var convertChangedValueTypes = function convertChangedValueTypes(target, values, element, elementStyler, changedKeys) {
    var originBbox = element.getBoundingClientRect();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display,
        top = elementComputedStyle.top,
        left = elementComputedStyle.left,
        bottom = elementComputedStyle.bottom,
        right = elementComputedStyle.right,
        transform = elementComputedStyle.transform;
    var originComputedStyle = {
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      transform: transform
    }; // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box

    if (display === "none") {
      elementStyler.set("display", target.display || "block");
    } // Apply the latest values (as set in checkAndConvertChangedValueTypes)


    elementStyler.render();
    var targetBbox = element.getBoundingClientRect();
    changedKeys.forEach(function (key) {
      // Restore styles to their **calculated computed style**, not their actual
      // originally set style. This allows us to animate between equivalent pixel units.
      var value = values.get(key);
      setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
      target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
  };

  var checkAndConvertChangedValueTypes = function checkAndConvertChangedValueTypes(values, ref, target, transitionEnd) {
    if (transitionEnd === void 0) {
      transitionEnd = {};
    }

    target = _assign({}, target);
    transitionEnd = _assign({}, transitionEnd);
    var element = ref.current;
    var elementStyler = index(element);
    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey); // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.

    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = targetPositionalKeys.reduce(function (acc, key) {
      var value = values.get(key);
      if (!value) return acc;
      var from = value.get();
      var to = target[key];
      var fromType = getDimensionValueType(from);
      var toType; // TODO: The current implementation of this basically throws an error
      // if you try and do value conversion via keyframes. There's probably
      // a way of doing this but the performance implications would need greater scrutiny,
      // as it'd be doing multiple resize-remeasure operations.

      if (isKeyframesTarget(to)) {
        var numKeyframes = to.length;

        for (var i = to[0] === null ? 1 : 0; i < numKeyframes; i++) {
          if (!toType) {
            toType = getDimensionValueType(to[i]);
            invariant(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
          } else {
            invariant(getDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
          }
        }
      } else {
        toType = getDimensionValueType(to);
      }

      if (fromType !== toType) {
        // If they're both just number or px, convert them both to numbers rather than
        // relying on resize/remeasure to convert (which is wasteful in this situation)
        if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
          var current = value.get();

          if (typeof current === "string") {
            value.set(parseFloat(current));
          }

          if (typeof to === "string") {
            target[key] = parseFloat(to);
          } else if (Array.isArray(to) && toType === px) {
            target[key] = to.map(parseFloat);
          }
        } else {
          // If we're going to do value conversion via DOM measurements, we first
          // need to remove non-positional transform values that could affect the bbox measurements.
          if (!hasAttemptedToRemoveTransformValues) {
            removedTransformValues = removeNonTranslationalTransform(values, elementStyler);
            hasAttemptedToRemoveTransformValues = true;
          }

          acc.push(key);
          transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
          setAndResetVelocity(value, to);
        }
      }

      return acc;
    }, []);

    if (changedValueTypeKeys.length) {
      var convertedTarget = convertChangedValueTypes(target, values, element, elementStyler, changedValueTypeKeys); // If we removed transform values, reapply them before the next render

      if (removedTransformValues.length) {
        removedTransformValues.forEach(function (_a) {
          var key = _a[0],
              value = _a[1];
          values.get(key).set(value);
        });
      } // Reapply original values


      elementStyler.render();
      return {
        target: convertedTarget,
        transitionEnd: transitionEnd
      };
    } else {
      return {
        target: target,
        transitionEnd: transitionEnd
      };
    }
  };
  /**
   * Convert value types for x/y/width/height/top/left/bottom/right
   *
   * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
   *
   * @param values
   * @param ref
   * @param target
   * @param transitionEnd
   * @internal
   */


  function unitConversion(values, ref, target, transitionEnd) {
    return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(values, ref, target, transitionEnd) : {
      target: target,
      transitionEnd: transitionEnd
    };
  }

  var parseDomVariant = function parseDomVariant(values, ref) {
    return function (target, transitionEnd) {
      var resolved = resolveCSSVariables(values, ref, target, transitionEnd);
      target = resolved.target;
      transitionEnd = resolved.transitionEnd;
      return unitConversion(values, ref, target, transitionEnd);
    };
  };

  function useForceUpdate() {
    var _a = React.useState(0),
        forcedRenderCount = _a[0],
        setForcedRenderCount = _a[1];

    return React.useCallback(function () {
      return setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
  }

  var SyncLayoutContext =
  /*#__PURE__*/
  React.createContext(null);

  var _a;

  var StepName;

  (function (StepName) {
    StepName["Prepare"] = "prepare";
    StepName["Read"] = "read";
    StepName["Render"] = "render";
  })(StepName || (StepName = {}));

  var stepOrder = [StepName.Prepare, StepName.Read, StepName.Render];
  var jobs = stepOrder.reduce(function (acc, key) {
    acc[key] = [];
    return acc;
  }, {});
  var jobsNeedProcessing = false;

  function flushCallbackList(list) {
    var numJobs = list.length;

    for (var i = 0; i < numJobs; i++) {
      list[i]();
    }

    list.length = 0;
  }

  function flushAllJobs() {
    if (!jobsNeedProcessing) return;
    flushCallbackList(jobs.prepare);
    flushCallbackList(jobs.read);
    flushCallbackList(jobs.render);
    jobsNeedProcessing = false;
  } // Note: The approach of schedulng jobs during the render step is incompatible with concurrent mode
  // where multiple renders might happen without a DOM update. This would result in unneccessary batched
  // jobs. But this was already a problem with our previous approach to positionTransition.
  // Hopefully the React team offer a getSnapshotBeforeUpdate-esque hook and we can move to that.


  var createUseSyncEffect = function createUseSyncEffect(stepName) {
    return function (callback) {
      if (!callback) return;
      jobsNeedProcessing = true;
      jobs[stepName].push(callback);
    };
  };

  var layoutSync = (_a = {}, _a[StepName.Prepare] = createUseSyncEffect(StepName.Prepare), _a[StepName.Read] = createUseSyncEffect(StepName.Read), _a[StepName.Render] = createUseSyncEffect(StepName.Render), _a.flush = flushAllJobs, _a);

  function isHTMLElement$1(element) {
    return element instanceof HTMLElement;
  }

  var defaultLayoutTransition = {
    duration: 0.8,
    ease: [0.45, 0.05, 0.19, 1.0]
  };
  var defaultPositionTransition = underDampedSpring();

  function getDefaultLayoutTransition(isPositionOnly) {
    return isPositionOnly ? defaultPositionTransition : defaultLayoutTransition;
  }

  function isResolver(transition) {
    return typeof transition === "function";
  }

  var axisLabels = {
    x: {
      id: "x",
      size: "width",
      min: "left",
      max: "right",
      origin: "originX"
    },
    y: {
      id: "y",
      size: "height",
      min: "top",
      max: "bottom",
      origin: "originY"
    }
  };

  function centerOf(min, max) {
    return (min + max) / 2;
  }

  function calcAxisDelta(prev, next, names) {
    var _a;

    var sizeDelta = prev[names.size] - next[names.size];
    var origin = 0.5; // If the element has changed size we want to check whether either side is in
    // the same position before/after the layout transition. If so, we can anchor
    // the element to that position and only animate its size.

    if (sizeDelta) {
      if (prev[names.min] === next[names.min]) {
        origin = 0;
      } else if (prev[names.max] === next[names.max]) {
        origin = 1;
      }
    }

    var delta = (_a = {}, _a[names.size] = sizeDelta, _a[names.origin] = origin, _a[names.id] = // Only measure a position delta if we haven't anchored to one side
    origin === 0.5 ? centerOf(prev[names.min], prev[names.max]) - centerOf(next[names.min], next[names.max]) : 0, _a);
    return delta;
  }

  function calcDelta(prev, next) {
    var delta = _assign(_assign({}, calcAxisDelta(prev, next, axisLabels.x)), calcAxisDelta(prev, next, axisLabels.y));

    return delta;
  }

  var offset = {
    getLayout: function getLayout(_a) {
      var offset = _a.offset;
      return offset;
    },
    measure: function measure(element) {
      var offsetLeft = element.offsetLeft,
          offsetTop = element.offsetTop,
          offsetWidth = element.offsetWidth,
          offsetHeight = element.offsetHeight;
      return {
        left: offsetLeft,
        top: offsetTop,
        right: offsetLeft + offsetWidth,
        bottom: offsetTop + offsetHeight,
        width: offsetWidth,
        height: offsetHeight
      };
    }
  };
  var boundingBox = {
    getLayout: function getLayout(_a) {
      var boundingBox = _a.boundingBox;
      return boundingBox;
    },
    measure: function measure(element) {
      var _a = element.getBoundingClientRect(),
          left = _a.left,
          top = _a.top,
          width = _a.width,
          height = _a.height,
          right = _a.right,
          bottom = _a.bottom;

      return {
        left: left,
        top: top,
        width: width,
        height: height,
        right: right,
        bottom: bottom
      };
    }
  };

  function readPositionStyle(element) {
    return window.getComputedStyle(element).position;
  }

  function getLayoutType(prev, next, isPositionOnly) {
    return isPositionOnly && prev === next ? offset : boundingBox;
  }

  function isSizeKey(key) {
    return key === "width" || key === "height";
  }

  function getTransition(_a) {
    var layoutTransition = _a.layoutTransition,
        positionTransition = _a.positionTransition;
    return layoutTransition || positionTransition;
  }

  var LayoutAnimation =
  /** @class */
  function (_super) {
    __extends(LayoutAnimation, _super);

    function LayoutAnimation() {
      return _super !== null && _super.apply(this, arguments) || this;
    } // Measure the current state of the DOM before it's updated, and schedule checks to see
    // if it's changed as a result of a React render.


    LayoutAnimation.prototype.getSnapshotBeforeUpdate = function () {
      var _a = this.props,
          innerRef = _a.innerRef,
          positionTransition = _a.positionTransition,
          values = _a.values,
          controls = _a.controls;
      var element = innerRef.current;
      if (!isHTMLElement$1(element)) return;
      var layoutTransition = getTransition(this.props);
      var isPositionOnly = !!positionTransition;
      var positionStyle = readPositionStyle(element);
      var prev = {
        offset: offset.measure(element),
        boundingBox: boundingBox.measure(element)
      };
      var transform;
      var next;
      var compare; // We split the unsetting, read and reapplication of the `transform` style prop into
      // different steps via useSyncEffect. Multiple components might all be doing the same
      // thing and by splitting these jobs and flushing them in batches we prevent layout thrashing.

      layoutSync.prepare(function () {
        // Unset the transform of all layoutTransition components so we can accurately measure
        // the target bounding box
        transform = element.style.transform;
        element.style.transform = "";
      });
      layoutSync.read(function () {
        // Read the target VisualInfo of all layoutTransition components
        next = {
          offset: offset.measure(element),
          boundingBox: boundingBox.measure(element)
        };
        var nextPosition = readPositionStyle(element);
        compare = getLayoutType(positionStyle, nextPosition, isPositionOnly);
      });
      layoutSync.render(function () {
        // Reverse the layout delta of all newly laid-out layoutTransition components into their
        // prev visual state and then animate them into their new one using transforms.
        var prevLayout = compare.getLayout(prev);
        var nextLayout = compare.getLayout(next);
        var delta = calcDelta(prevLayout, nextLayout);
        var hasAnyChanged = delta.x || delta.y || delta.width || delta.height;

        if (!hasAnyChanged) {
          // If layout hasn't changed, reapply the transform and get out of here.
          transform && (element.style.transform = transform);
          return;
        }

        index(element).set({
          originX: delta.originX,
          originY: delta.originY
        });
        syncRenderSession.open();
        var target = {};
        var transition = {};
        var transitionDefinition = isResolver(layoutTransition) ? layoutTransition({
          delta: delta
        }) : layoutTransition;

        function makeTransition(layoutKey, transformKey, targetValue, visualOrigin) {
          // If this dimension hasn't changed, early return
          var deltaKey = isSizeKey(layoutKey) ? layoutKey : transformKey;
          if (!delta[deltaKey]) return;
          var baseTransition = typeof transitionDefinition === "boolean" ? _assign({}, getDefaultLayoutTransition(isPositionOnly)) : transitionDefinition;
          var value = values.get(transformKey, targetValue);
          var velocity = value.getVelocity();
          transition[transformKey] = baseTransition[transformKey] ? _assign({}, baseTransition[transformKey]) : _assign({}, baseTransition);

          if (transition[transformKey].velocity === undefined) {
            transition[transformKey].velocity = velocity || 0;
          } // The target value of all transforms is the default value of that prop (ie x = 0, scaleX = 1)
          // This is because we're inverting the layout change with `transform` and then animating to `transform: none`


          target[transformKey] = targetValue;
          var offsetToApply = !isSizeKey(layoutKey) && compare === offset ? value.get() : 0;
          value.set(visualOrigin + offsetToApply);
        }

        makeTransition("left", "x", 0, delta.x);
        makeTransition("top", "y", 0, delta.y);

        if (!isPositionOnly) {
          makeTransition("width", "scaleX", 1, prev.boundingBox.width / next.boundingBox.width);
          makeTransition("height", "scaleY", 1, prev.boundingBox.height / next.boundingBox.height);
        }

        target.transition = transition; // Only start the transition if `transitionDefinition` isn't `false`. Otherwise we want
        // to leave the values in their newly-inverted state and let the user cope with the rest.

        transitionDefinition && controls.start(target); // Force a render to ensure there's no visual flickering

        syncRenderSession.flush();
      });
      return null;
    };

    LayoutAnimation.prototype.componentDidUpdate = function () {
      layoutSync.flush();
    };

    LayoutAnimation.prototype.render = function () {
      return null;
    };

    LayoutAnimation.contextType = SyncLayoutContext;
    return LayoutAnimation;
  }(React.Component);

  var Layout = {
    key: "layout",
    shouldRender: function shouldRender(_a) {
      var positionTransition = _a.positionTransition,
          layoutTransition = _a.layoutTransition;
      invariant(!(positionTransition && layoutTransition), "Don't set both positionTransition and layoutTransition on the same component");
      return typeof window !== "undefined" && !!(positionTransition || layoutTransition);
    },
    Component: LayoutAnimation
  };
  /**
   * A list of all valid MotionProps
   *
   * @internalremarks
   * This doesn't throw if a `MotionProp` name is missing - it should.
   */

  var validMotionProps = new Set(["initial", "animate", "exit", "style", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "static", "positionTransition", "layoutTransition", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onDirectionLock", "onDragTransitionEnd", "drag", "dragControls", "dragListener", "dragConstraints", "dragDirectionLock", "dragElastic", "dragMomentum", "dragPropagation", "dragTransition", "_dragValueX", "_dragValueY", "_dragTransitionControls", "dragOriginX", "dragOriginY", "onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileHover", "whileTap", "onHoverEnd", "onHoverStart"]);
  /**
   * Check whether a prop name is a valid `MotionProp` key.
   *
   * @param key - Name of the property to check
   * @returns `true` is key is a valid `MotionProp`.
   *
   * @public
   */

  function isValidMotionProp(key) {
    return validMotionProps.has(key);
  }

  var AnimatePropType;

  (function (AnimatePropType) {
    AnimatePropType["Target"] = "Target";
    AnimatePropType["VariantLabel"] = "VariantLabel";
    AnimatePropType["AnimationSubscription"] = "AnimationSubscription";
  })(AnimatePropType || (AnimatePropType = {}));

  function shallowCompare(next, prev) {
    if (prev === null) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;

    for (var i = 0; i < prevLength; i++) {
      if (prev[i] !== next[i]) return false;
    }

    return true;
  }

  var hasUpdated = function hasUpdated(prev, next) {
    return next !== undefined && (Array.isArray(prev) && Array.isArray(next) ? !shallowCompare(next, prev) : prev !== next);
  };

  function targetWithoutTransition(_a, mergeTransitionEnd) {
    if (mergeTransitionEnd === void 0) {
      mergeTransitionEnd = false;
    }

    var transition = _a.transition,
        transitionEnd = _a.transitionEnd,
        target = __rest(_a, ["transition", "transitionEnd"]);

    return mergeTransitionEnd ? _assign(_assign({}, target), transitionEnd) : target;
  }
  /**
   * Handle the `animate` prop when its an object of values, ie:
   *
   * ```jsx
   * <motion.div animate={{ opacity: 1 }} />
   * ```
   *
   * @internalremarks
   * It might be worth consolidating this with `use-variants`
   *
   * ```jsx
   * <motion.div animate="visible" />
   * ```
   *
   * @param target
   * @param controls
   * @param values
   * @param transition
   *
   * @internal
   */


  function useAnimateProp(targetAndTransition, controls, values, defaultTransition) {
    var isInitialRender = React.useRef(true);
    var prevValues = React.useRef(null);

    if (!prevValues.current) {
      prevValues.current = targetWithoutTransition(targetAndTransition, true);
    }

    React.useEffect(function () {
      var targetToAnimate = {}; // These are the values we're actually animating

      var animatingTarget = targetWithoutTransition(targetAndTransition); // This is the target as it'll be once transitionEnd values are applied

      var finalTarget = targetWithoutTransition(targetAndTransition, true); // Detect which values have changed between renders

      for (var key in animatingTarget) {
        // This value should animate on mount if this value doesn't already exist (wasn't
        // defined in `style` or `initial`) or if it does exist and it's already changed.
        var shouldAnimateOnMount = isInitialRender.current && (!values.has(key) || values.get(key).get() !== finalTarget[key]); // If this value has updated between renders or it's we're animating this value on mount,
        // add it to the animate target.

        var isValidValue = finalTarget[key] !== null;
        var valueHasUpdated = hasUpdated(prevValues.current[key], finalTarget[key]);

        if (isValidValue && (valueHasUpdated || shouldAnimateOnMount)) {
          targetToAnimate[key] = animatingTarget[key];
        }
      }

      isInitialRender.current = false;
      prevValues.current = _assign(_assign({}, prevValues.current), finalTarget);

      if (Object.keys(targetToAnimate).length) {
        controls.start(_assign(_assign({}, targetToAnimate), {
          transition: targetAndTransition.transition || defaultTransition,
          transitionEnd: targetAndTransition.transitionEnd
        }));
      }
    }, [targetAndTransition]);
  }

  var labelsToArray = function labelsToArray(label) {
    if (!label) {
      return [];
    }

    if (Array.isArray(label)) {
      return label;
    }

    return [label];
  };

  var resolveVariantLabels = function resolveVariantLabels(variant) {
    var unresolvedVariant = variant instanceof MotionValue ? variant.get() : variant;
    return Array.from(new Set(labelsToArray(unresolvedVariant)));
  };
  /**
   * Hooks in React sometimes accept a dependency array as their final argument. (ie useEffect/useMemo)
   * When values in this array change, React re-runs the dependency. However if the array
   * contains a variable number of items, React throws an error.
   */


  var asDependencyList = function asDependencyList(list) {
    return [list.join(",")];
  };

  var hasVariantChanged = function hasVariantChanged(oldVariant, newVariant) {
    return oldVariant.join(",") !== newVariant.join(",");
  };
  /**
   * Handle variants and the `animate` prop when its set as variant labels.
   *
   * @param initial - Initial variant(s)
   * @param animate - Variant(s) to animate to
   * @param inherit - `true` is inheriting animations from parent
   * @param controls - Animation controls
   *
   * @internal
   */


  function useVariants(initial, animate, inherit, controls) {
    var targetVariants = resolveVariantLabels(animate);
    var context = React.useContext(MotionContext);
    var parentAlreadyMounted = context.hasMounted && context.hasMounted.current;
    var hasMounted = React.useRef(false);
    React.useEffect(function () {
      var shouldAnimate = false;

      if (inherit) {
        // If we're inheriting variant changes and the parent has already
        // mounted when this component loads, we need to manually trigger
        // this animation.
        shouldAnimate = !!parentAlreadyMounted;
        targetVariants = resolveVariantLabels(context.animate);
      } else {
        shouldAnimate = hasMounted.current || hasVariantChanged(resolveVariantLabels(initial), targetVariants);
      }

      shouldAnimate && controls.start(targetVariants);
      hasMounted.current = true;
    }, asDependencyList(targetVariants));
  }
  /**
   * `useAnimationGroupSubscription` allows a component to subscribe to an
   * externally-created `AnimationControls`, created by the `useAnimation` hook.
   *
   * @param animation
   * @param controls
   *
   * @internal
   */


  function useAnimationGroupSubscription(animation, controls) {
    var unsubscribe = React.useMemo(function () {
      return animation.subscribe(controls);
    }, [animation]);
    React.useEffect(function () {
      return function () {
        unsubscribe && unsubscribe();
      };
    }, [unsubscribe]);
  }

  var _a$1, _b;

  var AnimatePropComponents = (_a$1 = {}, _a$1[AnimatePropType.Target] = makeRenderlessComponent(function (_a) {
    var animate = _a.animate,
        controls = _a.controls,
        values = _a.values,
        transition = _a.transition;
    return useAnimateProp(animate, controls, values, transition);
  }), _a$1[AnimatePropType.VariantLabel] = makeRenderlessComponent(function (_a) {
    var animate = _a.animate,
        _b = _a.inherit,
        inherit = _b === void 0 ? true : _b,
        controls = _a.controls,
        initial = _a.initial;
    return useVariants(initial, animate, inherit, controls);
  }), _a$1[AnimatePropType.AnimationSubscription] = makeRenderlessComponent(function (_a) {
    var animate = _a.animate,
        controls = _a.controls;
    return useAnimationGroupSubscription(animate, controls);
  }), _a$1);

  var isVariantLabel$1 = function isVariantLabel$1(prop) {
    return Array.isArray(prop) || typeof prop === "string";
  };

  var isAnimationSubscription = function isAnimationSubscription(_a) {
    var animate = _a.animate;
    return animate instanceof AnimationControls;
  };

  var animationProps = ["initial", "animate", "whileTap", "whileHover"];
  var animatePropTypeTests = (_b = {}, _b[AnimatePropType.Target] = function (props) {
    return props.animate !== undefined && !isVariantLabel$1(props.animate) && !isAnimationSubscription(props);
  }, _b[AnimatePropType.VariantLabel] = function (props) {
    return props.variants !== undefined || animationProps.some(function (key) {
      return typeof props[key] === "string";
    });
  }, _b[AnimatePropType.AnimationSubscription] = isAnimationSubscription, _b);

  var getAnimationComponent = function getAnimationComponent(props) {
    var animatePropType = undefined;

    for (var key in AnimatePropType) {
      if (animatePropTypeTests[key](props)) {
        animatePropType = key;
      }
    }

    return animatePropType ? AnimatePropComponents[animatePropType] : undefined;
  };
  /**
   * When a component is the child of `AnimatePresence`, it can use `usePresence`
   * to access information about whether it's still present in the React tree.
   *
   * ```jsx
   * import { usePresence } from "framer-motion"
   *
   * export const Component = () => {
   *   const [isPresent, safeToRemove] = usePresence()
   *
   *   useEffect(() => {
   *     !isPresent setTimeout(safeToRemove, 1000)
   *   }, [isPresent])
   *
   *   return <div />
   * }
   * ```
   *
   * If `isPresent` is `false`, it means that a component has been removed the tree, but
   * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
   *
   * @public
   */


  function usePresence() {
    var context = React.useContext(PresenceContext);
    if (context === null) return [true];
    var isPresent = context.isPresent,
        onExitComplete = context.onExitComplete,
        register = context.register;
    React.useEffect(register, []);
    return !isPresent && onExitComplete ? [false, onExitComplete] : [true];
  }

  var Exit = {
    key: "exit",
    shouldRender: function shouldRender(props) {
      return !!props.exit && !checkShouldInheritVariant(props);
    },
    Component: makeRenderlessComponent(function (props) {
      var _a;

      var animate = props.animate,
          controls = props.controls,
          exit = props.exit;

      var _b = usePresence(),
          isPresent = _b[0],
          onExitComplete = _b[1];

      var presenceContext = React.useContext(PresenceContext);
      var isPlayingExitAnimation = React.useRef(false);
      var custom = ((_a = presenceContext) === null || _a === void 0 ? void 0 : _a.custom) !== undefined ? presenceContext.custom : props.custom;
      React.useEffect(function () {
        if (!isPresent) {
          if (!isPlayingExitAnimation.current && exit) {
            controls.setProps(_assign(_assign({}, props), {
              custom: custom
            }));
            controls.start(exit).then(onExitComplete);
          }

          isPlayingExitAnimation.current = true;
        } else if (isPlayingExitAnimation.current && animate && !(animate instanceof AnimationControls)) {
          controls.start(animate);
        }

        if (isPresent) {
          isPlayingExitAnimation.current = false;
        }
      }, [isPresent]);
    })
  };

  var isPropValid = function isPropValid(key) {
    return !isValidMotionProp(key);
  };
  /**
   * Emotion and Styled Components both allow users to pass through arbitrary props to their components
   * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
   * of these should be passed to the underlying DOM node.
   *
   * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
   * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
   * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
   * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
   *
   * By making it an optionalDependency we can offer this functionality only in the situations where it's
   * actually required.
   */


  try {
    var emotionIsPropValid_1 = require("@emotion/is-prop-valid").default;

    isPropValid = function isPropValid(key) {
      // Handle events explicitly as Emotion validates them all as true
      if (key.startsWith("on")) {
        return !isValidMotionProp(key);
      } else {
        return emotionIsPropValid_1(key);
      }
    };
  } catch (_a) {// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
  }

  function filterValidProps(props) {
    var domProps = {};

    for (var key in props) {
      if (isPropValid(key)) {
        domProps[key] = props[key];
      }
    }

    return domProps;
  }

  var buildHTMLProps = function buildHTMLProps(values, style, isStatic, isDrag) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var props = {
      style: buildStyleAttr(values, style, isStatic)
    };

    if (isDrag) {
      // Disable text selection
      props.style.userSelect = "none"; // Disable the ghost element when a user drags

      props.draggable = false;
    }

    return props;
  };

  var buildSVGProps = function buildSVGProps(values, style) {
    var motionValueStyles = resolveCurrent(values);
    var props = buildSVGAttrs(motionValueStyles, undefined, undefined, undefined, undefined, false);
    props.style = _assign(_assign({}, style), props.style);
    return props;
  };

  var functionalityComponents = [Layout, Drag, Gestures, Exit];
  var numFunctionalityComponents = functionalityComponents.length;
  /**
   * Create a configuration for `motion` components that provides DOM-specific functionality.
   *
   * @internal
   */

  function createDomMotionConfig(Component) {
    var isDOM = typeof Component === "string";
    var isSVG = isDOM && svgElements.indexOf(Component) !== -1;
    return {
      renderComponent: function renderComponent(ref, style, values, props, isStatic) {
        var forwardedProps = isDOM ? filterValidProps(props) : props;
        var staticVisualStyles = isSVG ? buildSVGProps(values, style) : buildHTMLProps(values, style, isStatic, !!props.drag);
        return (
          /*#__PURE__*/
          React.createElement(Component, _assign(_assign(_assign({}, forwardedProps), {
            ref: ref
          }), staticVisualStyles))
        );
      },

      /**
       * loadFunctionalityComponents gets used by the `motion` component
       *
       * Each functionality component gets provided the `ref`, animation controls and the `MotionValuesMap`
       * generated for that component, as well as all the `props` passed to it by the user.
       *
       * The pattern used to determine whether to load and use each piece of functionality is
       * consistent (should render? Then push component) and could be used to extend functionality.
       *
       * By exposing a mutable piece of memory via an API like `extendMotionComponent` we could
       * allow users to add `FunctionalComponentDefinition`s. This would allow us to offer file size
       * reductions by shipping an entry point that doesn't load gesture and drag functionality, and
       * also offer a way for users to develop plugins/other functionality. Because these functionalities
       * are loaded as components, we can look into using Suspense for this purpose.
       *
       * For user-defined functionality we'd need to allow
       *  1) User-defined prop typing (extending `P`)
       *  2) User-defined "clean props" function that removes their plugin's props before being passed to the DOM.
       */
      loadFunctionalityComponents: function loadFunctionalityComponents(ref, values, props, context, controls, inherit) {
        var activeComponents = []; // TODO: Consolidate Animation functionality loading strategy with other functionality components

        var Animation = getAnimationComponent(props);

        if (Animation) {
          activeComponents.push(
          /*#__PURE__*/
          React.createElement(Animation, {
            key: "animation",
            initial: props.initial,
            animate: props.animate,
            variants: props.variants,
            transition: props.transition,
            controls: controls,
            inherit: inherit,
            values: values
          }));
        }

        for (var i = 0; i < numFunctionalityComponents; i++) {
          var _a = functionalityComponents[i],
              shouldRender = _a.shouldRender,
              key = _a.key,
              Component_1 = _a.Component;

          if (shouldRender(props, context)) {
            activeComponents.push(
            /*#__PURE__*/
            React.createElement(Component_1, _assign({
              key: key
            }, props, {
              parentContext: context,
              values: values,
              controls: controls,
              innerRef: ref
            })));
          }
        }

        return activeComponents;
      },
      getValueControlsConfig: function getValueControlsConfig(ref, values) {
        return {
          values: values,
          readValueFromSource: function readValueFromSource(key) {
            return index(ref.current).get(key);
          },
          // TODO: This is a good second source of plugins. This function contains the CSS variable
          // and unit conversion support. These functions share a common signature. We could make another
          // API for adding these.
          makeTargetAnimatable: parseDomVariant(values, ref)
        };
      }
    };
  }

  var htmlMotionComponents = htmlElements.reduce(function (acc, Component) {
    var config = createDomMotionConfig(Component); // Suppress "Expression produces a union type that is too complex to represent" error
    // @ts-ignore

    acc[Component] = createMotionComponent(config);
    return acc;
  }, {});
  var svgMotionComponents = svgElements.reduce(function (acc, Component) {
    // Suppress "Expression produces a union type that is too complex to represent" error
    // @ts-ignore
    acc[Component] = createMotionComponent(createDomMotionConfig(Component));
    return acc;
  }, {});
  /**
   * HTML & SVG components, optimised for use with gestures and animation. These can be used as
   * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
   *
   * @internalremarks
   *
   * I'd like to make it possible for these to be loaded "on demand" - to reduce bundle size by only
   * including HTML/SVG stylers, animation and/or gesture support when necessary.
   *
   * ```jsx
   * <motion.div animate={{ x: 100 }} />
   *
   * <motion.p animate={{ height: 200 }} />
   *
   * <svg><motion.circle r={10} animate={{ r: 20 }} /></svg>
   * ```
   *
   * @public
   */

  var motion = _assign(_assign({
    /**
     * Convert a custom React component into a `motion` component.
     *
     * It can also accept a string, to create [custom DOM elements](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements).
     *
     * ```jsx
     * const Component = React.forwardRef((props: Props, ref) => {
     *   return <div ref={ref} />
     * })
     *
     * const MotionComponent = motion.custom<Props>(Component)
     * ```
     *
     * @param Component -
     */
    custom: function custom(Component) {
      return createMotionComponent(createDomMotionConfig(Component));
    }
  }, htmlMotionComponents), svgMotionComponents);

  function createScrollMotionValues() {
    return {
      scrollX: motionValue(0),
      scrollY: motionValue(0),
      scrollXProgress: motionValue(0),
      scrollYProgress: motionValue(0)
    };
  }

  var viewportScrollValues = createScrollMotionValues();

  var PresenceChild = function PresenceChild(_a) {
    var children = _a.children,
        initial = _a.initial,
        isPresent = _a.isPresent,
        _onExitComplete = _a.onExitComplete,
        custom = _a.custom;
    var numPresenceChildren = React.useRef(0);
    var numExitComplete = React.useRef(0);
    var context = {
      initial: initial,
      isPresent: isPresent,
      custom: custom,
      onExitComplete: function onExitComplete() {
        numExitComplete.current++;
        var allComplete = numExitComplete.current >= numPresenceChildren.current;
        _onExitComplete && allComplete && _onExitComplete();
      }
    };
    var register = React.useMemo(function () {
      numExitComplete.current = 0;
      return function () {
        numPresenceChildren.current++;
        return function () {
          return numPresenceChildren.current--;
        };
      };
    }, [isPresent]);
    return (
      /*#__PURE__*/
      React.createElement(PresenceContext.Provider, {
        value: _assign(_assign({}, context), {
          register: register
        })
      }, children)
    );
  };

  function getChildKey(child) {
    return child.key || "";
  }

  function updateChildLookup(children, allChildren) {
    var seenChildren = process.env.NODE_ENV !== "production" ? new Set() : null;
    children.forEach(function (child) {
      var key = getChildKey(child);

      if (process.env.NODE_ENV !== "production" && seenChildren) {
        if (seenChildren.has(key)) {
          console.warn("Children of AnimatePresence require unique keys. \"" + key + "\" is a duplicate.");
        }

        seenChildren.add(key);
      }

      allChildren.set(key, child);
    });
  }

  function onlyElements(children) {
    var filtered = []; // We use forEach here instead of map as map mutates the component key by preprending `.$`

    React.Children.forEach(children, function (child) {
      if (
      /*#__PURE__*/
      React.isValidElement(child)) filtered.push(child);
    });
    return filtered;
  }
  /**
   * `AnimatePresence` enables the animation of components that have been removed from the tree.
   *
   * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
   *
   * @library
   *
   * Any `Frame` components that have an `exit` property defined will animate out when removed from
   * the tree.
   *
   * ```jsx
   * import { Frame, AnimatePresence } from 'framer'
   *
   * // As items are added and removed from `items`
   * export function Items({ items }) {
   *   return (
   *     <AnimatePresence>
   *       {items.map(item => (
   *         <Frame
   *           key={item.id}
   *           initial={{ opacity: 0 }}
   *           animate={{ opacity: 1 }}
   *           exit={{ opacity: 0 }}
   *         />
   *       ))}
   *     </AnimatePresence>
   *   )
   * }
   * ```
   *
   * You can sequence exit animations throughout a tree using variants.
   *
   * @motion
   *
   * Any `motion` components that have an `exit` property defined will animate out when removed from
   * the tree.
   *
   * ```jsx
   * import { motion, AnimatePresence } from 'framer-motion'
   *
   * export const Items = ({ items }) => (
   *   <AnimatePresence>
   *     {items.map(item => (
   *       <motion.div
   *         key={item.id}
   *         initial={{ opacity: 0 }}
   *         animate={{ opacity: 1 }}
   *         exit={{ opacity: 0 }}
   *       />
   *     ))}
   *   </AnimatePresence>
   * )
   * ```
   *
   * You can sequence exit animations throughout a tree using variants.
   *
   * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
   * once all `motion` components have finished animating out. Likewise, any components using
   * `usePresence` all need to call `safeToRemove`.
   *
   * @public
   */


  var AnimatePresence = function AnimatePresence(_a) {
    var children = _a.children,
        custom = _a.custom,
        _b = _a.initial,
        initial = _b === void 0 ? true : _b,
        onExitComplete = _a.onExitComplete,
        exitBeforeEnter = _a.exitBeforeEnter; // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceUpdate function, or one from a parent context if it exists.

    var localForceUpdate = useForceUpdate();
    var contextForceUpdate = React.useContext(SyncLayoutContext);
    var forceUpdate = contextForceUpdate || localForceUpdate;
    var isInitialRender = React.useRef(true); // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key

    var filteredChildren = onlyElements(children); // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting

    var presentChildren = React.useRef(filteredChildren); // A lookup table to quickly reference components by key

    var allChildren = React.useRef(new Map()).current; // A living record of all currently exiting components.

    var exiting = React.useRef(new Set()).current;
    updateChildLookup(filteredChildren, allChildren); // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null, filteredChildren.map(function (child) {
          return (
            /*#__PURE__*/
            React.createElement(PresenceChild, {
              key: getChildKey(child),
              isPresent: true,
              initial: initial ? undefined : false
            }, child)
          );
        }))
      );
    } // If this is a subsequent render, deal with entering and exiting children


    var childrenToRender = __spreadArrays(filteredChildren); // Diff the keys of the currently-present and target children to update our
    // exiting list.


    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey); // Diff the present children with our target children and mark those that are exiting

    var numPresent = presentKeys.length;

    for (var i = 0; i < numPresent; i++) {
      var key = presentKeys[i];

      if (targetKeys.indexOf(key) === -1) {
        exiting.add(key);
      } else {
        // In case this key has re-entered, remove from the exiting list
        exiting.delete(key);
      }
    } // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array


    if (exitBeforeEnter && exiting.size) {
      childrenToRender = [];
    } // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.


    exiting.forEach(function (key) {
      // If this component is actually entering again, early return
      if (targetKeys.indexOf(key) !== -1) return;
      var child = allChildren.get(key);
      if (!child) return;
      var insertionIndex = presentKeys.indexOf(key);

      var onExit = function onExit() {
        exiting.delete(key); // Remove this child from the present children

        var removeIndex = presentChildren.current.findIndex(function (child) {
          return child.key === key;
        });
        presentChildren.current.splice(removeIndex, 1); // Defer re-rendering until all exiting children have indeed left

        if (!exiting.size) {
          presentChildren.current = filteredChildren;
          forceUpdate();
          onExitComplete && onExitComplete();
        }
      };

      childrenToRender.splice(insertionIndex, 0,
      /*#__PURE__*/
      React.createElement(PresenceChild, {
        key: getChildKey(child),
        isPresent: false,
        onExitComplete: onExit,
        custom: custom
      }, child));
    }); // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders

    childrenToRender = childrenToRender.map(function (child) {
      var key = child.key;
      return exiting.has(key) ? child :
      /*#__PURE__*/
      React.createElement(PresenceChild, {
        key: getChildKey(child),
        isPresent: true
      }, child);
    });
    presentChildren.current = childrenToRender;

    if (process.env.NODE_ENV !== "production" && exitBeforeEnter && childrenToRender.length > 1) {
      console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    }

    return (
      /*#__PURE__*/
      React.createElement(React.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function (child) {
        return (
          /*#__PURE__*/
          React.cloneElement(child)
        );
      }))
    );
  }; // Does this device prefer reduced motion? Returns `null` server-side.


  var prefersReducedMotion = motionValue(null);

  if (typeof window !== "undefined") {
    if (window.matchMedia) {
      var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");

      var setReducedMotionPreferences = function setReducedMotionPreferences() {
        return prefersReducedMotion.set(motionMediaQuery_1.matches);
      };

      motionMediaQuery_1.addListener(setReducedMotionPreferences);
      setReducedMotionPreferences();
    } else {
      prefersReducedMotion.set(false);
    }
  }

  var FieldGroupContext =
  /*#__PURE__*/
  React__default.createContext();

  var FieldGroup = function FieldGroup(_ref36) {
    var fields = _ref36.fields,
        children = _ref36.children,
        values = _ref36.values,
        animate = _ref36.animate;

    if (animate) {
      var orderedFields = fields.sort(function (field1, field2) {
        // Order the fields so that hidden fields come first.
        // This way we can avoid blank fields during progressive reveal
        // Basically return -1 for ordering the first compared element to lower index and 1 for reverse.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
        if (field1.type === 'hidden') {
          return -1;
        }

        if (field2.type === 'hidden') {
          return 1;
        }
      });
      var fieldsWithValues = orderedFields.filter(function (_ref37) {
        var name = _ref37.name;
        return values[name];
      });
      var lastFieldWithValue = fieldsWithValues[fieldsWithValues.length - 1];
      var lastFieldWithValueIndex = fieldsWithValues.findIndex(function (_ref38) {
        var name = _ref38.name;
        return name === lastFieldWithValue.name;
      }) || 0;
      var newFields = lastFieldWithValueIndex < fields.length - 1 ? [fields[lastFieldWithValueIndex + 1]] : [];
      var fieldsToShow = [].concat(_toConsumableArray(fieldsWithValues), newFields);
      return (
        /*#__PURE__*/
        React__default.createElement(FieldGroupContext.Provider, {
          value: {
            shouldAnimate: true
          }
        },
        /*#__PURE__*/
        React__default.createElement(AnimatePresence, {
          initial: false
        }, fieldsToShow.map(function (field) {
          return children(field);
        })))
      );
    } else {
      return (
        /*#__PURE__*/
        React__default.createElement(FieldGroupContext.Provider, {
          value: {
            shouldAnimate: false
          }
        }, fields.map(function (field) {
          return children(field);
        }))
      );
    }
  };

  var SmallText = styled__default(typography.Paragraph)(_templateObject40());
  var BaseFieldWrapper = styled__default(layout.Box)(_templateObject41(), function (props) {
    return props.theme.grid.lg;
  });
  var Wrapper$7 = styled__default(layout.Box)(_templateObject42(), function (props) {
    return props.alignItems ? props.alignItems : 'center';
  });
  var StyledSup = styled__default.sup(_templateObject43(), function (props) {
    return "".concat(theme.getColor(props.labelSuperColor || 'error', props.theme));
  });
  var variantChild = {
    open: {
      y: 0,
      opacity: 1,
      transition: {
        y: {
          stiffness: 1000,
          velocity: -100
        }
      }
    },
    closed: {
      y: 50,
      opacity: 0,
      transition: {
        y: {
          stiffness: 1000
        }
      }
    }
  };
  var variants = {
    open: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.08
      }
    },
    closed: {
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1
      }
    }
  };
  var variantChildLast = {
    open: {
      opacity: 1
    },
    closed: {
      opacity: 0
    }
  };

  var AnimateableWrapper = function AnimateableWrapper(_ref39) {
    var children = _ref39.children,
        animateProps = _objectWithoutProperties(_ref39, ["children"]);

    var fieldGroupContext = React__default.useContext(FieldGroupContext);
    var shouldAnimate = fieldGroupContext ? fieldGroupContext.shouldAnimate : false;

    if (shouldAnimate) {
      return (
        /*#__PURE__*/
        React__default.createElement(motion.div, animateProps, children)
      );
    } else {
      return children;
    }
  };

  var BaseField = function BaseField(props) {
    var _React__default$useSt41 = React__default.useState(false),
        _React__default$useSt42 = _slicedToArray(_React__default$useSt41, 2),
        focused = _React__default$useSt42[0],
        setFocused = _React__default$useSt42[1];

    var _React__default$useSt43 = React__default.useState(false),
        _React__default$useSt44 = _slicedToArray(_React__default$useSt43, 2),
        waiting = _React__default$useSt44[0],
        setWaiting = _React__default$useSt44[1];

    var toggleFocused = function toggleFocused(e) {
      setFocused(!focused);

      if (!focused && typeof props.onFocus === 'function') {
        props.onFocus(e);
      }

      if (focused && typeof props.onBlur === 'function') {
        props.onBlur(e);
      }
    };

    var _React__default$useSt45 = React__default.useState(true),
        _React__default$useSt46 = _slicedToArray(_React__default$useSt45, 2),
        closed = _React__default$useSt46[0],
        setClosed = _React__default$useSt46[1];

    React__default.useEffect(function () {
      // The purpose of this is to allow the field to mount
      // in a hidden state and then begin it's animation
      var timeout = setTimeout(function () {
        return setClosed(false);
      }, 100);
      return function () {
        return clearInterval(timeout);
      };
    }, []);

    var toggleWaiting = function toggleWaiting() {
      setWaiting(!waiting);
    };

    var label = props.label,
        description = props.description,
        labelSuper = props.labelSuper,
        labelSuperColor = props.labelSuperColor,
        hint = props.hint,
        helper = props.helper,
        error = props.error;
    var Input = getFieldComponent(props.type, props.config);

    var _iv = props.initialValue,
        inputProps = _objectWithoutProperties(props, ["initialValue"]);

    return props.type !== 'hidden' ?
    /*#__PURE__*/
    React__default.createElement(BaseFieldWrapper, {
      mb: 10,
      className: props.className
    },
    /*#__PURE__*/
    React__default.createElement(AnimateableWrapper, {
      initial: false,
      animate: closed ? 'closed' : 'open',
      exit: {
        opacity: 0
      }
    },
    /*#__PURE__*/
    React__default.createElement(AnimateableWrapper, {
      variants: variants
    },
    /*#__PURE__*/
    React__default.createElement(AnimateableWrapper, {
      variants: variantChild
    }, props.config.renderLabel ? props.config.renderLabel({
      name: props.name,
      label: label,
      labelSuper: labelSuper,
      description: description,
      helper: helper
    }) :
    /*#__PURE__*/
    React__default.createElement(Wrapper$7, {
      alignItems: "flex-end"
    },
    /*#__PURE__*/
    React__default.createElement(React__default.Fragment, null,
    /*#__PURE__*/
    React__default.createElement(layout.Box, null,
    /*#__PURE__*/
    React__default.createElement(typography.Label, {
      font: "serif",
      htmlFor: props.name
    }, label,
    /*#__PURE__*/
    React__default.createElement(StyledSup, {
      labelSuperColor: labelSuperColor
    }, labelSuper)),
    /*#__PURE__*/
    React__default.createElement(SmallText, null, description)),
    /*#__PURE__*/
    React__default.createElement(SmallText, null, helper)))),
    /*#__PURE__*/
    React__default.createElement(AnimateableWrapper, {
      variants: variantChild
    },
    /*#__PURE__*/
    React__default.createElement(Input, _extends({}, inputProps, {
      showErrorColor: !focused && error,
      id: "".concat(props.name),
      value: inputProps.value,
      defaultValue: props.defaultValue,
      onFocus: toggleFocused,
      onBlur: toggleFocused,
      onWaiting: toggleWaiting
    }))),
    /*#__PURE__*/
    React__default.createElement(AnimateableWrapper, {
      variants: variantChildLast
    },
    /*#__PURE__*/
    React__default.createElement(Wrapper$7, {
      style: {
        minHeight: '15px'
      },
      className: props.config && props.config.validator === 'requiredRadioTerms' ? 'radioTermWrapper' : ''
    },
    /*#__PURE__*/
    React__default.createElement(SmallText, null, hint),
    /*#__PURE__*/
    React__default.createElement(SmallText, {
      "data-testid": "fieldError",
      color: !focused && error ? 'error' : 'text'
    }, error || waiting)))))) :
    /*#__PURE__*/
    React__default.createElement(Input, _extends({}, inputProps, {
      id: "".concat(props.name)
    }));
  };

  var inputHtmlProps = {
    autoComplete: PropTypes.oneOf(['off', 'on', 'new-password']),
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.oneOf(['text', 'tel', 'radio', 'password', 'checkbox', 'hidden' //'month',
    ]).isRequired
  };
  BaseField.propTypes = _objectSpread({}, inputHtmlProps, {
    label: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    config: PropTypes.shape({
      component: PropTypes.string,
      validator: PropTypes.string,
      showYear: PropTypes.bool
    })
  }); // istanbul ignore file

  var maskValidator = function maskValidator(regex, fieldName) {
    return Yup.string().required('Required').min(maskPatterns[regex].length, 'Not enough characters').test('matches-mask', "Invalid ".concat(fieldName), function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var matches = _toConsumableArray(value).every(function (char, index) {
        var pattern = maskPatterns[regex][index];

        try {
          return char.match(new RegExp(pattern));
        } catch (e) {
          return pattern === char;
        }
      });

      return matches;
    });
  };

  var minimumCharsValidator = function minimumCharsValidator(min) {
    return Yup.string().required('Required').min(min, "Must be at least ".concat(min, " characters"));
  };

  var lessThanValidator = function lessThanValidator(val, message) {
    return Yup.number().required('Required').lessThan(val + 1, message);
  };

  var valueMatchValidator = function valueMatchValidator(regexStr, message) {
    if (typeof regexStr === 'function') {
      return regexStr();
    } else {
      var re = new RegExp(regexStr);
      return Yup.string().required('Required').matches(re, message);
    }
  }; // 4 Digit AU Postcode Validation


  var postcodeValidator = Yup.string().required('Required').matches(/^[0-9]{4}(,\s*)([A-Za-z]+(?:\s[A-Za-z]+)*)$/, 'Please select postcode and suburb from the dropdown list'); // 5 Digit US Zipcode Validation

  var zipcodeValidator = Yup.string().required('Required').matches(/^[0-9]{5}(,\s*)([A-Za-z]+(?:\s[A-Za-z]+)*)$/, 'Please select zipcode and city from the dropdown list'); // IE County Validation

  var countyValidator = Yup.string().required('Required').matches(/[A-Za-z]+/, 'Please select county from the dropdown list');
  var monthValidator = Yup.string().required('Required').matches(/^(January|February|March|April|May|June|July|August|September|October|November|December)$/, 'Please select month from the dropdown');
  var monthButtonGroupValidator = Yup.string().required('Required').matches(/[A-Za-z0-9]+/, 'Please select a month or other options');
  var monthYearValidator = Yup.string().required('Required').matches(/^[A-Za-z]{3},\s([0-9]{4})$/, 'Please select month and year from the dropdown');
  var requiredValidator = Yup.string().required('Required');
  var requiredRadioValidator = Yup.string().required('Please select an option');
  var requiredRadioTermsValidator = Yup.string().required('Tick to agree to terms above');
  var emailValidator = Yup.string().email('Invalid email address').required('Required');

  var passwordConfirmValidator = function passwordConfirmValidator() {
    var passwordFieldValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return Yup.string().required('Confirm password is required').oneOf([passwordFieldValue, null], "Passwords don't match");
  };

  var dropdownValidator = function dropdownValidator(options) {
    return Yup.string().oneOf(options, 'Please select from the dropdown list').required('Required');
  };

  var passwordComplexityValidator = Yup.string().required('Required').min(8, 'Password is too short - should be 8 chars minimum').matches(/[a-zA-Z]/, 'Password should contain a letter').matches(/[0-9]/, 'Password should contain a number');

  var rangeArr = function rangeArr(start, end) {
    return Array(end - start + 1).fill().map(function (_, idx) {
      return (start + idx).toString();
    });
  };

  var lifeInsuranceAgeDropdownValidator = function lifeInsuranceAgeDropdownValidator() {
    var minAge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
    var maxAge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 69;
    return Yup.string().oneOf(rangeArr(minAge, maxAge), "Sorry, but you must be between ".concat(minAge, " and ").concat(maxAge, " years old to be eligible for this offer.")).required('Required');
  };

  var yearRangeValidator = function yearRangeValidator() {
    var minYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1930;
    var maxYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2007;
    var minAge = new Date().getFullYear() - maxYear;
    var maxAge = new Date().getFullYear() - minYear;
    return Yup.string().oneOf(rangeArr(minYear, maxYear), "Sorry, but you must be between ".concat(minAge, " and ").concat(maxAge, " years old"));
  };

  var validatorMap = {
    maskValidator: maskValidator,
    requiredValidator: requiredValidator,
    requiredRadioValidator: requiredRadioValidator,
    requiredRadioTermsValidator: requiredRadioTermsValidator,
    emailValidator: emailValidator,
    passwordConfirmValidator: passwordConfirmValidator,
    passwordComplexityValidator: passwordComplexityValidator,
    lifeInsuranceAgeDropdownValidator: lifeInsuranceAgeDropdownValidator,
    zipcodeValidator: zipcodeValidator,
    postcodeValidator: postcodeValidator,
    countyValidator: countyValidator,
    dropdownValidator: dropdownValidator,
    yearRangeValidator: yearRangeValidator,
    lessThanValidator: lessThanValidator,
    monthValidator: monthValidator,
    monthButtonGroupValidator: monthButtonGroupValidator,
    monthYearValidator: monthYearValidator,
    minimumCharsValidator: minimumCharsValidator,
    valueMatchValidator: valueMatchValidator
  };

  var getSchema = function getSchema(fields) {
    var validationSchema = {};
    fields.filter(function (_ref40) {
      var validator = _ref40.config.validator;
      return validator;
    }).forEach(function (_ref41) {
      var name = _ref41.name,
          _ref41$config = _ref41.config,
          validator = _ref41$config.validator,
          validatorArgs = _ref41$config.validatorArgs;
      validationSchema[name] = validatorArgs ? validatorMap["".concat(validator, "Validator")].apply(validatorMap, _toConsumableArray(validatorArgs)) : validatorMap["".concat(validator, "Validator")];
    });
    return Yup.object().shape(validationSchema);
  };

  var getInitialValues = function getInitialValues(fields) {
    var initialValues = {};
    fields.forEach(function (_ref42) {
      var name = _ref42.name,
          initialValue = _ref42.initialValue;
      initialValues[name] = initialValue || '';
    });
    return initialValues;
  };

  var setupForm = function setupForm(fields) {
    return {
      validationSchema: getSchema(fields),
      initialValues: getInitialValues(fields)
    };
  };

  var getFieldErrors = function getFieldErrors(rest, field) {
    var errors = rest.errors,
        touched = rest.touched;

    if (errors[field.name] && touched[field.name]) {
      // Prints out which fields fail validation.
      // console.log(field.name);
      // console.log(errors[field.name]);
      return errors[field.name];
    }

    return false;
  };

  var FormContext =
  /*#__PURE__*/
  React__default.createContext();

  var FormError =
  /*#__PURE__*/
  function (_Error) {
    _inherits(FormError, _Error);

    function FormError(object) {
      var _getPrototypeOf2;

      var _this2;

      _classCallCheck(this, FormError);

      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      _this2 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormError)).call.apply(_getPrototypeOf2, [this].concat(params)));
      _this2.object = object;
      return _this2;
    }

    return FormError;
  }(_wrapNativeSuper(Error));

  var getFormValues = function getFormValues(fields) {
    var values = {};
    fields.map(function (field) {
      values[field.name] = field.value;
    });
    return values;
  };

  var FooterBox = styled__default(layout.Box)(_templateObject44(), function (props) {
    return props.centeredSubmit ? 'center' : 'flex-end';
  });

  var Form = function Form(_ref43) {
    var onSubmit = _ref43.onSubmit,
        quickSubmit = _ref43.quickSubmit,
        autoSearch = _ref43.autoSearch,
        dynamicFields = _ref43.dynamicFields,
        getNewestFieldValue = _ref43.getNewestFieldValue,
        providedFields = _ref43.fields,
        TURN_OFF_AUTOCOMPLETE = _ref43.TURN_OFF_AUTOCOMPLETE,
        id = _ref43.id,
        FormListener = _ref43.FormListener,
        props = _objectWithoutProperties(_ref43, ["onSubmit", "quickSubmit", "autoSearch", "dynamicFields", "getNewestFieldValue", "fields", "TURN_OFF_AUTOCOMPLETE", "id", "FormListener"]);

    var _React__default$useSt47 = React__default.useState(providedFields),
        _React__default$useSt48 = _slicedToArray(_React__default$useSt47, 2),
        fields = _React__default$useSt48[0],
        setFields = _React__default$useSt48[1]; // istanbul ignore if


    if (dynamicFields) {
      React.useEffect(function () {
        setFields(providedFields);
        return function () {
          dynamicFields = false;
        };
      }, [providedFields]);
    }

    var _React__default$useSt49 = React__default.useState({
      formError: props.formError || null,
      fieldErrors: props.fieldErrors || {}
    }),
        _React__default$useSt50 = _slicedToArray(_React__default$useSt49, 2),
        serverErrors = _React__default$useSt50[0],
        setServerErrors = _React__default$useSt50[1];

    var _setupForm = setupForm(fields),
        validationSchema = _setupForm.validationSchema,
        initialValues = _setupForm.initialValues;

    var context = React__default.useContext(FormContext) || {};

    var submitWrapper =
    /*#__PURE__*/
    function () {
      var _ref44 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _len2,
            args,
            _key2,
            submitValues,
            formikBag,
            fieldsWithValues,
            response,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                // Undo server errors
                setServerErrors({
                  formError: '',
                  fieldErrors: {}
                });

                for (_len2 = _args3.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args3[_key2];
                }

                submitValues = args[0], formikBag = args[1];
                fieldsWithValues = fields.map(function (field) {
                  return _objectSpread({}, field, {
                    value: submitValues[field.name]
                  });
                });
                _context3.next = 7;
                return onSubmit(fieldsWithValues, context);

              case 7:
                response = _context3.sent;

                if (!Array.isArray(response)) {
                  _context3.next = 12;
                  break;
                }

                setFields(response);
                _context3.next = 13;
                break;

              case 12:
                throw new FormError({
                  formError: 'Something went wrong',
                  fieldErrors: {}
                });

              case 13:
                formikBag.setSubmitting(false);

                if (!(typeof props.onSuccess === 'function')) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 17;
                return props.onSuccess({
                  id: id,
                  values: getFormValues(response)
                });

              case 17:
                _context3.next = 22;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](0);
                setServerErrors(_context3.t0.object);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 19]]);
      }));

      return function submitWrapper() {
        return _ref44.apply(this, arguments);
      };
    }(); // NOTE: Autosubmit has some quirks, we don't have much of
    // an ability to autosubmit text fields as they can possibly
    // be any length - for now we're only supporting fields with
    // explicity use 'setFieldValue', that's because we know when
    // that function is called the value will be 100% complete
    // this feels like a hack and can probably be improved with some
    // field-level autosearch settings.


    var autoSubmit = function autoSubmit() {
      var submitNode = document.getElementById("hidden-submit-".concat(id));

      if (submitNode) {
        submitNode.click();
      }
    }; // Pass these values straight through with no submission


    React__default.useEffect(function () {
      if (props.passThru) {
        validationSchema.isValid(initialValues).then(function (valid) {
          if (valid) {
            props.onSuccess({
              id: id,
              values: initialValues
            });
          }
        });
      }

      return function () {
        props.passThru = false;
      };
    }, []);

    var handleTurnOffAutoComplete = function handleTurnOffAutoComplete() {
      if (TURN_OFF_AUTOCOMPLETE) {
        return 'off';
      } // If this function returns null/undefined
      // the HTML property "autocomplete" isn't applied

    };

    return (
      /*#__PURE__*/
      React__default.createElement(formik.Formik, {
        initialValues: initialValues,
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: submitWrapper
      }, function (formikProps) {
        var handleSubmit = formikProps.handleSubmit,
            zisSubmitting = formikProps.zisSubmitting,
            validateForm = formikProps.validateForm,
            isValidating = formikProps.isValidating,
            handleChange = formikProps.handleChange,
            rest = _objectWithoutProperties(formikProps, ["handleSubmit", "zisSubmitting", "validateForm", "isValidating", "handleChange"]);

        var fieldUtils = {
          setFieldValue: function setFieldValue(field, value) {
            // filter out field's error message from server errors.
            var fieldErrors = Object.keys(serverErrors.fieldErrors).reduce(function (obj, key) {
              if (key !== field) {
                // istanbul ignore next
                return _objectSpread({}, obj, _defineProperty({}, key, serverErrors.fieldErrors[key]));
              }

              return obj;
            }, {}); // update server errors message

            setServerErrors({
              formError: serverErrors.formError,
              fieldErrors: fieldErrors
            });
            rest.setFieldValue(field, value); // istanbul ignore next

            getNewestFieldValue && typeof getNewestFieldValue == 'function' && getNewestFieldValue(field, value);
            (autoSearch || quickSubmit) && validateForm().then(function () {
              autoSubmit();
            });
          },
          setFieldTouched: rest.setFieldTouched,
          setFieldError: rest.setFieldError
        };
        return (
          /*#__PURE__*/
          React__default.createElement("form", {
            onSubmit: handleSubmit,
            autoComplete: handleTurnOffAutoComplete()
          },
          /*#__PURE__*/
          React__default.createElement("button", {
            type: "submit",
            hidden: true,
            id: "hidden-submit-".concat(id)
          }),
          /*#__PURE__*/
          React__default.createElement(FieldGroup, {
            fields: fields,
            values: rest.values,
            animate: props.progressiveReveal
          }, function (field) {
            return (
              /*#__PURE__*/
              React__default.createElement(BaseField, _extends({
                key: field.name,
                fieldUtils: fieldUtils
              }, field, {
                value: rest.values[field.name],
                onChange: handleChange,
                error: serverErrors.fieldErrors[field.name] || !autoSearch && getFieldErrors(rest, field)
              }))
            );
          }), typeof props.renderFooter === 'function' ? props.renderFooter({
            formError: serverErrors.formError
          }) : props.renderFooter || !quickSubmit &&
          /*#__PURE__*/
          React__default.createElement(FooterBox, {
            centeredSubmit: props.centeredSubmit
          },
          /*#__PURE__*/
          React__default.createElement(layout.Box, {
            style: {
              display: 'flex',
              flexDirection: 'column'
            }
          },
          /*#__PURE__*/
          React__default.createElement(layout.Box, {
            mb: 10,
            style: {
              display: 'flex',
              alignSelf: 'flex-end'
            }
          },
          /*#__PURE__*/
          React__default.createElement(button.Button, {
            align: "center",
            "data-testid": "submit-".concat(id),
            type: "submit"
          }, rest.submitText || 'Submit')),
          /*#__PURE__*/
          React__default.createElement(layout.Box, {
            style: {
              height: '12px',
              display: 'flex',
              alignSelf: 'flex-end'
            }
          },
          /*#__PURE__*/
          React__default.createElement(typography.Small, {
            align: "left",
            color: "error"
          }, serverErrors.formError)))), FormListener &&
          /*#__PURE__*/
          React__default.createElement(FormListener, null))
        );
      })
    );
  };

  Form.propTypes = {
    id: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, BaseField.propTypes)))
  };

  var StepForm = function StepForm(_ref45) {
    var steps = _ref45.steps,
        props = _objectWithoutProperties(_ref45, ["steps"]);

    var _React__default$useSt51 = React__default.useState(steps[0].id),
        _React__default$useSt52 = _slicedToArray(_React__default$useSt51, 2),
        activeFormId = _React__default$useSt52[0],
        setActiveFormId = _React__default$useSt52[1];

    var _React__default$useSt53 = React__default.useState({}),
        _React__default$useSt54 = _slicedToArray(_React__default$useSt53, 2),
        values = _React__default$useSt54[0],
        setValues = _React__default$useSt54[1];

    var formIds = steps.map(function (_ref46) {
      var id = _ref46.id;
      return id;
    });
    return (
      /*#__PURE__*/
      React__default.createElement(FormContext.Provider, {
        value: values
      }, props.children({
        activeFormId: activeFormId,
        forms: steps.map(function (form, index) {
          return props.renderForm(_objectSpread({}, form, {
            onSuccess: function onSuccess(_ref47) {
              var id = _ref47.id,
                  submittedValues = _ref47.values;

              var newValues = _objectSpread({}, values, _defineProperty({}, id, submittedValues));

              var nextFormId = formIds[formIds.indexOf(id) + 1];
              setActiveFormId(nextFormId);
              setValues(newValues);

              if (index === steps.length - 1) {
                props.onFinalSuccess && props.onFinalSuccess({
                  values: newValues
                });
              } else {
                props.onEachSuccess && props.onEachSuccess({
                  values: newValues,
                  nextFormId: nextFormId
                });
              }
            }
          }));
        })
      }))
    );
  };

  StepForm.propTypes = {
    /** An array of Forms */
    steps: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, Form.propTypes))),
    children: PropTypes.func,
    renderForm: PropTypes.func
  };
  var Div = styled__default(layout.Box)(_templateObject45(), function (props) {
    return props.hide ? 'hidden' : 'visible';
  }, function (props) {
    return props.hide ? 0 : 'auto';
  });

  var appendOrRemove = function appendOrRemove(array, item) {
    return array.includes(item) ? array.filter(function (arrayItem) {
      return arrayItem !== item;
    }) : [].concat(_toConsumableArray(array), [item]);
  };

  var Accordion = function Accordion(props) {
    var _React__default$useSt55 = React__default.useState([]),
        _React__default$useSt56 = _slicedToArray(_React__default$useSt55, 2),
        openItems = _React__default$useSt56[0],
        setOpenItems = _React__default$useSt56[1];

    var setIt = function setIt(openItems, id) {
      var res = props.setOpenItems(openItems, id);
      setOpenItems(appendOrRemove.apply(void 0, _toConsumableArray(res)));
    };

    React__default.useEffect(function () {
      setIt(openItems, props.activeItem);
    }, [props.activeItem]);

    var showHeader = function showHeader(itemId) {
      if (props.items[0].id === itemId) {
        return true;
      }

      return props.hideInactiveHeaders && openItems.includes(itemId);
    };

    return props.items.map(function (item) {
      return (
        /*#__PURE__*/
        React__default.createElement(layout.Box, {
          key: item.id,
          id: "form-container-".concat(item.id)
        }, showHeader(item.id) && props.itemHeader({
          item: item
        }), openItems.includes(item.id) ?
        /*#__PURE__*/
        React__default.createElement(Div, null, props.itemBody(_objectSpread({}, item, {
          visible: true
        }))) :
        /*#__PURE__*/
        React__default.createElement(Div, {
          hide: true
        }, props.itemBody(_objectSpread({}, item, {
          visible: false
        }))))
      );
    });
  };

  Accordion.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.any
    }).isRequired),
    variant: PropTypes.string,
    renderItem: PropTypes.func
  };
  Accordion.defaulProps = {
    // setOpenItems: (openItemId, openingItemId) => [openItemId, openingItemId],
    canControlExpansion: true,
    initialOpenItems: []
  };
  var validatorMap$1 = {
    maskValidator: maskValidator,
    requiredValidator: requiredValidator,
    requiredRadioValidator: requiredRadioValidator,
    requiredRadioTermsValidator: requiredRadioTermsValidator,
    emailValidator: emailValidator,
    passwordConfirmValidator: passwordConfirmValidator,
    passwordComplexityValidator: passwordComplexityValidator,
    monthButtonGroupValidator: monthButtonGroupValidator,
    zipcodeValidator: zipcodeValidator,
    postcodeValidator: postcodeValidator,
    countyValidator: countyValidator,
    dropdownValidator: dropdownValidator,
    minimumCharsValidator: minimumCharsValidator,
    valueMatchValidator: valueMatchValidator
  };
  /**
   *
   *
   * Helpers
   *
   *
   */

  var getFieldMachine = function getFieldMachine(machineName, field) {
    var machineMap = {
      text: textMachine,
      radio: radioMachine,
      check: radioMachine
    };
    var context = field;
    var machine = machineMap[machineName]; // If we have a radio field with only one value
    // we can skip to it's validation step

    if (machineName === 'radio' && field.options.length === 1) {
      context = _objectSpread({}, field, {
        value: field.options[0].value,
        type: 'hidden'
      });
      machine = _objectSpread({}, machine, {
        states: _objectSpread({}, machine.states, {
          completion: _objectSpread({}, machine.states.completion, {
            initial: 'complete' // move to complete

          }),
          validity: _objectSpread({}, machine.states.validity, {
            initial: 'validating' // this will trigger the field group submission

          })
        })
      });
    }

    return _objectSpread({}, machine, {
      id: field.name,
      context: context
    });
  };

  var getFieldValues = function getFieldValues(fields) {
    var submissionObject = {};
    fields.map(function (_ref48) {
      var machine = _ref48.machine;
      var _machine$state$contex = machine.state.context,
          name = _machine$state$contex.name,
          value = _machine$state$contex.value;
      submissionObject[name] = value;
    });
    return submissionObject;
  };
  /**
   *
   *
   * Field machine logic
   *
   *
   */


  var fieldConfig = {
    actions: {
      change: xstate.assign({
        value: function value(_, event) {
          return event.value;
        },
        validatorArgs: function validatorArgs(_, event) {
          return event.validatorArgs;
        },
        validator: function validator(_, event) {
          return event.validator;
        }
      }),
      assignValidatorArgs: xstate.assign({
        validatorArgs: function validatorArgs(_, event) {
          return event.validatorArgs;
        },
        validator: function validator(_, event) {
          return event.validator;
        }
      }),
      assignError: xstate.assign({
        error: function error(_, event) {
          return event.data.message;
        }
      }),
      removeError: xstate.assign({
        error: null
      }),
      notifyParentTouched: xstate.sendParent(function (context) {
        return {
          type: 'fieldTouched',
          data: context
        };
      }),
      notifyParentComplete: xstate.sendParent(function (context) {
        return {
          type: 'fieldComplete',
          data: context
        };
      }),
      notifyParentIncomplete: xstate.sendParent(function (context) {
        return {
          type: 'fieldIncomplete',
          data: context
        };
      }),
      notifyParentUnknown: xstate.sendParent(function () {
        return {
          type: 'fieldUnknown'
        };
      }),
      notifyParentInvalid: xstate.sendParent(function () {
        return {
          type: 'fieldInvalid'
        };
      }),
      notifyParentValid: xstate.sendParent(function (context) {
        return {
          type: 'fieldValid',
          data: context
        };
      })
    },
    guards: {
      hasValue: function hasValue(context) {
        return !!context.value;
      },
      autoValidateValues: function autoValidateValues(context) {
        return !!context.value && !!context.autoValidate;
      }
    },
    services: {
      validateField: function () {
        var _validateField = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4(context) {
          var validatorArgs, validator;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  validatorArgs = context.validatorArgs;
                  validator = context.validator;

                  if (!context.config.validate_if) {
                    _context4.next = 13;
                    break;
                  }

                  if (!validatorArgs) {
                    _context4.next = 8;
                    break;
                  }

                  _context4.next = 6;
                  return validatorMap$1["".concat(validator, "Validator")].apply(validatorMap$1, _toConsumableArray(validatorArgs)).validate(context.value);

                case 6:
                  _context4.next = 11;
                  break;

                case 8:
                  if (!validator) {
                    _context4.next = 11;
                    break;
                  }

                  _context4.next = 11;
                  return validatorMap$1["".concat(validator, "Validator")].validate(context.value);

                case 11:
                  _context4.next = 21;
                  break;

                case 13:
                  if (!context.config.validatorArgs) {
                    _context4.next = 18;
                    break;
                  }

                  _context4.next = 16;
                  return validatorMap$1["".concat(context.config.validator, "Validator")].apply(validatorMap$1, _toConsumableArray(validatorArgs)).validate(context.value);

                case 16:
                  _context4.next = 21;
                  break;

                case 18:
                  if (!context.config.validator) {
                    _context4.next = 21;
                    break;
                  }

                  _context4.next = 21;
                  return validatorMap$1["".concat(context.config.validator, "Validator")].validate(context.value);

                case 21:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function validateField(_x2) {
          return _validateField.apply(this, arguments);
        }

        return validateField;
      }()
    }
  };
  var textMachine = {
    type: 'parallel',
    states: {
      focus: {
        initial: 'idle',
        states: {
          idle: {
            on: {
              change: {
                actions: ['change', 'assignValidatorArgs', 'removeError'],
                target: 'touched'
              }
            }
          },
          touched: {
            on: {
              change: {
                actions: ['change', 'assignValidatorArgs', 'removeError']
              }
            }
          }
        }
      },
      completion: {
        initial: 'unknown',
        states: {
          unknown: {
            on: {
              '': [{
                target: 'complete',
                cond: 'autoValidateValues'
              }, {
                target: 'idle'
              }]
            }
          },
          idle: {
            entry: 'notifyParentIncomplete',
            on: {
              complete: 'complete'
            }
          },
          complete: {
            entry: 'notifyParentComplete',
            on: {
              change: 'idle'
            }
          }
        }
      },
      validity: {
        initial: 'unknown',
        states: {
          unknown: {
            on: {
              '': [{
                target: 'validating',
                cond: 'autoValidateValues'
              }, {
                target: 'idle'
              }]
            }
          },
          idle: {
            on: {
              validate: 'validating'
            }
          },
          validating: {
            entry: ['assignValidatorArgs'],
            invoke: {
              src: 'validateField',
              onDone: 'valid',
              onError: {
                target: 'invalid',
                actions: 'assignError'
              }
            }
          },
          invalid: {
            entry: ['notifyParentInvalid'],
            on: {
              change: 'unknown',
              validate: 'validating'
            }
          },
          valid: {
            entry: ['notifyParentValid', 'removeError'],
            on: {
              change: 'unknown',
              validate: 'validating'
            }
          }
        }
      }
    }
  };
  var radioMachine = {
    type: 'parallel',
    states: {
      focus: {
        initial: 'idle',
        states: {
          idle: {
            on: {
              change: {
                actions: ['change', 'assignValidatorArgs', 'removeError'],
                target: 'touched'
              }
            }
          },
          touched: {
            entry: 'notifyParentTouched',
            on: {
              change: {
                actions: ['change', 'assignValidatorArgs', 'removeError']
              }
            }
          }
        }
      },
      completion: {
        initial: 'idle',
        states: {
          idle: {
            entry: 'notifyParentIncomplete',
            on: {
              change: 'complete'
            }
          },
          complete: {
            entry: 'notifyParentComplete',
            on: {
              change: {
                actions: 'notifyParentIncomplete'
              }
            }
          }
        }
      },
      validity: {
        initial: 'unknown',
        states: {
          unknown: {
            on: {
              '': [{
                target: 'validating',
                cond: 'autoValidateValues'
              }, {
                target: 'idle'
              }]
            }
          },
          idle: {
            on: {
              validate: 'validating'
            }
          },
          validating: {
            entry: ['assignValidatorArgs'],
            invoke: {
              src: 'validateField',
              onDone: 'valid',
              onError: {
                target: 'invalid',
                actions: 'assignError'
              }
            }
          },
          invalid: {
            entry: ['notifyParentInvalid'],
            on: {
              change: 'unknown',
              validate: 'validating'
            }
          },
          valid: {
            entry: ['notifyParentValid', 'removeError'],
            on: {
              change: 'unknown',
              validate: 'validating'
            }
          }
        }
      }
    }
  };
  /**
   *
   *
   * Field group machine logic
   *
   *
   */

  var fieldGroupConfig = {
    actions: {
      assignNext: xstate.assign({
        nextMachine: function nextMachine(context, event) {
          var name = event.data.fields.map(function (_ref49) {
            var name = _ref49.name;
            return name;
          }).join('-'); // NOTE: This check allows us to preserve a machine that's
          // already been spawned. There's probably a better way to do this
          // but right now the thought is that we only want to preserve
          // child machines when we know it wont change, so if we have
          // context.nextFn we can't be sure it wouldn't change so we
          // need to spawn again - which will wipe out it's values

          if (context.nextMachine && context.next) {
            return context.nextMachine;
          }

          return xstate.spawn(xstate.Machine(fieldGroupMachineConfig(context.options), fieldGroupConfig).withContext(_objectSpread({}, event.data, {
            options: context.options
          })), "group-".concat(name));
        }
      }),
      sendRequestToSubmit: xstate.send('parentRequestSubmitting', {
        to: function to(context) {
          return context.nextMachine;
        }
      }),
      spawn: xstate.assign({
        fields: function fields(context, event) {
          return context.fields.map(function (field) {
            return _objectSpread({}, field, {
              machine: field.machine ? field.machine : xstate.spawn(xstate.Machine(getFieldMachine(field.config.machine, field), _objectSpread({}, fieldConfig, {
                sync: true
              })), "field-".concat(field.name))
            });
          });
        }
      }),
      notifyParentSubmitting: xstate.sendParent(function (context, event) {
        var submissionObject = {};
        context.fields.map(function (_ref50) {
          var machine = _ref50.machine;
          var _machine$state$contex2 = machine.state.context,
              name = _machine$state$contex2.name,
              value = _machine$state$contex2.value;
          submissionObject[name] = value;
        });
        return {
          type: 'bubble',
          data: _objectSpread({}, event.data, submissionObject)
        };
      })
    },
    guards: {
      allFieldsComplete: function allFieldsComplete(context, event) {
        return context.fields.map(function (_ref51) {
          var machine = _ref51.machine;
          return machine.state;
        }).every(function (state) {
          return state.matches('completion.complete');
        });
      },
      allFieldsValid: function allFieldsValid(context, event) {
        return context.fields.map(function (_ref52) {
          var machine = _ref52.machine;
          return machine.state;
        }).every(function (state) {
          return state.matches('validity.valid');
        });
      }
    },
    services: {
      getNextFieldGroup: function () {
        var _getNextFieldGroup = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5(context) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!context.onSubmit) {
                    _context5.next = 3;
                    break;
                  }

                  _context5.next = 3;
                  return context.onSubmit(getFieldValues(context.fields));

                case 3:
                  _context5.prev = 3;

                  if (!context.nextFn) {
                    _context5.next = 6;
                    break;
                  }

                  return _context5.abrupt("return", context.nextFn(context.fields.map(function (_ref53) {
                    var machine = _ref53.machine;
                    return machine.state.context;
                  })));

                case 6:
                  if (!context.next) {
                    _context5.next = 8;
                    break;
                  }

                  return _context5.abrupt("return", context.next);

                case 8:
                  _context5.next = 13;
                  break;

                case 10:
                  _context5.prev = 10;
                  _context5.t0 = _context5["catch"](3);
                  console.error('xform error: ', _context5.t0);

                case 13:
                  throw new Error('No next fields defined, should submit instead');

                case 14:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[3, 10]]);
        }));

        function getNextFieldGroup(_x3) {
          return _getNextFieldGroup.apply(this, arguments);
        }

        return getNextFieldGroup;
      }()
    }
  };

  var fieldGroupMachineConfig = function fieldGroupMachineConfig(options) {
    return {
      initial: 'init',
      states: {
        init: {
          on: {
            '': {
              target: 'notReady',
              actions: 'spawn'
            }
          }
        },
        notReady: {
          id: 'notReady',
          on: {
            submit: 'validating',
            fieldComplete: options.autoComplete ? {
              target: 'validating',
              cond: 'allFieldsComplete'
            } : {}
          }
        },
        validating: {
          id: 'validating',
          on: {
            fieldInvalid: {
              target: 'notReady'
            },
            fieldValid: {
              target: 'invoking',
              cond: 'allFieldsValid'
            }
          }
        },
        invoking: {
          invoke: {
            src: 'getNextFieldGroup',
            onDone: {
              target: 'groupReady.passThru',
              actions: 'assignNext'
            },
            onError: {
              target: 'groupReady.submitter'
            }
          }
        },
        groupReady: {
          on: {
            fieldIncomplete: options.autoComplete ? 'validating' : 'notReady'
          },
          states: {
            passThru: {
              entry: 'sendRequestToSubmit',
              on: {
                parentRequestSubmitting: {
                  actions: 'sendRequestToSubmit'
                },
                bubble: {
                  actions: 'notifyParentSubmitting'
                },
                fieldTouched: '#validating',
                submit: '#validating'
              }
            },
            submitter: {
              entry: 'notifyParentSubmitting',
              on: {
                parentRequestSubmitting: {
                  actions: 'notifyParentSubmitting'
                }
              }
            }
          }
        }
      }
    };
  };
  /**
   *
   *
   * Form machine logic
   *
   *
   */


  var formConfig = {
    actions: {
      // "Attempted to spawn an Actor" warning is tracked here
      // https://github.com/davidkpiano/xstate/issues/757
      assignInitialFieldGroup: xstate.assign({
        nextMachine: function nextMachine(context) {
          var name = context.next.context.fields.map(function (_ref54) {
            var name = _ref54.name;
            return name;
          }).join('-');
          return xstate.spawn(xstate.Machine(_objectSpread({}, context.next, {
            id: "group-".concat(name)
          }), fieldGroupConfig), "group-".concat(name));
        }
      })
    }
  };
  var formMachine = {
    initial: 'idle',
    states: {
      idle: {
        entry: 'assignInitialFieldGroup',
        on: {
          '': 'formReady'
        }
      },
      formReady: {
        on: {
          bubble: {
            target: 'submitting'
          }
        }
      },
      submitting: {
        invoke: {
          src: function () {
            var _src = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee6(context, event) {
              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return context.onSubmit(event.data);

                    case 2:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }));

            function src(_x4, _x5) {
              return _src.apply(this, arguments);
            }

            return src;
          }(),
          onDone: 'formReady',
          onError: 'formReady'
        }
      }
    }
  };
  /**
   *
   *
   * Hooks
   *
   *
   */

  var useField = function useField(machine, groupIsValidating) {
    var fieldValidator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _react$useService = react.useService(machine),
        _react$useService2 = _slicedToArray(_react$useService, 2),
        state = _react$useService2[0],
        send = _react$useService2[1];

    var validator = fieldValidator.validator,
        validatorArgs = fieldValidator.validatorArgs;
    React__default.useEffect(function () {
      if (groupIsValidating) {
        validatorArgs ? send({
          type: 'validate',
          validator: validator,
          validatorArgs: validatorArgs
        }) : send({
          type: 'validate',
          validator: validator
        });
      }
    }, [groupIsValidating, send]);
    return {
      context: state ? state.context : {},
      send: send
    };
  };

  var useInitialFieldValue = function useInitialFieldValue(field, value) {
    var _react$useService3 = react.useService(field.machine),
        _react$useService4 = _slicedToArray(_react$useService3, 2),
        _state = _react$useService4[0],
        send = _react$useService4[1];

    React__default.useEffect(function () {
      send({
        type: 'change',
        value: value
      });
    }, [value, send]);
    return {};
  };

  var useFieldGroup = function useFieldGroup(service) {
    var _react$useService5 = react.useService(service),
        _react$useService6 = _slicedToArray(_react$useService5, 2),
        state = _react$useService6[0],
        send = _react$useService6[1];

    var _React__default$useSt57 = React__default.useState(false),
        _React__default$useSt58 = _slicedToArray(_React__default$useSt57, 2),
        groupIsValidating = _React__default$useSt58[0],
        setGroupIsValidating = _React__default$useSt58[1];

    React__default.useEffect(function () {
      if (state && state.matches('validating')) {
        setGroupIsValidating(true);
      } else {
        setGroupIsValidating(false);
      }
    }, [state]);
    return {
      fields: state ? state.context.fields : [],
      nextMachine: state ? state.context.nextMachine : null,
      groupIsValidating: groupIsValidating,
      send: send,
      state: state
    };
  };

  var useForm = function useForm(_ref55) {
    var onSubmit = _ref55.onSubmit,
        options = _ref55.options,
        form = _ref55.form;

    var _react$useMachine = react.useMachine(xstate.Machine(formMachine, formConfig).withContext({
      onSubmit: onSubmit,
      options: options,
      fieldOptions: form.fieldOptions,
      submitText: form.submitText,
      next: _objectSpread({}, fieldGroupMachineConfig(options), {
        context: _objectSpread({}, form, {
          options: options
        })
      })
    })),
        _react$useMachine2 = _slicedToArray(_react$useMachine, 1),
        state = _react$useMachine2[0];

    if (!state) {
      return {
        formState: undefined,
        fieldGroupMachine: undefined
      };
    }

    if (!state.context.nextMachine.hasOwnProperty('machine')) {
      return {
        formState: undefined,
        fieldGroupMachine: undefined
      };
    }

    return {
      formState: state,
      fieldGroupMachine: state.context.nextMachine
    };
  };
  /**
   *
   *
   * Components
   *
   *
   */


  var Field = function Field(_ref56) {
    var groupIsValidating = _ref56.groupIsValidating,
        machine = _ref56.machine;

    var _useField = useField(machine, groupIsValidating),
        context = _useField.context,
        send = _useField.send;

    return (
      /*#__PURE__*/
      React__default.createElement(BaseField, _extends({}, context, {
        fieldUtils: {
          setFieldValue: function setFieldValue(_name, value) {
            send({
              type: 'change',
              value: value
            });
          }
        },
        onBlur: function onBlur() {
          send("complete");
        },
        onChange: function onChange(e) {
          send({
            type: 'change',
            value: e.target.value
          });
        },
        error: context.error
      }))
    );
  };

  var FieldGroup$1 = function FieldGroup$1(_ref57) {
    var service = _ref57.service;

    var _useFieldGroup = useFieldGroup(service),
        fields = _useFieldGroup.fields,
        nextMachine = _useFieldGroup.nextMachine,
        groupIsValidating = _useFieldGroup.groupIsValidating;

    return (
      /*#__PURE__*/
      React__default.createElement(React__default.Fragment, null, fields.map(function (field) {
        return (
          /*#__PURE__*/
          React__default.createElement(Field, {
            key: field.name,
            groupIsValidating: groupIsValidating,
            machine: field.machine
          })
        );
      }), nextMachine &&
      /*#__PURE__*/
      React__default.createElement(FieldGroup$1, {
        service: nextMachine
      }))
    );
  };

  var Xform = function Xform(props) {
    var _useForm = useForm(props),
        fieldGroupMachine = _useForm.fieldGroupMachine;

    return (
      /*#__PURE__*/
      React__default.createElement(React__default.Fragment, null, fieldGroupMachine &&
      /*#__PURE__*/
      React__default.createElement(FieldGroup$1, {
        service: fieldGroupMachine
      }))
    );
  };

  exports.Accordion = Accordion;
  exports.BaseField = BaseField;
  exports.Field = Field;
  exports.FieldGroup = FieldGroup$1;
  exports.Form = Form;
  exports.FormError = FormError;
  exports.MonthButtonGroupField = MonthButtonGroupField;
  exports.MonthField = MonthField;
  exports.StepForm = StepForm;
  exports.Xform = Xform;
  exports.YearField = YearField;
  exports.getFormValues = getFormValues;
  exports.useField = useField;
  exports.useFieldGroup = useFieldGroup;
  exports.useForm = useForm;
  exports.useInitialFieldValue = useInitialFieldValue;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});